export const translations = {
  en: {
    // Navigation
    nav: {
      allStores: 'All Stores',
      addStore: 'Add Store',
      billings: 'Billings',
      accounts: 'Accounts',
      support: 'Support',
      profile: 'Profile',
      signOut: 'Sign Out',
      selectStore: 'Select Store',
      adminOrders: 'Admin: Orders',
      adminSupport: 'Admin: Support',
      adminBillings: 'Billings',
      findReturnByShk: 'Find return by barcode',
      enterAsClient: 'Enter as client',
      createSuperuser: 'Create superadmin',
      exitImpersonation: 'Exit to my account',
      goodsOnSale: 'Goods on sale',
      adminWbReturns: 'WB: All returns',
      adminConsole: 'Analytics',
      adminReports: 'Reports',
      highlightStores: 'Highlight by store',
      notifications: 'Notifications',
    },
    adminConsole: {
      title: 'Console',
      subtitle: 'Run server-side audit commands (superuser). Output matches manage.py.',
      storeIdOptional: 'WB store_id (optional)',
      storeIdPlaceholder: 'All stores if empty',
      cmdAuditSnapshot: 'audit_order_snapshot_mismatches (summary)',
      running: 'Running…',
      clear: 'Clear output',
      outputTitle: 'Output',
      outputEmpty: 'Run a command to see output here.',
      runFailed: 'Command failed',
      elapsed: 'Completed in {{ms}} ms',
    },
    adminReports: {
      title: 'Reports',
      store: 'Store (optional)',
      storePlaceholder: 'All stores — search by ID or name…',
      week: 'Week',
      pvz: 'PVZ',
      pvzAll: 'All PVZ',
      pvzOur: 'All our PVZ',
      pvzShosseynaya: 'Shosseynaya 4k3',
      pvzProezd: 'Proezd 3723',
      apply: 'Apply',
      loadError: 'Failed to load report.',
      exportError: 'Export failed.',
      pulseTitle: 'Warehouse pulse',
      pulseLoading: 'Loading warehouse pulse…',
      refreshPulse: 'Refresh pulse',
      pulseAccepted: 'Total accepted returns',
      pulseTotalDebt: 'Total debt',
      pulseTotalDebtHint: 'Issued (WB) but no receipt billing',
      pulseDebt72h: 'Debt (72h)',
      pulseDebt72hHint: 'Issued in the last 72 hours without receipt billing',
      pulseTopUps: 'Top-ups (all time)',
      pulseCharges: 'Charges',
      pulseActiveUsers: 'Active users (96h)',
      pulseSupport: 'Support messages (24h)',
      pulseErrors: 'Failed tasks (24h)',
      pulseErrorsHint: 'Celery failures; HTTP 500 in Graylog/Sentry',
      techLoad: 'Load avg',
      techMem: 'Process memory',
      downloadErrorsLog: 'Download error log',
      weekCardTitle: 'Weekly report',
      weeklyFiltersTitle: 'Weekly report filters',
      dailyTitle: 'By day',
      metricReceipts: 'Receipts billed',
      metricWbReceived: 'Received (WB completedDt)',
      metricAvgAccept: 'Avg acceptance time',
      sectionUsers: 'Users & stores',
      newUsers: 'New users',
      usersLoggedIn: 'Logged in',
      newStores: 'New stores',
      avgDailyLogins: 'Avg daily logins',
      unregisteredWb: 'WB stores without registration',
      unregisteredWbHint: 'Orders in last 96h without Store.store_id',
      sectionBilling: 'Billing',
      billingWeekHint: 'Top-ups and charges for the selected week only (by billing date or created_at if empty).',
      topUps: 'Top-ups',
      charges: 'Charges',
      debtors: 'Debtors',
      chargeType: 'Charge type',
      colStore: 'Store',
      colDebt: 'Debt',
      colLastPayment: 'Last payment',
      totalDebt: 'Total debt',
      sectionProblems: 'Problems & anomalies',
      anomalyAcceptBefore: 'Acceptance before WB issue',
      noReceiptCompleted: 'Completed but no receipt',
      completed72h: '>72h completed, not accepted',
      acceptedInTransit: 'Accepted but status in transit',
      issuedTitle: 'Issued goods',
      dateFrom: 'From',
      dateTo: 'To',
      loadIssued: 'Load table',
      refreshIssued: 'Refresh',
      exportExcel: 'Download Excel',
      exportExcelShort: 'Excel',
      issuedSearch: 'Search',
      issuedSearchPlaceholder: 'srid, barcode, store, product…',
      issuedEmpty: 'No issued goods for the selected filters.',
      pageOf: 'Page {{page}} of {{total}}',
      prevPage: 'Previous',
      nextPage: 'Next',
      debtorsTopHint: 'Top {{n}} debtors shown ({{total}} total)',
      topStoresShown: 'top {{n}} shown',
      pulsePartialError: 'Debt metrics unavailable',
      returnsSource: 'Return type',
      returnsSourceAll: 'All',
      returnsSourceForeign: 'Foreign',
      returnsSourceInternal: 'Internal',
      acceptStatusFilter: 'Acceptance status',
      acceptStatusAll: 'Any',
      acceptStatusYes: 'Accepted',
      acceptStatusNo: 'Not accepted',
      datesOptional: 'Dates optional — empty loads all issued goods',
      reportLoading: 'Loading weekly report…',
      rows: 'rows',
      colAccept: 'Receipt status',
      colProduct: 'Product',
      colBarcode: 'Barcode',
      colDeliveryAddress: 'Delivery address',
      colStatus: 'Status',
    },
    notifications: {
      empty: 'No notifications',
      markRead: 'Got it',
      languageLabel: 'Display language',
      apiTokenTitle: 'API key check failed',
      apiTokenBody:
        'The scheduled check failed for store «{{storeName}}». Update the marketplace API key to restore sync.',
      addApiToken: 'Add API key',
      apiTokenDismiss: 'Hide until next login',
    },
    errors: {
      serviceUnavailable:
        'The service is temporarily unreachable. This may be due to technical maintenance or a server restart. Please wait a few minutes and refresh the page.',
      serviceUnavailableShort:
        'The site is temporarily unavailable (maintenance or restart). Please try again in a few minutes.',
      unknown: 'Something went wrong. Please try again.',
    },
    adminHighlight: {
      navButton: 'Highlight by store',
      title: 'Highlight orders by store',
      intro:
        'Choose stores whose orders should show a red outline in admin tables (Orders, Billings, WB returns report for that store). Saved in this browser only. Superuser only.',
      searchLabel: 'Search stores',
      searchPlaceholder: 'Name, WB store ID, owner email…',
      searching: 'Searching…',
      searchError: 'Could not load stores',
      noMatches: 'No stores match',
      summary: 'Stores selected',
      noneSelected: 'None',
      reopenSearch: 'search again to resolve',
      selected: 'On',
      unnamedStore: 'Store',
      clearAll: 'Clear all & close',
      cancel: 'Cancel',
      save: 'Save',
    },
    adminSuperuser: {
      title: 'Create superadmin',
      intro:
        'Creates another user with full superuser access (same as you). The account is active and email is marked verified.',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Confirm password',
      submit: 'Create',
      close: 'Close',
      emailRequired: 'Enter an email address.',
      passwordTooShort: 'Password must be at least 8 characters.',
      passwordMismatch: 'Passwords do not match.',
      createFailed: 'Could not create user.',
      created: 'Superuser created: {{email}}',
    },
    adminStaffStatus: {
      title: 'Staff analytics',
      intro:
        'Order status transitions performed by operators (from / to), aggregated by user for the selected period. Only changes with a recorded operator are counted.',
      dateFrom: 'From date',
      dateTo: 'To date',
      load: 'Load',
      loadError: 'Failed to load staff analytics.',
      colEmail: 'Operator (email)',
      colTotal: 'Transitions',
      colTransitions: 'Preview',
      empty: 'No data for this period.',
      from: 'From status',
      to: 'To status',
      count: 'Count',
    },
    wbAdminReturns: {
      title: 'WB: All store returns (Analytics)',
      intro:
        'Data comes from the local snapshot table (refreshed from WB every 4 hours). By default the table loads all snapshot rows (paginated). Narrow by PVZ group, optional WB date range on selected fields, store, isStatusActive, and the text search; press Enter or Apply. Click a row to show extra columns (snapshot, store meta, brand, etc.). You can add a row to Orders with the button.',
      store: 'Store (Wildberries)',
      storeOptional: 'Store (optional)',
      storeOptionalHint: 'Leave empty for all stores. Pick one to filter by that store (database id / seller).',
      storePlaceholder: '— select —',
      storeSearchPlaceholder: 'Search by WB store ID, name, or owner email…',
      storeSearchHint: 'Only Wildberries stores with a saved API key are listed.',
      storeSearching: 'Searching…',
      storeSearchError: 'Could not load stores',
      storeNoMatches: 'No matching stores with an API key',
      storeClear: 'Clear',
      year: 'Year',
      month: 'Month',
      dateFrom: 'Date from',
      dateTo: 'Date to',
      load: 'Load from database',
      restrictByMonth: 'Limit to calendar month (orderDt)',
      allSnapshotsHint: 'Unchecked: all snapshots in the database (with pagination). Filters are optional.',
      orderDtFrom: 'Order date from',
      orderDtTo: 'Order date to',
      isStatusActive: 'isStatusActive',
      anyActive: 'Any',
      acceptStatusFilter: 'Receipt status',
      acceptStatusAll: 'Any',
      acceptYes: 'Accepted',
      acceptNo: 'Not accepted',
      returnsSourceFilter: 'Return origin',
      returnsSourceAll: 'All',
      returnsSourceForeign: 'Foreign',
      returnsSourceInternal: 'Internal',
      applyFilters: 'Apply / refresh',
      exactMatch: 'Exact match (server)',
      storesInResult: 'Stores in this result',
      loading: 'Loading…',
      downloadExcel: 'Download Excel',
      exporting: 'Exporting…',
      lastSynced: 'Snapshot last updated (UTC)',
      pagePrev: 'Previous page',
      pageNext: 'Next page',
      filterByStoreDb: 'Store id (DB)',
      orderColumn: 'Order',
      addToOrder: 'Add to Orders',
      addingToOrder: 'Saving…',
      addToOrderDone: 'Order created or already exists',
      addToOrderError: 'Could not create order',
      shkIdSearch: 'ShkId (main)',
      shkIdPlaceholder: 'Filter by ShkId…',
      search: 'All columns',
      searchPlaceholder: 'Address, srid, shkId, stickerId, orderId, barcode, brand…',
      searchHint: 'Enter applies filters. Matches substrings in text fields; numeric IDs match exactly.',
      filterByStore: 'WB seller id',
      allStores: 'All stores',
      returnType: 'Return type',
      status: 'Status',
      allReturnTypes: 'All return types',
      allStatuses: 'All statuses',
      records: 'Rows shown',
      storesLoaded: 'Stores queried',
      storesSkipped: 'skipped / errors',
      partialStoreErrors: 'Some stores failed (others are shown):',
      storePk: 'Store pk',
      noRows: 'No snapshot rows (sync may not have run yet, or filters exclude everything).',
      selectStoreHint: 'Select a Wildberries store.',
      loadError: 'Failed to load data',
      exportError: 'Failed to export Excel',
      pvzScope: 'Pickup point (delivery address)',
      pvzScopeAll: 'All PVZ',
      pvzShosseynaya: 'Shosseynaya 4k3',
      pvzProezd3723: 'Proezd 3723',
      pvzOurWarehouse: 'Our warehouse (dstOfficeId 50156464)',
      pvzOurPvz: 'Our PVZ (dstOfficeId 50173297)',
      pvzOther: 'Other PVZ',
      wbDtFrom: 'WB dates from',
      wbDtTo: 'WB dates to',
      wbDtFieldsLabel: 'Match interval on (OR)',
      wbFieldCompletedDt: 'Item issued at (completedDt)',
      wbFieldReadyToReturnDt: 'Ready for pickup (readyToReturnDt)',
      wbFieldExpiredDt: 'PVZ storage expired (expiredDt)',
      wbFieldOrderDt: 'Return ordered at (orderDt)',
      wbDtHint:
        'Pick at least one field and both dates; rows match if any selected field falls in the range.',
      detailFieldsTitle: 'Extra fields (click row to toggle)',
      colSnapshotId: 'Snapshot ID',
      colStoreSellerId: 'Store (WB seller id)',
      colStoreDbId: 'Store (DB id)',
      colStoreName: 'Store name',
      colSrid: 'srid',
      colNmId: 'nmId',
      colBarcode: 'Barcode',
      colBrand: 'Brand',
      colSubjectName: 'Subject',
      colTechSize: 'Size',
      colReturnType: 'Return type',
      colReason: 'Reason',
      colStatus: 'Status',
      colAcceptStatus: 'Receipt status',
      colReturnsSource: 'Return origin',
      colOrderDt: 'Return ordered at',
      colOrderId: 'orderId',
      colCompletedDt: 'Item issued at',
      colReadyToReturnDt: 'Ready for pickup',
      colExpiredDt: 'PVZ storage expired at',
      colDstOfficeAddress: 'PVZ address',
      colDstOfficeId: 'dstOfficeId',
      colIsStatusActive: 'isStatusActive',
      colShkId: 'shkId',
      colStickerId: 'stickerId',
    },
    impersonate: {
      title: 'Enter as client',
      searchPlaceholder: 'Search by email or name...',
      search: 'Search',
      selectUser: 'Select a user to open the app as that client',
      noUsers: 'No users found',
      loading: 'Loading...',
      entering: 'Entering...',
      error: 'Failed to enter as client',
      openAsUser: 'Open as this user',
    },
    billing: {
      title: 'Accounts',
      currentBalance: 'Current balance',
      topUp: 'Top-up',
      deducted: 'Deducted',
      dateFrom: 'Date from (billing date)',
      dateTo: 'Date to (billing date)',
      type: 'Type',
      orderNo: 'Order number',
      searchProductBarcode: 'Product, barcode...',
      apply: 'Apply',
      downloadExcel: 'Download Excel',
      downloadPdf: 'Download PDF report',
      accountsPdfFilename: 'accounts_report',
      noExpenses: 'No charges for the selected period.',
      shownOf: 'Showing {{from}}–{{to}} of {{total}}',
      perPage: 'per page',
      back: 'Back',
      next: 'Next',
      pageOf: 'Page {{page}} of {{total}}',
      date: 'Date',
      service: 'Service',
      orderStatus: 'Order status',
      orderDate: 'Order date',
      product: 'Product',
      amount: 'Amount (¥)',
      allTypes: 'All types',
      type_storage_daily: 'Storage per day',
      type_storage_warehouse: 'Warehouse storage (WH)',
      type_prepare_return_to_seller: 'Prepare return to seller',
      type_disposal: 'Product disposal',
      type_packaging_shipment: 'Packaging and shipment',
      type_inspection_no_media: 'Product inspection',
      type_inspection_with_media: 'Defective product inspection with photos',
      type_receipt_warehouse: 'Receipt at warehouse',
      type_receipt_pickup: 'Receipt at pickup point',
      type_balance_top_up: 'Balance top-up',
      whStockUnits: 'WH stock qty',
      byStore: 'By store',
      depositWarningBanner: 'Attention! According to the terms of cooperation described in the offer, with a negative balance Flydarin will only be able to accept, check and store goods; they will not be put up for sale. For uninterrupted operation, please top up your balance via AliPay using the QR code on this page. Minimum deposit when connecting 1 store = 1000 yuan, 2 stores = 700 yuan each, 3 or more stores = 500 yuan each. Funds will be credited to your balance within 24 hours.',
      sendReceiptHint: 'Please be sure to send a receipt or screenshot after paying the deposit.',
      sendReceiptButton: 'Send receipt',
      payWithAlipay: 'Pay with AliPay',
      payWithAlipayHint:
        'Choose a store and enter any top-up amount in CNY. After Alipay confirms payment, your balance is updated automatically (no receipt needed for this flow).',
      payWithAlipayCustomHint:
        'Enter the amount you want to add to the selected store balance, then open the official Alipay checkout page.',
      payWithAlipayStoreLabel: 'Store',
      payWithAlipayAmountLabel: 'Top-up amount (CNY)',
      payWithAlipayFillDebt: 'Fill debt amount ({{amount}} ¥)',
      payWithAlipayAmountRequired: 'Enter a valid amount (minimum 0.01 ¥).',
      payWithAlipayStoreRequired: 'Select a store.',
      payWithAlipayNoStores: 'No stores linked to your account.',
      payWithAlipayPagePrimaryHint:
        'Recommended: pay in this browser — you will be redirected to the official Alipay checkout page (alipay.trade.page.pay).',
      payWithAlipayPageNewTab: 'Open in new tab',
      payWithAlipayNegativeOnly: 'Live QR payment is available only when a store balance is negative.',
      payWithAlipayButton: 'Get payment QR',
      payWithAlipayAmount: 'Amount',
      payWithAlipayOrderNo: 'Order no.',
      payWithAlipayReused: 'Existing unpaid QR (still valid)',
      payWithAlipayScanHint: 'Open AliPay and scan this code.',
      payWithAlipayCreditHint: 'After AliPay confirms payment, the top-up is applied automatically; no receipt is required for this flow.',
      payWithAlipayCopyPayload: 'Copy QR payload',
      payWithAlipayCopied: 'Copied',
      payWithAlipayPageButton: 'Open AliPay page',
      payWithAlipayPagePopupBlocked: 'Popup is blocked by browser. Please allow popups and try again.',
      payWithAlipayPageNoUrl: 'Could not get AliPay payment URL.',
      accountsPeriodSummaryTitle: 'Period summary',
      accountsSummaryTotalTitle: 'Total charges',
      accountsSummaryByService: 'Charges by service type',
      accountsSummaryNoCharges: 'No charges in this period with the current filters.',
      accountsSummaryActivityTitle: 'Returns in this period',
      accountsSummaryNewReturnsLine: 'New returns: {{total}} · our return point: {{our}} · other PVZ: {{other}}',
      accountsSummaryCompletedLine:
        'Finished processing (listed for sale, sent to seller, disposed, etc.): {{total}} · our point: {{our}} · other: {{other}}',
      accountsSummaryTableHint: 'Use Details on a product row to see status history and every charge line.',
      accountsStatusHistoryTranslatedHint: 'Status names are shown in your interface language.',
      accountsPeriodRange: '{{from}} — {{to}}',
      accountsSelectedPeriodLabel: 'Selected period',
      accountsAllTimeLabel: 'All time',
      accountsQuickPeriod: 'Quick period',
      accountsQuickPeriodCustom: 'Custom (use dates below)',
      accountsQuickAllTime: 'All time',
      accountsQuickToday: 'Today',
      accountsQuickWeek: 'This week (Mon — today)',
      accountsQuickMonth: 'This month',
      accountsQuickQuarter: 'This quarter',
      accountsWeekTitle: 'Period summary',
      accountsWeekNewOrders: 'New orders (created in period)',
      accountsWeekCreatedOurPvz: 'New orders · our return PVZ',
      accountsWeekCreatedOtherPvz: 'New orders · other PVZ',
      accountsWeekProcessedFinal: 'Moved to final status in period',
      accountsWeekProcessedOurPvz: 'Final status · our PVZ',
      accountsWeekProcessedOtherPvz: 'Final status · other PVZ',
      accountsWeekChargesTotal: 'Charges in period (¥)',
      accountsWeekChargesByType: 'Charges by type',
      accountsAllStores: 'All stores',
      accountsStoreFilterPlaceholder: 'Search store by name or ID…',
      accountsStoreNoMatches: 'No matching stores',
      accountsStoreColumn: 'Store',
      accountsSortLabel: 'Sort table',
      accountsSortStore: 'By store',
      accountsSortProduct: 'By product',
      accountsSortBarcode: 'By barcode',
      accountsSortCharges: 'By total charges',
      accountsBarcode: 'Barcode',
      accountsNmId: 'nm ID',
      accountsPrice: 'Price',
      accountsReturnsCount: 'Returns',
      accountsInSaleOnWarehouse: 'On sale (in warehouse)',
      accountsInSaleOnWarehouseHint:
        'Items that are with us on the warehouse as active stock listed for sale on the marketplace.',
      accountsWhBuyerShipments: 'Shipments to buyers',
      accountsWhBuyerShipmentsHint:
        'Orders with this barcode that have a packaging/shipment charge created from the Warehouse Hub API (buyer shipments).',
      accountsTotalCharges: 'Total charges (¥)',
      accountsDetailColumn: 'Details',
      accountsExpand: 'Details',
      accountsCollapse: 'Hide',
      accountsChargeType: 'Charge type',
      accountsStatusHistory: 'Status history',
      accountsReturnTotals: 'Return totals',
      accountsByChargeType: 'By charge type',
      accountsExpandChargeLines: 'Charge lines',
      accountsCollapseChargeLines: 'Hide lines',
      accountsNoBarcodeRows: 'No aggregated data for the selected filters.',
      accountsTopUpsTitle: 'Balance top-ups',
      accountsTopUpsHint: 'Wallet top-up transactions for the selected period and store.',
      accountsTopUpsLimited: 'Showing {{count}} of {{total}} latest transactions.',
      accountsTopUpsComment: 'Comment',
      accountsNoTopUps: 'No balance top-ups for the selected filters.',
      accountsTopUpsExportFilename: 'accounts_top_ups',
      accountsCustomChargesTitle: 'Charges agreed with client',
      accountsCustomChargesHint: 'Manual store charges without a linked order for the selected period and store.',
      accountsCustomChargesLimited: 'Showing {{count}} of {{total}} latest transactions.',
      accountsCustomChargesComment: 'Comment',
      accountsNoCustomCharges: 'No agreed charges for the selected filters.',
      accountsCustomChargesExportFilename: 'accounts_custom_charges',
      accountsExportFilename: 'accounts_by_barcode',
      accountsStatusAwaitingReceipt: 'Awaiting receipt at WB',
      accountsStatusReceivedAwaitingCheck: 'Received, awaiting inspection',
      accountsStatusAwaitingSellerDecision: 'Awaiting seller decision',
      accountsStatusAwaitingForSale: 'Awaiting transfer to sale',
      accountsStatusTransferringToSale: 'Transferring to sale',
      accountsStatusSubmittedForSale: 'Listed for sale',
      accountsStatusAwaitingShipment: 'Awaiting shipment to seller',
      accountsStatusAwaitingDisposal: 'Awaiting disposal',
      accountsStatusDisposed: 'Disposed',
      accountsStatusSentToSeller: 'Sent to seller',
      accountsChargeNameReceiptWarehouse: 'Receipt at warehouse (per item)',
      accountsChargeNameReceiptPickup: 'Receipt at pickup point (per item)',
      accountsChargeNameInspectionNoMedia: 'Product inspection',
      accountsChargeNameInspectionWithMedia: 'Defective product inspection with photos',
      accountsChargeNamePackagingShipment: 'Packaging & shipment to marketplace',
      accountsChargeNameStorageAtWarehouse: 'Storage at warehouse (until shipment)',
      accountsChargeNamePrepareReturn: 'Preparing return to seller',
      accountsChargeNameDisposal: 'Product disposal',
      accountsChargeNameBalanceTopUp: 'Balance top-up',
      accountsChargeTooltipReceiptWarehouse:
        'Tariff item 1: receipt of goods or returns at the warehouse — 2.0 ¥ per item.',
      accountsChargeTooltipReceiptPickup:
        'Tariff item 2: receipt at pickup point — 5.5 ¥ per item.',
      accountsChargeTooltipInspectionNoMedia:
        'Tariff item 3: product inspection — 2.0 ¥ per unit.',
      accountsChargeTooltipInspectionWithMedia:
        'Tariff item 4: defective product inspection with photos — 3.5 ¥ per unit.',
      accountsChargeTooltipPackagingShipment:
        'Tariff item 5: packaging and shipment to the marketplace — tiered by sum of sides (L+W+H in cm), from 10.5 ¥ up to 90 ¥ for oversized.',
      accountsChargeTooltipStorageAtWarehouse:
        'Tariff item 6: storage at warehouse until shipment — 13.5 ¥ per 1 m³ per day. Includes both daily storage (storage_daily) and WH stock turnover storage (storage_warehouse).',
      accountsChargeTooltipPrepareReturn:
        'Tariff item 7: preparing goods for return to seller — 3.5 ¥ per unit.',
      accountsChargeTooltipDisposal:
        'Disposal charge: default gross weight (kg) from WB card × 3.5 ¥ per unit; admin can override.',
      accountsChargeTooltipBalanceTopUp: 'Account balance top-up (not a service charge).',
    },
    findReturnByShk: {
      title: 'Find return by barcode (shkId)',
      storePlaceholder: 'Search store by name, ID or email...',
      shkIdsPlaceholder: 'Enter shkIds (one per line or comma-separated)',
      shkIdsHint: 'Multiple values: one per line or separated by comma/semicolon.',
      addSet: 'Add another store',
      submit: 'Search',
      searching: 'Searching...',
      storeLabel: 'Store',
      found: 'Found',
      notFound: 'Not found',
      alreadyInDb: 'Already in system',
      editOrder: 'Edit',
      viewEdit: 'View / Edit',
      deleteOrder: 'Delete order',
      confirmDelete: 'Delete this order? This cannot be undone.',
      created: 'Created',
      deleted: 'Deleted',
      error: 'Error',
      noStoreSelected: 'Select a store',
      noShkIds: 'Enter at least one shkId',
      resultsTitle: 'Results',
      removeRow: 'Remove',
    },
    // Dashboard cards
    dashboard: {
      inTransit: 'In Transit to',
      warehouse: 'IndigoWarehouse',
      storedIn: 'Stored in',
      completedReturns: 'Completed Returns',
      returnRequests: 'Return Requests',
      ordersInProcessing: 'Orders in Processing',
      ordersPendingDecision: 'Orders Pending Decision',
      completedOrders: 'Completed Orders',
      items: 'items',
      or: 'or',
      viewItemsInTransit: 'View items in transit',
      viewReturnsOtherPvz: 'View returns to other pickup points',
      viewReturnData: 'View return data',
      viewFinancialReport: 'View financial report',
      processReturns: 'Process returns',
      viewProcessingOrders: 'View processing orders',
      viewCompletedOrders: 'View completed orders',
    },
    // Add Store Modal
    addStore: {
      title: 'Add Store',
      selectMarketplace: 'Select Marketplace',
      wildberries: 'Wildberries',
      ozon: 'Ozon',
      yandexMarket: 'Yandex Market',
      comingSoon: 'Coming Soon',
      storeName: 'Store Name',
      storeNamePlaceholder: 'My Store',
      storeNameHint: 'Give your store a name to easily identify it',
      enterApiKey: 'Enter JWT API Key',
      apiKeyPlaceholder: 'Paste your JWT API key here...',
      cancel: 'Cancel',
      add: 'Add Store',
      adding: 'Adding...',
      success: 'Store added successfully!',
      error: 'Failed to add store',
      invalidToken: 'Invalid or expired token',
      storeExists: 'This store is already connected',
    },
    // Profile
    profile: {
      title: 'Profile Information',
      email: 'Email',
      emailCannotChange: 'Email cannot be changed',
      wechatId: 'WeChat ID',
      telegramUsername: 'Telegram',
      messengerHint: 'Contacts for messengers',
      firstName: 'First Name',
      lastName: 'Last Name',
      accountStatus: 'Account Status',
      emailVerified: 'Email Verified',
      memberSince: 'Member Since',
      edit: 'Edit',
      save: 'Save Changes',
      saving: 'Saving...',
      cancel: 'Cancel',
      updateSuccess: 'Profile updated successfully!',
      updateError: 'Failed to update profile. Please try again.',
      // Delivery address
      deliveryAddressTitle: 'Delivery Address',
      deliveryAddressDescription: 'Your delivery address is required to receive product returns.',
      deliveryAddressWarning: 'Please fill in your delivery address to be able to request product returns.',
      addressUpdateSuccess: 'Address updated successfully!',
      addressStreet: 'Street Address',
      addressStreetPlaceholder: '123 Main Street, Apt 4',
      addressCity: 'City',
      addressCityPlaceholder: 'Moscow',
      addressPostalCode: 'Postal Code',
      addressPostalCodePlaceholder: '123456',
      addressCountry: 'Country',
      addressCountryPlaceholder: 'Russia',
      addressPhone: 'Phone Number',
      addressPhonePlaceholder: '+7 (999) 123-45-67',
      // Legal documents
      documentsTitle: 'Legal Entity Documents',
      documentsDescription: 'Upload PDF documents related to your legal entity. Maximum file size: 10MB.',
      documentsUpload: 'Upload PDF',
      documentsUploading: 'Uploading...',
      documentsEmpty: 'No documents uploaded yet',
      documentsOnlyPdf: 'Only PDF files are allowed',
      documentsMaxSize: 'File size cannot exceed 10MB',
      documentsUploadSuccess: 'Document uploaded successfully!',
      documentsUploadError: 'Failed to upload document',
      documentsDeleteSuccess: 'Document deleted successfully!',
      documentsDeleteError: 'Failed to delete document',
      documentsConfirmDelete: 'Are you sure you want to delete this document?',
      autoReturnCheckTitle: 'Automatic return verification',
      autoReturnCheckHint:
        'Per store: when enabled, new return line items for that store are created with warehouse verification required. When disabled, they are created without verification.',
      autoReturnCheckLoadError: 'Could not load stores for this setting.',
      autoReturnCheckUpdateError: 'Could not update the setting. Please try again.',
      autoReturnCheckNoStores: 'No stores connected. Add a store on the dashboard first.',
    },
    // Security
    security: {
      title: 'Security',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      update: 'Update Password',
      updating: 'Updating...',
      success: 'Password changed successfully!',
    },
    chatApp: {
      topicSupport: 'Tech Support',
      topicSupportSub: 'Chat with our team',
      topicAi: 'Warehouse Cat',
      topicAiSub: 'AI assistant',
      topicProfile: 'Profile',
      reports: 'Reports',
      settings: 'Settings',
      reportDeductions: 'Deductions',
      reportTopups: 'Top-ups',
      reportSales: 'Sales',
      reportReturns: 'Returns',
      switchClassic: 'Classic interface',
      switchChat: 'Chat interface',
      aiWelcome: 'Meow! I am the Warehouse Cat — ask me about returns, billing, or how the platform works.',
      aiPlaceholder: 'Ask a question…',
      aiError: 'Could not get an answer. Try again or contact support.',
      send: 'Send',
      load: 'Load',
      returnsWindows: 'Returns 24h / 48h / 72h',
      barcode: 'Barcode',
      date: 'Date',
      store: 'Store',
      comment: 'Comment',
      wbReceived: 'WB receipts (completed)',
      ourReceipts: 'Our acceptances',
      debt: 'Debt (issued, not accepted)',
    },
    // Stores
    stores: {
      title: 'My Stores',
      noStores: 'No stores connected yet',
      addFirst: 'Add your first store to get started',
      connected: 'Connected',
      storeId: 'Store ID',
      edit: 'Edit store',
      editTitle: 'Edit Store Name',
      storeName: 'Store Name',
      storeNamePlaceholder: 'Enter store name',
      storeNameHint: 'Give your store a name to easily identify it',
      editError: 'Failed to update store',
      // Verification status
      verifying: 'Verifying...',
      verified: 'Verified',
      verificationFailed: 'Verification Failed',
      verificationFailedMessage: 'Token verification failed. Please update the API key or delete this store and add it again with a valid API key.',
      verificationPending: 'Verification in progress...',
      deleteStore: 'Delete Store',
      deleteStoreConfirm: 'Are you sure you want to delete this store?',
      updateApiKey: 'Update API Key',
      enterNewApiKey: 'Enter New API Key',
      apiKeyPlaceholder: 'Paste your API key here...',
      apiKeyUpdateHint: 'Enter a new API key to replace the current one. The store will be re-verified after update.',
      apiKeyUpdateSuccess: 'API key updated successfully. Store verification in progress.',
      apiKeyUpdateError: 'Failed to update API key',
      apiKeyInvalidMessage: 'Your API key is invalid or expired. Please update it to continue using this store.',
      store: 'Store',
    },
    // Auth
    auth: {
      login: 'Sign In',
      register: 'Sign Up',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      noAccount: "Don't have an account?",
      haveAccount: 'Already have an account?',
      signUpNow: 'Sign up',
      signInNow: 'Sign in',
      firstName: 'First Name',
      lastName: 'Last Name',
      welcomeBack: 'Welcome Back',
      signInToAccount: 'Sign in to your account',
      enterEmail: 'Enter your email',
      enterPassword: 'Enter your password',
      signingIn: 'Signing in...',
      loginFailed: 'Login failed. Please try again.',
      createAccount: 'Create Account',
      joinUs: 'Join us and get started',
      signingUp: 'Creating account...',
      registrationFailed: 'Registration failed. Please try again.',
      pricingAndExample: 'Our pricing and example',
      resetPassword: 'Reset Password',
      enterEmailReset: 'Enter your email to reset password',
      sendResetLink: 'Send Reset Link',
      sending: 'Sending...',
      backToLogin: 'Back to login',
      checkEmail: 'Check Your Email',
      resetLinkSent: 'We have sent a password reset link to',
      newPasswordTitle: 'Set New Password',
      enterNewPassword: 'Enter your new password',
      confirmNewPassword: 'Confirm your new password',
      resetPasswordBtn: 'Reset Password',
      resetting: 'Resetting...',
      passwordResetSuccess: 'Password Reset Successful',
      passwordResetSuccessMsg: 'Your password has been successfully reset.',
      registrationSuccess: 'Registration Successful',
      verifyEmailMsg: 'Please check your email to verify your account.',
      verifyingEmail: 'Verifying your email...',
      emailVerified: 'Email Verified',
      emailVerifiedMsg: 'Your email has been successfully verified.',
      resendVerification: 'Resend verification email',
      // Forgot Password
      forgotPasswordTitle: 'Forgot Password?',
      forgotPasswordSubtitle: 'No worries, we\'ll send you reset instructions',
      forgotPasswordFailed: 'Failed to send reset email. Please try again.',
      // Reset Sent
      resetSentTitle: 'Check Your Email',
      resetSentMessage: 'We\'ve sent password reset instructions to',
      resetSentInfo: 'If an account exists with this email, you\'ll receive instructions to reset your password. Check your spam folder if you don\'t see it within a few minutes.',
      // Reset Password
      resetPasswordTitle: 'Reset Password',
      resetPasswordSubtitle: 'Enter your new password below',
      newPasswordLabel: 'New Password',
      newPasswordPlaceholder: 'At least 8 characters',
      confirmNewPasswordLabel: 'Confirm Password',
      confirmNewPasswordPlaceholder: 'Confirm your new password',
      passwordsDoNotMatch: 'Passwords do not match',
      resetPasswordFailed: 'Failed to reset password. Please try again.',
      // Reset Success
      resetSuccessTitle: 'Password Reset Complete',
      resetSuccessMessage: 'Your password has been successfully reset.',
      resetSuccessInfo: 'You can now sign in with your new password.',
      continueToSignIn: 'Continue to Sign In',
      // Verify Email
      verifyingEmailTitle: 'Verifying Your Email',
      verifyingEmailMessage: 'Please wait while we verify your email address...',
      emailVerifiedTitle: 'Email Verified!',
      emailVerifiedMessage: 'Your email has been successfully verified.',
      emailVerifiedInfo: 'Your account is now active. You will be redirected to login shortly...',
      verificationFailedTitle: 'Verification Failed',
      verificationFailedMessage: 'We couldn\'t verify your email address',
      verificationFailedInfo: 'The verification link may have expired or already been used. Please try signing in or request a new verification email.',
      goToLogin: 'Go to Login',
      // Registration Success
      registrationSuccessTitle: 'Check Your Email',
      registrationSuccessMessage: 'We\'ve sent a verification link to',
      registrationSuccessImportant: 'Important:',
      registrationSuccessInfo: 'You must verify your email address before you can log in. Click the link in the email we sent you to activate your account.',
      didntReceiveEmail: 'Didn\'t receive the email?',
      resendVerificationEmail: 'Resend verification email',
      verificationEmailResent: 'Verification email has been resent. Please check your inbox.',
      resendEmailFailed: 'Failed to resend email. Please try again.',
      alreadyVerified: 'Already verified?',
      contactUs: 'Contact us',
      telegramChat: 'Telegram chat',
      faq: 'FAQ',
      aboutProject: 'About Project',
    },
    // Register
    register: {
      title: 'Create Account',
      subtitle: 'Sign up to get started',
      firstName: 'First Name',
      firstNamePlaceholder: 'John',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Doe',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      password: 'Password',
      passwordPlaceholder: 'At least 8 characters',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm your password',
      submit: 'Create Account',
      creating: 'Creating Account...',
      haveAccount: 'Already have an account?',
      signIn: 'Sign in',
      passwordsDoNotMatch: 'Passwords do not match',
      failed: 'Registration failed. Please try again.',
      agreeToOffer: 'I have read and agree to the',
      offerLink: 'Offer',
      agreeToDataProcessing: 'I agree to the processing of personal data',
      mustAgreeToOffer: 'You must agree to the offer to register',
      mustAgreeToDataProcessing: 'You must agree to data processing to register',
      wechatId: 'WeChat ID',
      telegramUsername: 'Telegram username',
      messengerHint: 'Provide at least one: WeChat ID or Telegram username',
    },
    // Forgot Password
    forgotPassword: {
      title: 'Forgot Password?',
      subtitle: 'No worries, we\'ll send you reset instructions',
      emailLabel: 'Email',
      emailPlaceholder: 'Enter your email',
      sendResetLink: 'Send Reset Link',
      sending: 'Sending...',
      backToLogin: 'Back to login',
      failed: 'Failed to send reset email. Please try again.',
    },
    // Reset Sent
    resetSent: {
      title: 'Check Your Email',
      message: 'We\'ve sent password reset instructions to',
      info: 'If an account exists with this email, you\'ll receive instructions to reset your password. Check your spam folder if you don\'t see it within a few minutes.',
      backToLogin: 'Back to login',
    },
    // Reset Password
    resetPassword: {
      title: 'Reset Password',
      subtitle: 'Enter your new password below',
      newPasswordLabel: 'New Password',
      newPasswordPlaceholder: 'At least 8 characters',
      confirmPasswordLabel: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm your new password',
      resetButton: 'Reset Password',
      resetting: 'Resetting...',
      backToLogin: 'Back to login',
      passwordsDoNotMatch: 'Passwords do not match',
      failed: 'Failed to reset password. Please try again.',
    },
    // Reset Success
    resetSuccess: {
      title: 'Password Reset Complete',
      message: 'Your password has been successfully reset.',
      info: 'You can now sign in with your new password.',
      continueToSignIn: 'Continue to Sign In',
    },
    // Verify Email
    verifyEmail: {
      verifyingTitle: 'Verifying Your Email',
      verifyingMessage: 'Please wait while we verify your email address...',
      successTitle: 'Email Verified!',
      successMessage: 'Your email has been successfully verified.',
      successInfo: 'Your account is now active. You will be redirected to login shortly...',
      continueToSignIn: 'Continue to Sign In',
      failedTitle: 'Verification Failed',
      failedMessage: 'We couldn\'t verify your email address',
      failedInfo: 'The verification link may have expired or already been used. Please try signing in or request a new verification email.',
      goToLogin: 'Go to Login',
      invalidLink: 'Invalid verification link.',
      failedError: 'Failed to verify email. The link may be invalid or expired.',
    },
    // Registration Success
    registrationSuccess: {
      title: 'Check Your Email',
      message: 'We\'ve sent a verification link to',
      important: 'Important:',
      info: 'You must verify your email address before you can log in. Click the link in the email we sent you to activate your account.',
      didntReceiveEmail: 'Didn\'t receive the email?',
      resendButton: 'Resend verification email',
      sending: 'Sending...',
      emailResent: 'Verification email has been resent. Please check your inbox.',
      resendFailed: 'Failed to resend email. Please try again.',
      alreadyVerified: 'Already verified?',
      signIn: 'Sign in',
    },
    // Offer
    offer: {
      title: 'Offer Agreement',
      languageUAE: 'UAE',
      languageChina: 'China',
      selectLanguage: 'Select language to download the offer document',
      uaeDescription: 'Download the offer document for UAE',
      chinaDescription: 'Download the offer document for China',
      download: 'Download DOCX',
      downloading: 'Downloading...',
      downloadError: 'Failed to download offer document',
    },
    // Pricing
    pricing: {
      title: 'Service Rates',
      subtitle: 'Service rates and pricing information',
      loadError: 'Failed to load pricing table',
      downloadButton: 'Download Our Prices',
      downloading: 'Downloading...',
      downloadError: 'Failed to download price list',
    },
    // Indigo Price List (static table on /pricing)
    priceList: {
      title: 'INDIGO Service Price List',
      subhead: 'Service rates — prices are per unit unless otherwise stated.',
      colNo: 'No.',
      colService: 'Service',
      colCost: 'Cost (¥)',
      colNote: 'Note / unit of measure',
      r1_name: 'Receipt of goods or returns at warehouse (per item)',
      r1_note: 'per item',
      r2_name: 'Receipt at pickup point (per item)',
      r2_note: 'per unit',
      r3_name: 'Product inspection',
      r3_note: 'per unit',
      r4_name: 'Defective product inspection with photos',
      r4_note: 'per unit',
      r5_main: 'Order processing (packaging and shipment to marketplace)',
      r5_50_name: 'up to 50 cm (sum of sides)',
      r5_50_note: 'L+W+H ≤ 50 cm',
      r5_80_name: 'up to 80 cm',
      r5_80_note: 'sum ≤ 80 cm',
      r5_100_name: 'up to 100 cm',
      r5_100_note: 'sum ≤ 100 cm',
      r5_120_name: 'up to 120 cm',
      r5_120_note: 'sum ≤ 120 cm',
      r5_180_name: 'up to 180 cm',
      r5_180_note: 'sum ≤ 180 cm',
      r5_220_name: 'up to 220 cm',
      r5_220_note: 'sum ≤ 220 cm',
      r5_oversized_name: 'oversized orders',
      r5_oversized_note: 'over 220 cm or non-standard',
      r6_name: 'Storage at warehouse (until shipment)',
      r6_note: 'per 1 m³ per day',
      r7_name: 'Preparing goods for return to seller',
      r7_note: 'per unit',
      r8_name: 'Return to seller',
      r8_note: 'according to carrier rates (calculated separately)',
      r8_price: 'individually',
      infoTitle: 'Important notes',
      info1: 'Service 5 (order processing) includes packaging and shipment of the customer order from warehouse to marketplace. Cost depends on the sum of three dimensions (length + width + height) in centimetres.',
      info2: 'Storage (service 6) is charged for each full or partial day at 13.5 per 1 cubic metre per day. Volume is rounded to 0.001 m³.',
      info3: 'Return to seller (service 8) — cost is calculated individually for the specific carrier and route.',
      info4: 'All prices are excluding marketplace commissions and taxes.',
    },
    // Landing
    landing: {
      home: 'Home',
      heroTitle: 'Warehouse and returns management for marketplaces',
      heroSubtitle: 'Connect your store, manage returns and storage in one place.',
      login: 'Sign In',
      register: 'Sign Up',
      connectService: 'Connect service',
      featuresTitle: 'Why choose us',
      feature1Title: 'Returns & storage',
      feature1Text: 'Manage returns and warehouse operations in one system.',
      feature2Title: 'Speed and transparency',
      feature2Text: 'Real-time statuses and clear billing.',
      feature3Title: 'Security',
      feature3Text: 'Your data is protected and compliant.',
      ctaTitle: 'Get started',
      ctaText: 'Sign in or create an account to connect your store.',
    },
    // Footer
    footer: {
      copyright: '© {{year}} Indigo Warehouse. All rights reserved.',
      pricing: 'Pricing and example',
      offer: 'Offer',
      faq: 'FAQ',
      aboutProject: 'About Project',
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      update: 'Update',
      updating: 'Updating...',
      hello: 'Hello',
      cancel: 'Cancel',
      close: 'Close',
      save: 'Save',
      saving: 'Saving...',
      back: 'Back',
      home: 'Home',
      currency: {
        yen: '¥',
        ruble: '₽',
      },
      yes: 'Yes',
      no: 'No',
    },
    // Admin Orders
    adminOrders: {
      title: 'Order Management (Admin)',
      orderNumber: 'Order Number',
      sticker: 'Sticker',
      status: 'Status',
      store: 'Store',
      trackingNumbers: 'Tracking Numbers',
      product: 'Product',
      wbProductPhoto: 'WB photo',
      refreshWbPhotoTooltip: 'Refresh image from WB API (live)',
      goodsReturnReason: 'WB return reason',
      defectNeedsPhotoVideo:
        'For defective goods, enable «Requires photo/video» before moving to sale or seller decision.',
      dstOfficeAddress: 'Return PVZ Address',
      returnStatus: 'Return Status',
      allReturnStatuses: 'All return statuses',
      returnStatusActive: 'Active',
      returnStatusArchived: 'Archived',
      readyToReturnDt: 'Ready to Return Date',
      createdDate: 'Created Date',
      actions: 'Actions',
      details: 'Details',
      hide: 'Hide',
      edit: 'Edit',
      acceptanceMode: 'Acceptance mode',
      acceptanceModeNotFound: 'Return not found in WB goods-return.',
      searchPlaceholder:
        'Order #, tracking, SKU, barcode, WB stickerId, WB shkId (substring; exact if query is all digits), PVZ address…',
      allStatuses: 'All Statuses',
      storeIdPlaceholder: 'Store ID',
      customer: 'Customer',
      tracking: 'Tracking',
      seller: 'Seller',
      orderInfo: 'Order Information',
      id: 'ID',
      whEnterId: 'WH Enter ID',
      whSyncError: 'WH Sync Error',
      productInfo: 'Product Information',
      defective: 'Defective',
      needsCheck: 'Requires Check',
      defectAfterCheck: 'Defect After Check',
      needsPhotoVideo: 'Requires Photo/Video',
      comments: 'Comments',
      attachments: 'Attachments',
      addAttachment: 'Add Attachment',
      showing: 'Showing {{from}} - {{to}} of {{total}}',
      editOrder: 'Edit Order',
      statusLabel: 'Status',
      storeId: 'Store ID',
      customerTrackingNumber: 'Customer Tracking Number',
      trackingNumber: 'Tracking Number',
      sellerTrackingNumber: 'Seller Tracking Number',
      itemFields: 'Item Fields',
      inspectionComments: 'Inspection Comments',
      cancel: 'Cancel',
      save: 'Save',
      addAttachmentTitle: 'Add Attachment',
      attachmentType: 'Attachment Type',
      photo: 'Photo',
      video: 'Video',
      file: 'File',
      upload: 'Upload',
      attachmentFilesSelected: 'Selected: {{count}} file(s)',
      accessDenied: 'Access denied. Super administrator rights required.',
      deleteAttachment: 'Delete attachment?',
      statusTransitionSection: 'Status transition (history)',
      statusTransitionHint:
        'Shows orders that entered any checked status during the interval (by status change time). Combined with other filters using AND.',
      statusTransitionDateFrom: 'Transition from',
      statusTransitionDateTo: 'Transition to',
      statusTransitionTargetStatuses: 'Entered statuses',
      statusTransitionClear: 'Clear transition filter',
      statusTransitionIncomplete: 'Pick a date range and at least one status for this filter.',
      statusTransitionActiveNote: 'Transition filter active. Total matching orders: {{total}}.',
      dimensionsWeight: 'Dimensions & weight',
      disposalModalTitle: 'Disposal billing',
      disposalModalHint:
        'One charge per order line. When gross weight (kg) is known, suggested amount is weight × 3.5 ¥. You can edit each line.',
      disposalApplyAuto: 'Fill from weight (kg × 3.5 ¥)',
      disposalAmountYuan: 'Amount (¥)',
      disposalWeightLine: 'Gross weight: {{kg}} kg — suggested {{suggested}} ¥',
      disposalWeightUnknown: 'Product weight unknown — enter amount manually.',
      disposalConfirm: 'Create charges and set to Disposed',
    },
    // Returns Table
    returns: {
      allReturns: 'All Returns',
      inTransit: 'Items in Transit',
      inWarehouse: 'Stored in Warehouse',
      ordersInProcessing: 'Orders in Processing',
      ordersPendingDecision: 'Orders Pending Decision',
      completedOrders: 'Completed Orders',
      returnsOtherPvz: 'Returns to other pickup points',
      filterByOtherPvz: 'Orders to other pickup points',
      otherPvzTrue: 'Other PVZ only',
      otherPvzFalse: 'Only Indigo PVZ',
      pvzScopeFilter: 'WB pickup (delivery address)',
      pvzScopeAll: 'All addresses',
      pvzScopeShosseynaya: 'Moscow, Shosseynaya 4 bld. 3',
      pvzScopeProezd3723: 'Proezd 3723, vl. 12, Moscow, 109548',
      pvzScopeOther: 'Other pickup points',
      pvzScopeOur: 'Our PVZ (both above)',
      wbDtFrom: 'WB date from',
      wbDtTo: 'WB date to',
      wbDtFieldsHint: 'Filter by WB fields (OR if several checked)',
      wbDtFieldCompleted: 'completedDt',
      wbDtFieldReady: 'readyToReturnDt',
      wbDtFieldExpired: 'expiredDt',
      wbDtFieldOrder: 'orderDt',
      otherPvzContactBanner: 'If you need to collect these items, contact us in chat.',
      whBillingCharges: 'Number of deductions for storage and transfer to sale',
      whChargesCountCol: 'Deductions count (storage + transfer)',
      whStockUnitsCol: 'Stock units',
      whServiceStorage: 'Storage (WH stock / shipment)',
      whServiceShipmentToSale: 'Transfer to sale (shipment)',
      whStorageTotal: 'Total deductions for storage',
      whShipmentTotal: 'Total deductions for transfer to sale',
      otherPvzHelpText: 'This section shows WB returns in status "Awaiting Receipt at WB" that go to non-Indigo pickup points.',
      goodsOnSaleHelpText: 'This section shows items transferred to sale and related WH billing.',
      goodsOnSaleTotalsTitle: 'Totals (this page)',
      goodsOnSaleTotalsLine: 'In warehouse (returns): {{wh}} · Sold / shipped: {{sold}}',
      goodsOnSaleOnStockCol: 'On stock in warehouse',
      goodsOnSaleSoldCol: 'Sold & sent to buyer',
      goodsOnSaleStorageFeeCol: 'Storage fees — WH + daily (¥)',
      goodsOnSaleShipmentFeeCol: 'Packing & transfer fees (¥)',
      goodsOnSaleReturnsSubtable: 'Returns for this product',
      goodsOnSaleWarehouseBadge: 'In warehouse',
      goodsOnSaleSettledBadge: 'Settled',
      goodsOnSaleWhStateCol: 'WH state',
      goodsOnSaleWhPresentCol: 'WH stock (present)',
      goodsOnSaleWhReservedCol: 'WH stock (reserved)',
      goodsOnSaleWhDefectedCol: 'WH stock (defected)',
      goodsOnSaleWhStockLiveHint: 'On-stock column: live WH API (stocks.present). Hover for reserved/defected.',
      goodsOnSaleWhStockUnavailable: 'WH stock unavailable',
      goodsOnSaleMpStateCol: 'Marketplace status',
      goodsOnSaleMpStateWaiting: 'Preparing for shipment',
      goodsOnSaleMpStateReadyPickup: 'Arrived at pickup point (PVZ)',
      goodsOnSaleMpStateSold: 'Sold',
      goodsOnSaleMpStateCanceledByClient: 'Buyer canceled at pickup',
      goodsOnSaleMpStateSorted: 'Order sorted at warehouse',
      goodsOnSaleMpStateDefect: 'Assembly canceled — defect',
      goodsOnSaleReturnsWord: 'returns',
      goodsOnSaleMobileGroupedHint: 'Rows are grouped by product; tap a card to see returns.',
      goodsOnSaleShippedDateFrom: 'Buyer shipment from',
      goodsOnSaleShippedDateTo: 'Buyer shipment to',
      goodsOnSaleApplyFilters: 'Apply filters',
      goodsOnSaleSummaryShipments: 'Shipments (charged lines)',
      goodsOnSaleSummarySold: 'Successful sales',
      goodsOnSaleSummaryCanceled: 'Canceled / defect',
      goodsOnSaleSummaryInTransit: 'In transit / other',
      destination: 'Destination',
      readyToReturnDt: 'Ready for pickup at',
      archiveState: 'Active/Archived',
      finances: 'Finances',
      filters: 'Filters',
      // Status values for filter dropdown
      statusAwaitingReceipt: 'Awaiting Receipt at WB',
      statusReceivedAwaitingCheck: 'Received, Awaiting Check',
      statusAwaitingSellerDecision: 'Awaiting Seller Decision',
      statusAwaitingForSale: 'Awaiting Transfer to Sale',
      statusTransferringToSale: 'Transferring to Sale',
      statusSubmittedForSale: 'Submitted for Sale',
      statusAwaitingShipment: 'Awaiting Shipment to Seller',
      statusAwaitingDisposal: 'Awaiting Disposal',
      statusDisposed: 'Disposed',
      statusSentToSeller: 'Sent to Seller',
      // Table columns - In Transit
      returnRequestDate: 'Return Request Date',
      product: 'Product',
      dimensionsWeight: 'Dimensions & weight',
      unitCm: 'cm',
      unitKg: 'kg',
      dimensionsUnknownShort: '—',
      weightUnknownShort: 'weight unknown',
      dimensionsWeightUnavailable: 'Dimensions and weight unavailable',
      sku: 'SKU',
      barcode: 'Barcode',
      returnNumber: 'Return Number',
      sticker: 'Sticker',
      defectiveItem: 'Defective Item?',
      needsCheck: 'Needs Verification',
      needsPhotoVideo: 'Photo/Video Required?',
      decisionOnProduct: 'Decision on Product',
      status: 'Status',
      trackingNumber: 'Tracking Number',
      sellerTrackingNumber: 'Seller Tracking Number',
      // Table columns - In Warehouse
      isDefectAfterCheck: 'Defect After Check',
      photoVideo: 'Photo/Video',
      receiptDate: 'Receipt Date by IndigoWarehouse',
      attachedFiles: 'Attached Files',
      photo: 'Photo',
      video: 'Video',
      inspectionComments: 'Inspection Comments/Suggestions',
      goodsReturnReason: 'Return reason (WB)',
      wbProductPhoto: 'Photo',
      productImageComingSoon: 'Coming soon',
      wbImageNotFound: 'Not Found',
      wbPhotoFullscreen: 'View photo full screen',
      wbOpenOnWildberries: 'Open on Wildberries',
      wbCatalogShort: 'WB listing',
      whPortalProducts: 'Open in WH (products)',
      photoVideoAdminOnly:
        'Defective product inspection with photos is set by support after the check; you only choose whether verification is needed.',
      acceptSuggestion: 'Accept Suggestion',
      // Yes/No buttons
      yes: 'Yes',
      no: 'No',
      // Status decisions
      transferToSale: 'Transfer to Sale',
      sellOnWB: 'Sell on WB',
      dispose: 'Dispose',
      disposeIn7Days: 'Dispose in 7 days',
      sendToSeller: 'Return to Seller',
      // Filters
      searchPlaceholder: 'Search by product, SKU, barcode, return number...',
      dateFrom: 'Date from',
      dateTo: 'Date to',
      allStatuses: 'All Statuses',
      filterByDefect: 'Filter by defect',
      applyFilters: 'Apply Filters',
      clearFilters: 'Clear Filters',
      // Confirmations and warnings
      confirmNeedsCheckTitle: 'Confirm Verification Request',
      confirmNeedsCheckMessage: 'Are you sure you want to request verification? This action is irreversible and cannot be undone.',
      alsoRequirePhotoVideo: 'Also require photo/video',
      confirmAction: 'Yes, Request Verification',
      deliveryAddressRequired: 'Please fill in your delivery address in your profile before requesting product return.',
      // Status change modal
      chooseAction: 'Choose Action',
      statusChangeTitle: 'Decision on Product',
      statusChangeMessage: 'Choose what to do with this product:',
      confirmStatusChange: 'Confirm',
      photoVideoRequiresCheck: 'Photo/video can only be required when verification is enabled.',
      errorPhotoVideoWithoutCheck: 'Cannot enable photo/video requirement without verification. Please enable verification first.',
      errorCannotDisableCheck: 'Cannot disable verification. This setting is irreversible.',
      errorUpdateFailed: 'Failed to update. Please try again.',
      // Table states
      noItemsFound: 'No items found',
      loadingItems: 'Loading items...',
      errorLoadingItems: 'Error loading items',
      // Pagination
      showingItems: 'Showing {{from}}-{{to}} of {{total}} items',
      itemsPerPage: 'Items per page',
      // Links
      downloadAttachment: 'Download attachment',
      attachmentCommentPlaceholder: 'Comment on this verification photo',
      saveAttachmentComment: 'Save comment',
      bulkSelectColumn: 'Select row',
      bulkSelectPage: 'Select all on page',
      bulkClearSelection: 'Clear selection',
      bulkSelectedCount: 'Selected: {{count}}',
      bulkNeedsCheckOn: 'Verification: yes (selected)',
      bulkNeedsCheckOff: 'Verification: no (selected)',
      bulkNeedsCheckPending: 'Request verification (selected)',
      bulkPhotoVideoOn: 'Require photo/video (selected)',
      bulkDecisionForSelected: 'Decision for selected…',
      bulkStatusModalIntro: 'Bulk action',
      bulkStatusModalCount: '{{count}} items',
      bulkConfirmNeedsCheckCount:
        'Request verification for {{count}} items? This cannot be undone.',
      bulkPartialFailure:
        '{{failed}} of {{total}} items could not be updated. The list has been refreshed.',
    },
    // Support Chat
    support: {
      chat: {
        connectionError: 'Connection error. Please check your connection to the server.',
        connectionErrorNoToken: 'Authorization token not found. Please log in again.',
        reconnectError: 'Failed to reconnect to chat',
        connectionClosed: 'Chat connection closed',
      },
      supportChat: 'Support Chat',
      chatWith: 'Chat with',
      online: 'Online',
      archived: 'Archived',
      chatNotFound: 'Chat not found',
      enterMessage: 'Enter message...',
      send: 'Send',
      justNow: 'just now',
      goToChat: 'Go to Chat',
      support: 'Support',
      allChats: 'All Chats',
      myChats: 'My Chats',
      archive: 'Archive',
      active: 'Active',
      newChat: 'New Chat',
      searchChats: 'Search chats...',
      search: 'Search...',
      nothingFound: 'Nothing found',
      noChats: 'No chats',
      noChatsYet: 'You don\'t have any chats yet',
      open: 'Open',
      closed: 'Closed',
      unarchive: 'Unarchive',
      toArchive: 'To Archive',
      noSelectedChat: 'No selected chat',
      selectChatToView: 'Select a chat to view',
      newSupportChat: 'New Support Chat',
      subject: 'Subject',
      describeProblem: 'Describe your problem...',
      create: 'Create',
      cancel: 'Cancel',
      failedToLoadChats: 'Failed to load chats',
      failedToChangeArchive: 'Failed to change archive status',
      failedToCreateChat: 'Failed to create chat',
      failedToLoadChat: 'Failed to load chat',
      failedToUploadFile: 'Failed to upload file',
      chatInArchive: 'Chat is archived. Sending messages is not available.',
      attachment: '[Attachment]',
      minutesAgo: '{{minutes}} min ago',
      invalidFileType: 'Unsupported file type. Allowed: images ({{imageExts}}) and videos ({{videoExts}})',
      fileSizeExceeded: 'File size must not exceed 50MB. Current size: {{currentSize}}MB',
      reply: 'Reply',
      replyToMessage: 'Reply to message',
      primaryTab: 'Personal inboxes',
      openOldThreads: 'Old threads',
      backToMainChat: 'Back to main chat',
      filterByStoreId: 'Store ID (filter)',
      markAsUnread: 'Mark as unread',
      markUnreadFailed: 'Could not mark as unread',
      aiSuggestTitle: 'AI reply draft',
      aiSuggestHint:
        'Paste the customer question (Ctrl+V), get a draft, then edit and send yourself. Nothing is sent automatically.',
      aiSuggestPasteClipboard: 'Paste from clipboard',
      aiSuggestGetDraft: 'Get AI draft',
      aiSuggestInsert: 'Insert into message',
      aiSuggestLoading: 'Generating…',
      aiSuggestError: 'Could not get AI draft.',
      broadcastTitle: 'Broadcast to user chats',
      broadcastOpen: 'Broadcast',
      broadcastAudience: 'Audience',
      broadcastAudienceAll: 'All clients (active, non-admin)',
      broadcastAudienceStore: 'Users who have a store whose ID contains',
      broadcastAudienceUsers: 'Specific users (by user ID)',
      broadcastStoreIdHint: 'Substring of WB store_id (same as list filter)',
      broadcastUserIdsHint: 'Comma-separated numeric IDs, e.g. 12, 34, 56',
      broadcastUserIdsLabel: 'User IDs',
      broadcastMessageLabel: 'Message text',
      broadcastTranslatedLabel: 'Admin translation / note (optional, stored as translated_content)',
      broadcastSend: 'Send to all targets',
      broadcastSending: 'Sending…',
      broadcastDone: 'Done: sent {{sent}}, failed {{failed}}.',
      broadcastError: 'Broadcast failed',
      broadcastSuperuserOnly: 'Only superusers can send broadcasts.',
      broadcastConfirm: 'Send this message to every user in the selected audience?',
      broadcastNeedStoreId: 'Enter a store ID substring.',
      broadcastNeedUserIds: 'Enter at least one numeric user ID.',
    },
  },
  ru: {
    // Navigation
    nav: {
      allStores: 'Все магазины',
      addStore: 'Добавить магазин',
      billings: 'Биллинг',
      accounts: 'Счета',
      support: 'Поддержка',
      profile: 'Профиль',
      signOut: 'Выход',
      selectStore: 'Выбрать магазин',
      adminOrders: 'Админ: Заказы',
      adminSupport: 'Админ: Поддержка',
      adminBillings: 'Биллинг',
      findReturnByShk: 'Найти возврат по штрихкоду',
      enterAsClient: 'Войти как клиент',
      createSuperuser: 'Создать суперадмина',
      exitImpersonation: 'Выйти в мой аккаунт',
      goodsOnSale: 'Товары в продаже',
      adminWbReturns: 'Все возвраты WB',
      adminConsole: 'Аналитика',
      adminReports: 'Отчёты',
      highlightStores: 'Подсветка по магазину',
      notifications: 'Уведомления',
    },
    adminConsole: {
      title: 'Консоль',
      subtitle: 'Запуск серверных команд аудита (суперадмин). Вывод как у manage.py.',
      storeIdOptional: 'WB store_id (необязательно)',
      storeIdPlaceholder: 'Все магазины, если пусто',
      cmdAuditSnapshot: 'audit_order_snapshot_mismatches (сводка)',
      running: 'Выполняется…',
      clear: 'Очистить вывод',
      outputTitle: 'Вывод',
      outputEmpty: 'Запустите команду, чтобы увидеть результат.',
      runFailed: 'Ошибка выполнения команды',
      elapsed: 'Готово за {{ms}} мс',
    },
    adminReports: {
      title: 'Отчёты',
      store: 'Магазин (необязательно)',
      storePlaceholder: 'Все магазины — поиск по ID или названию…',
      week: 'Неделя',
      pvz: 'ПВЗ',
      pvzAll: 'Все ПВЗ',
      pvzOur: 'Все наши ПВЗ',
      pvzShosseynaya: 'Шоссейная 4к3',
      pvzProezd: 'Проезд 3723',
      apply: 'Применить',
      loadError: 'Не удалось загрузить отчёт.',
      exportError: 'Ошибка выгрузки.',
      pulseTitle: 'Пульс склада',
      pulseLoading: 'Загрузка пульса склада…',
      refreshPulse: 'Обновить пульс',
      pulseAccepted: 'Всего принятых возвратов',
      pulseTotalDebt: 'Общий долг',
      pulseTotalDebtHint: 'Выдано (WB), но нет списания за приёмку',
      pulseDebt72h: 'Долг за 72ч',
      pulseDebt72hHint: 'Выдано за последние 72 часа без списания за приёмку',
      pulseTopUps: 'Пополнения (всё время)',
      pulseCharges: 'Списания',
      pulseActiveUsers: 'Активные пользователи (96ч)',
      pulseSupport: 'Сообщения в поддержку (24ч)',
      pulseErrors: 'Ошибки задач (24ч)',
      pulseErrorsHint: 'Celery; HTTP 500 — Graylog/Sentry',
      techLoad: 'Load avg',
      techMem: 'Память процесса',
      downloadErrorsLog: 'Скачать лог ошибок',
      weekCardTitle: 'Отчёт за неделю',
      weeklyFiltersTitle: 'Фильтры недельного отчёта',
      dailyTitle: 'По дням',
      metricReceipts: 'Принято (списания за приёмку)',
      metricWbReceived: 'Получено по WB (completedDt)',
      metricAvgAccept: 'Среднее время приёмки',
      sectionUsers: 'Пользователи и магазины',
      newUsers: 'Новые пользователи',
      usersLoggedIn: 'Входили в систему',
      newStores: 'Новые магазины',
      avgDailyLogins: 'Средняя активность (входы/день)',
      unregisteredWb: 'Не зарегистрированы в WB',
      unregisteredWbHint: 'За 96ч: заказы без Store.store_id',
      sectionBilling: 'Биллинг и пополнения',
      billingWeekHint: 'Пополнения и списания только за выбранную неделю (по billing_date или created_at, если дата пустая).',
      topUps: 'Пополнения',
      charges: 'Списания',
      debtors: 'Должники',
      chargeType: 'Тип списания',
      colStore: 'Магазин',
      colDebt: 'Долг',
      colLastPayment: 'Последняя оплата',
      totalDebt: 'Сумма долга',
      sectionProblems: 'Проблемы и аномалии',
      anomalyAcceptBefore: 'Приёмка раньше получения',
      noReceiptCompleted: 'completedDt без приёмки',
      completed72h: '>72ч без приёмки',
      acceptedInTransit: 'Принят, статус «В пути в пвз»',
      issuedTitle: 'Выданные товары',
      dateFrom: 'Дата с',
      dateTo: 'Дата по',
      loadIssued: 'Загрузить таблицу',
      refreshIssued: 'Обновить',
      exportExcel: 'Скачать Excel',
      exportExcelShort: 'Excel',
      issuedSearch: 'Поиск',
      issuedSearchPlaceholder: 'srid, штрихкод, магазин, товар…',
      issuedEmpty: 'Нет выданных товаров по выбранным фильтрам.',
      pageOf: 'Стр. {{page}} из {{total}}',
      prevPage: 'Назад',
      nextPage: 'Вперёд',
      debtorsTopHint: 'Показаны топ-{{n}} должников (всего {{total}})',
      topStoresShown: 'показаны топ-{{n}}',
      pulsePartialError: 'Метрики долга временно недоступны',
      returnsSource: 'Тип возврата',
      returnsSourceAll: 'Оба',
      returnsSourceForeign: 'Зарубежный',
      returnsSourceInternal: 'Внутренний',
      acceptStatusFilter: 'Статус приёмки',
      acceptStatusAll: 'Любой',
      acceptStatusYes: 'Принято',
      acceptStatusNo: 'Не принято',
      datesOptional: 'Даты необязательны — без них все выданные товары',
      reportLoading: 'Загрузка недельного отчёта…',
      rows: 'строк',
      colAccept: 'Статус приёмки',
      colProduct: 'Товар',
      colBarcode: 'Штрихкод',
      colDeliveryAddress: 'Адрес доставки',
      colStatus: 'Статус',
    },
    notifications: {
      empty: 'Нет уведомлений',
      markRead: 'Ознакомился',
      languageLabel: 'Язык отображения',
      apiTokenTitle: 'Проверка API-ключа не пройдена',
      apiTokenBody:
        'Плановая проверка не удалась для магазина «{{storeName}}». Обновите API-ключ маркетплейса, чтобы восстановить синхронизацию.',
      addApiToken: 'Добавить API-ключ',
      apiTokenDismiss: 'Скрыть до следующего входа',
    },
    errors: {
      serviceUnavailable:
        'Сервис временно недоступен: возможны технические работы или перезапуск сервера. Подождите несколько минут и обновите страницу.',
      serviceUnavailableShort:
        'Сайт временно недоступен (технические работы или перезапуск). Попробуйте через несколько минут.',
      unknown: 'Произошла ошибка. Попробуйте снова.',
    },
    adminHighlight: {
      navButton: 'Подсветка по магазину',
      title: 'Подсветка заказов по магазинам',
      intro:
        'Выберите магазины: строки с их заказами в админских таблицах получат красную рамку (Заказы, Биллинг, отчёт WB по выбранному магазину). Настройка хранится только в этом браузере. Только для суперпользователя.',
      searchLabel: 'Поиск магазинов',
      searchPlaceholder: 'Название, ID магазина WB, email владельца…',
      searching: 'Поиск…',
      searchError: 'Не удалось загрузить магазины',
      noMatches: 'Нет совпадений',
      summary: 'Выбраны магазины',
      noneSelected: 'Нет',
      reopenSearch: 'найдите в поиске, чтобы сохранить',
      selected: 'Да',
      unnamedStore: 'Магазин',
      clearAll: 'Сбросить всё и закрыть',
      cancel: 'Отмена',
      save: 'Сохранить',
    },
    adminSuperuser: {
      title: 'Создать суперадмина',
      intro:
        'Создаётся ещё один пользователь с полными правами суперпользователя (как у вас). Аккаунт активен, email считается подтверждённым.',
      email: 'Email',
      password: 'Пароль',
      passwordConfirm: 'Повтор пароля',
      submit: 'Создать',
      close: 'Закрыть',
      emailRequired: 'Укажите email.',
      passwordTooShort: 'Пароль не короче 8 символов.',
      passwordMismatch: 'Пароли не совпадают.',
      createFailed: 'Не удалось создать пользователя.',
      created: 'Суперадмин создан: {{email}}',
    },
    adminStaffStatus: {
      title: 'Аналитика сотрудников',
      intro:
        'Переходы статусов заказов с указанием оператора (из / в), суммарно по каждому пользователю за выбранный период. Учитываются только записи, где зафиксирован автор смены.',
      dateFrom: 'Дата с',
      dateTo: 'Дата по',
      load: 'Загрузить',
      loadError: 'Не удалось загрузить аналитику.',
      colEmail: 'Оператор (email)',
      colTotal: 'Переходов',
      colTransitions: 'Кратко',
      empty: 'Нет данных за период.',
      from: 'Из статуса',
      to: 'В статус',
      count: 'Кол-во',
    },
    wbAdminReturns: {
      title: 'Все возвраты WB (Analytics)',
      intro:
        'Данные из таблицы-снимка (обновление из WB каждые 4 ч). По умолчанию — все строки (постранично). Сузьте по группе ПВЗ, опциональному интервалу по полям WB, магазину, isStatusActive и поиску; Enter или «Применить». Клик по строке — дополнительные поля (снимок, магазин, бренд и т.д.).',
      store: 'Магазин (Wildberries)',
      storeOptional: 'Магазин (необязательно)',
      storeOptionalHint:
        'Пусто — все магазины. Выбор — только этот магазин (id в БД / продавец WB).',
      storePlaceholder: '— выберите —',
      storeSearchPlaceholder: 'Поиск по ID магазина WB, названию или email владельца…',
      storeSearchHint: 'Показываются только магазины Wildberries с сохранённым API-ключом.',
      storeSearching: 'Поиск…',
      storeSearchError: 'Не удалось загрузить список магазинов',
      storeNoMatches: 'Нет магазинов с ключом по запросу',
      storeClear: 'Сбросить',
      year: 'Год',
      month: 'Месяц',
      dateFrom: 'Дата с',
      dateTo: 'Дата по',
      load: 'Загрузить из БД',
      restrictByMonth: 'Только календарный месяц (orderDt)',
      allSnapshotsHint: 'Без галочки — все снимки в БД (постранично). Фильтры необязательны.',
      orderDtFrom: 'Дата заказа (orderDt) с',
      orderDtTo: 'Дата заказа по',
      isStatusActive: 'isStatusActive',
      anyActive: 'Любой',
      acceptStatusFilter: 'Статус приёмки',
      acceptStatusAll: 'Любой',
      acceptYes: 'Принято',
      acceptNo: 'Не принято',
      returnsSourceFilter: 'Тип возврата',
      returnsSourceAll: 'Все',
      returnsSourceForeign: 'Зарубежный',
      returnsSourceInternal: 'Внутренний',
      applyFilters: 'Применить / обновить',
      exactMatch: 'Точное совпадение (сервер)',
      storesInResult: 'Магазинов в выборке',
      loading: 'Загрузка…',
      downloadExcel: 'Скачать Excel',
      exporting: 'Экспорт…',
      lastSynced: 'Снимок обновлён (UTC)',
      pagePrev: 'Предыдущая страница',
      pageNext: 'Следующая страница',
      filterByStoreDb: 'Store id (БД)',
      orderColumn: 'Заказ',
      addToOrder: 'В Order',
      addingToOrder: 'Сохранение…',
      addToOrderDone: 'Заказ создан или уже был',
      addToOrderError: 'Не удалось создать заказ',
      shkIdSearch: 'ShkId (основной)',
      shkIdPlaceholder: 'Фильтр по ShkId…',
      search: 'Все колонки',
      searchPlaceholder: 'Адрес ПВЗ, srid, shkId, stickerId, orderId, штрихкод, бренд…',
      searchHint:
        'Enter — применить фильтры. Подстрока в текстовых полях; числовые id — точное совпадение.',
      filterByStore: 'WB seller id',
      allStores: 'Все магазины',
      returnType: 'Тип возврата',
      status: 'Статус',
      allReturnTypes: 'Все типы возврата',
      allStatuses: 'Все статусы',
      records: 'Строк',
      storesLoaded: 'Магазинов опрошено',
      storesSkipped: 'пропуск / ошибка',
      partialStoreErrors: 'Часть магазинов с ошибкой (остальные строки показаны):',
      storePk: 'Магазин id',
      noRows: 'Нет строк снимка (ещё не было синхронизации или фильтры исключили всё).',
      selectStoreHint: 'Выберите магазин Wildberries.',
      loadError: 'Не удалось загрузить данные',
      exportError: 'Не удалось выгрузить Excel',
      pvzScope: 'ПВЗ (адрес доставки)',
      pvzScopeAll: 'Все ПВЗ',
      pvzShosseynaya: 'Шоссейная 4к3',
      pvzProezd3723: 'Проезд 3723',
      pvzOurWarehouse: 'Наш склад (50156464)',
      pvzOurPvz: 'Наш ПВЗ (50173297)',
      pvzOther: 'Другие ПВЗ',
      wbDtFrom: 'Даты WB с',
      wbDtTo: 'Даты WB по',
      wbDtFieldsLabel: 'Интервал по полям (ИЛИ)',
      wbFieldCompletedDt: 'Время выдачи товара (completedDt)',
      wbFieldReadyToReturnDt: 'Время готовности к выдаче (readyToReturnDt)',
      wbFieldExpiredDt: 'Время когда истёк срок хранения на ПВЗ (expiredDt)',
      wbFieldOrderDt: 'Время когда сделали заказ по возврату (orderDt)',
      wbDtHint:
        'Отметьте хотя бы одно поле и укажите обе даты; строка попадает в выборку, если хотя бы одно из полей попадает в интервал.',
      detailFieldsTitle: 'Дополнительные поля (клик по строке)',
      colSnapshotId: 'ID снимка',
      colStoreSellerId: 'Магазин (seller id WB)',
      colStoreDbId: 'Магазин (id в БД)',
      colStoreName: 'Название магазина',
      colSrid: 'srid',
      colNmId: 'nmId',
      colBarcode: 'Штрихкод',
      colBrand: 'Бренд',
      colSubjectName: 'Предмет',
      colTechSize: 'Размер',
      colReturnType: 'Тип возврата',
      colReason: 'Причина',
      colStatus: 'Статус',
      colAcceptStatus: 'Статус приёмки',
      colReturnsSource: 'Тип возврата',
      colOrderDt: 'Время когда сделали заказ по возврату',
      colOrderId: 'orderId',
      colCompletedDt: 'Время выдачи товара',
      colReadyToReturnDt: 'Время готовности к выдаче',
      colExpiredDt: 'Время когда истёк срок хранения на ПВЗ',
      colDstOfficeAddress: 'Адрес ПВЗ',
      colDstOfficeId: 'ID ПВЗ выдачи',
      colIsStatusActive: 'Активность возврата',
      colShkId: 'ШК (shkId)',
      colStickerId: 'Стикер (stickerId)',
    },
    impersonate: {
      title: 'Войти как клиент',
      searchPlaceholder: 'Поиск по email или имени...',
      search: 'Найти',
      selectUser: 'Выберите пользователя, чтобы открыть приложение от его имени',
      noUsers: 'Пользователи не найдены',
      loading: 'Загрузка...',
      entering: 'Вход...',
      error: 'Не удалось войти как клиент',
      openAsUser: 'Открыть от его имени',
    },
    billing: {
      title: 'Счета',
      currentBalance: 'Текущий баланс',
      topUp: 'Пополнение',
      deducted: 'Списано',
      dateFrom: 'Дата с (начисление, billing_date)',
      dateTo: 'Дата по (начисление, billing_date)',
      type: 'Тип',
      orderNo: 'Номер заказа',
      searchProductBarcode: 'Товар, штрихкод...',
      apply: 'Применить',
      downloadExcel: 'Скачать Excel',
      downloadPdf: 'Скачать PDF-отчёт',
      accountsPdfFilename: 'accounts_report',
      noExpenses: 'Нет списаний за выбранный период.',
      shownOf: 'Показано {{from}}–{{to}} из {{total}}',
      perPage: 'на странице',
      back: 'Назад',
      next: 'Вперёд',
      pageOf: 'Стр. {{page}} из {{total}}',
      date: 'Дата',
      service: 'Услуга',
      orderStatus: 'Статус заказа',
      orderDate: 'Дата заказа',
      product: 'Товар',
      amount: 'Сумма (¥)',
      allTypes: 'Все типы',
      type_storage_daily: 'Хранение за обработку заказа на Flydarin',
      type_storage_warehouse: 'Хранение за наличие товара на нашем складе при продаже на МП',
      type_prepare_return_to_seller: 'Отправка товара обратно продавцу',
      type_disposal: 'Утилизация',
      type_packaging_shipment: 'Отгрузка товара покупателю',
      type_inspection_no_media: 'Проверка товара',
      type_inspection_with_media: 'Проверка бракованного товара с фотографиями',
      type_receipt_warehouse: 'Приёмка товара на нашем складе',
      type_receipt_pickup: 'Приёмка товара на стороннем ПВЗ',
      type_balance_top_up: 'Пополнение баланса',
      whStockUnits: 'Кол-во (склад WH)',
      byStore: 'По магазинам',
      depositWarningBanner: 'Внимание! Согласно условиям сотрудничества, описанным в оферте, при отрицательном балансе Flydarin сможет только принимать, проверять и хранить товары, а передача их в продажу осуществляться не будет. Для бесперебойной работы, пожалуйста, пополните баланс через AliPay по QR-коду на данной странице. Минимальная сумма депозита при подключении 1 магазина = 1000 юаней, 2 магазинов = 700 юаней за каждый, 3 и более магазинов = 500 юаней за каждый. Средства будут зачислены на баланс в течение 24 часов.',
      sendReceiptHint: 'Пожалуйста, обязательно пришлите после оплаты депозита чек или скриншот.',
      sendReceiptButton: 'Отправить чек',
      payWithAlipay: 'Оплатить через AliPay',
      payWithAlipayHint:
        'Выберите магазин и укажите любую сумму пополнения в юанях. После подтверждения оплаты в Alipay баланс обновится автоматически; чек для этого способа не обязателен.',
      payWithAlipayCustomHint:
        'Введите сумму пополнения для выбранного магазина и откройте официальную страницу оплаты Alipay.',
      payWithAlipayStoreLabel: 'Магазин',
      payWithAlipayAmountLabel: 'Сумма пополнения (CNY)',
      payWithAlipayFillDebt: 'Подставить долг ({{amount}} ¥)',
      payWithAlipayAmountRequired: 'Укажите корректную сумму (минимум 0,01 ¥).',
      payWithAlipayStoreRequired: 'Выберите магазин.',
      payWithAlipayNoStores: 'К аккаунту не привязано ни одного магазина.',
      payWithAlipayPagePrimaryHint:
        'Рекомендуется: оплата в этом браузере — откроется официальная страница Alipay (alipay.trade.page.pay).',
      payWithAlipayPageNewTab: 'Открыть в новой вкладке',
      payWithAlipayNegativeOnly: 'Оплата по «живому» QR доступна только при отрицательном балансе магазина.',
      payWithAlipayButton: 'Получить QR для оплаты',
      payWithAlipayAmount: 'Сумма',
      payWithAlipayOrderNo: '№ заказа',
      payWithAlipayReused: 'Используется ранее созданный неоплаченный QR (ещё действителен)',
      payWithAlipayScanHint: 'Откройте AliPay и отсканируйте код.',
      payWithAlipayCreditHint: 'После подтверждения оплаты AliPay пополнение зачисляется автоматически; чек для этого способа не обязателен.',
      payWithAlipayCopyPayload: 'Скопировать данные QR',
      payWithAlipayCopied: 'Скопировано',
      payWithAlipayPageButton: 'Открыть страницу AliPay',
      payWithAlipayPagePopupBlocked: 'Браузер заблокировал всплывающее окно. Разрешите pop-up и повторите.',
      payWithAlipayPageNoUrl: 'Не удалось получить ссылку оплаты AliPay.',
      accountsPeriodSummaryTitle: 'Сводка за период',
      accountsSummaryTotalTitle: 'Всего списано',
      accountsSummaryByService: 'По типам услуг',
      accountsSummaryNoCharges: 'За этот период при текущих фильтрах списаний нет.',
      accountsSummaryActivityTitle: 'Возвраты за период',
      accountsSummaryNewReturnsLine: 'Новых возвратов: {{total}} · наш ПВЗ: {{our}} · другой ПВЗ: {{other}}',
      accountsSummaryCompletedLine:
        'Дошли до завершения (в продаже, отправлен продавцу, утилизирован и т.д.): {{total}} · наш ПВЗ: {{our}} · другой: {{other}}',
      accountsSummaryTableHint: 'В таблице ниже нажмите «Детали» у строки товара — история статусов и каждая строка списания.',
      accountsStatusHistoryTranslatedHint: 'Названия статусов показаны на языке интерфейса.',
      accountsPeriodRange: '{{from}} — {{to}}',
      accountsSelectedPeriodLabel: 'Выбранный период',
      accountsAllTimeLabel: 'За всё время',
      accountsQuickPeriod: 'Быстрый период',
      accountsQuickPeriodCustom: 'Вручную (даты ниже)',
      accountsQuickAllTime: 'За всё время',
      accountsQuickToday: 'Текущий день',
      accountsQuickWeek: 'Текущая неделя (пн — сегодня)',
      accountsQuickMonth: 'Текущий месяц',
      accountsQuickQuarter: 'Текущий квартал',
      accountsWeekTitle: 'Сводка за период',
      accountsWeekNewOrders: 'Новые заказы (созданы за период)',
      accountsWeekCreatedOurPvz: 'Новые заказы · наш ПВЗ возврата',
      accountsWeekCreatedOtherPvz: 'Новые заказы · сторонний ПВЗ',
      accountsWeekProcessedFinal: 'Переведено в финальный статус за период',
      accountsWeekProcessedOurPvz: 'Финальный статус · наш ПВЗ',
      accountsWeekProcessedOtherPvz: 'Финальный статус · сторонний ПВЗ',
      accountsWeekChargesTotal: 'Списания за период (¥)',
      accountsWeekChargesByType: 'Списания по типу',
      accountsAllStores: 'Все магазины',
      accountsStoreFilterPlaceholder: 'Поиск магазина по названию или ID…',
      accountsStoreNoMatches: 'Нет подходящих магазинов',
      accountsStoreColumn: 'Магазин',
      accountsSortLabel: 'Сортировка таблицы',
      accountsSortStore: 'По магазину',
      accountsSortProduct: 'По товару',
      accountsSortBarcode: 'По штрихкоду',
      accountsSortCharges: 'По сумме списаний',
      accountsBarcode: 'Штрихкод',
      accountsNmId: 'nm ID',
      accountsPrice: 'Цена',
      accountsReturnsCount: 'Возвратов',
      accountsInSaleOnWarehouse: 'В продаже, на складе',
      accountsInSaleOnWarehouseHint:
        'Товары, которые находятся у нас на складе как активный остаток и выставлены на продажу на маркетплейсе.',
      accountsWhBuyerShipments: 'Отгрузки покупателям',
      accountsWhBuyerShipmentsHint:
        'Заказы с этим штрихкодом, по которым есть списание за отгрузку, созданное по отчётам Warehouse Hub API.',
      accountsTotalCharges: 'Сумма списаний (¥)',
      accountsDetailColumn: 'Детали',
      accountsExpand: 'Подробнее',
      accountsCollapse: 'Скрыть',
      accountsChargeType: 'Тип списания',
      accountsStatusHistory: 'История статусов',
      accountsReturnTotals: 'Итого по возврату',
      accountsByChargeType: 'По типу списания',
      accountsExpandChargeLines: 'Строки списаний',
      accountsCollapseChargeLines: 'Скрыть строки',
      accountsNoBarcodeRows: 'Нет данных по выбранным фильтрам.',
      accountsTopUpsTitle: 'Пополнения баланса',
      accountsTopUpsHint: 'Транзакции пополнения кошелька за выбранный период и магазин.',
      accountsTopUpsLimited: 'Показано {{count}} из {{total}} последних транзакций.',
      accountsTopUpsComment: 'Комментарий',
      accountsNoTopUps: 'Пополнений баланса по выбранным фильтрам нет.',
      accountsTopUpsExportFilename: 'accounts_top_ups',
      accountsCustomChargesTitle: 'Списания по согласованию с клиентом',
      accountsCustomChargesHint: 'Ручные списания по магазину без привязки к заказу за выбранный период.',
      accountsCustomChargesLimited: 'Показано {{count}} из {{total}} последних транзакций.',
      accountsCustomChargesComment: 'Комментарий',
      accountsNoCustomCharges: 'Согласованных списаний по выбранным фильтрам нет.',
      accountsCustomChargesExportFilename: 'accounts_custom_charges',
      accountsExportFilename: 'accounts_by_barcode',
      accountsStatusAwaitingReceipt: 'Ожидает получения в WB',
      accountsStatusReceivedAwaitingCheck: 'Получен, ожидает проверки',
      accountsStatusAwaitingSellerDecision: 'Ожидает решения продавцом',
      accountsStatusAwaitingForSale: 'Ожидает передачи в продажу',
      accountsStatusTransferringToSale: 'Передаётся на продажу',
      accountsStatusSubmittedForSale: 'Передан в продажу',
      accountsStatusAwaitingShipment: 'Ожидает отправки продавцу',
      accountsStatusAwaitingDisposal: 'Ожидает утилизации',
      accountsStatusDisposed: 'Утилизирован',
      accountsStatusSentToSeller: 'Отправлен продавцу',
      accountsChargeNameReceiptWarehouse: 'Приёмка товара на нашем складе',
      accountsChargeNameReceiptPickup: 'Приёмка товара на стороннем ПВЗ',
      accountsChargeNameInspectionNoMedia: 'Проверка товара',
      accountsChargeNameInspectionWithMedia: 'Проверка бракованного товара с фотографиями',
      accountsChargeNamePackagingShipment: 'Отгрузка товара покупателю',
      accountsChargeNameStorageAtWarehouse: 'Хранение на складе (Flydarin + МП)',
      accountsChargeNamePrepareReturn: 'Отправка товара обратно продавцу',
      accountsChargeNameDisposal: 'Утилизация товара',
      accountsChargeNameBalanceTopUp: 'Пополнение баланса',
      accountsChargeTooltipReceiptWarehouse:
        'Пункт тарифа 1: приёмка товара или возврата на складе — 2,0 ¥ за единицу.',
      accountsChargeTooltipReceiptPickup:
        'Пункт 2: приёмка в пункте выдачи — 5,5 ¥ за единицу.',
      accountsChargeTooltipInspectionNoMedia:
        'Пункт 3: проверка товара — 2,0 ¥ за единицу.',
      accountsChargeTooltipInspectionWithMedia:
        'Пункт 4: проверка бракованного товара с фотографиями — 3,5 ¥ за единицу.',
      accountsChargeTooltipPackagingShipment:
        'Пункт 5: отгрузка товара покупателю (упаковка и отправка на МП) — ступени по сумме сторон (Д+Ш+В в см), от 10,5 ¥ до 90 ¥ за негабарит.',
      accountsChargeTooltipStorageAtWarehouse:
        'Пункт 6: 13,5 ¥ за 1 м³ в сутки. Включает хранение за обработку заказа на Flydarin (storage_daily) и хранение при продаже на МП (storage_warehouse); в сводке — одной строкой.',
      accountsChargeTooltipPrepareReturn:
        'Пункт 7: отправка товара обратно продавцу — 3,5 ¥ за единицу.',
      accountsChargeTooltipDisposal:
        'Утилизация: по умолчанию масса брутто (кг) из карточки WB × 3,5 ¥ за позицию; администратор может задать сумму вручную.',
      accountsChargeTooltipBalanceTopUp: 'Пополнение баланса (не услуга).',
    },
    findReturnByShk: {
      title: 'Найти возврат по штрихкоду (shkId)',
      storePlaceholder: 'Поиск магазина по названию, ID или email...',
      shkIdsPlaceholder: 'Введите shkId (по одному на строку или через запятую)',
      shkIdsHint: 'Несколько значений: по одному на строку или через запятую/точку с запятой.',
      addSet: 'Добавить ещё магазин',
      submit: 'Найти',
      searching: 'Поиск...',
      storeLabel: 'Магазин',
      found: 'Найдено',
      notFound: 'Не найдено',
      alreadyInDb: 'Уже в системе',
      editOrder: 'Редактировать',
      viewEdit: 'Просмотр / Редактирование',
      deleteOrder: 'Удалить заказ',
      confirmDelete: 'Удалить этот заказ? Действие необратимо.',
      created: 'Создан',
      deleted: 'Удалён',
      error: 'Ошибка',
      noStoreSelected: 'Выберите магазин',
      noShkIds: 'Введите хотя бы один shkId',
      resultsTitle: 'Результаты',
      removeRow: 'Удалить',
    },
    // Dashboard cards
    dashboard: {
      inTransit: 'В пути в',
      warehouse: 'ИндигоСклад',
      storedIn: 'Хранятся в',
      completedReturns: 'Реализовано возвратов',
      returnRequests: 'Заявки на возврат',
      ordersInProcessing: 'Заказы в обработке',
      ordersPendingDecision: 'Ожидают решения',
      completedOrders: 'Завершённые заказы',
      items: 'товаров',
      or: 'или',
      viewItemsInTransit: 'Посмотреть товары в пути',
      viewReturnsOtherPvz: 'Перейти к возвратам в другие ПВЗ',
      viewReturnData: 'Изучить данные о возвратах',
      viewFinancialReport: 'Посмотреть финансовый отчет',
      processReturns: 'Проработать возвраты',
      viewProcessingOrders: 'Посмотреть заказы',
      viewCompletedOrders: 'Посмотреть завершённые',
    },
    // Add Store Modal
    addStore: {
      title: 'Добавить магазин',
      selectMarketplace: 'Выберите маркетплейс',
      wildberries: 'Wildberries',
      ozon: 'Ozon',
      yandexMarket: 'Яндекс Маркет',
      comingSoon: 'Скоро',
      storeName: 'Название магазина',
      storeNamePlaceholder: 'Мой магазин',
      storeNameHint: 'Дайте магазину имя для удобной идентификации',
      enterApiKey: 'Введите JWT API ключ',
      apiKeyPlaceholder: 'Вставьте ваш JWT API ключ сюда...',
      cancel: 'Отмена',
      add: 'Добавить магазин',
      adding: 'Добавление...',
      success: 'Магазин успешно добавлен!',
      error: 'Не удалось добавить магазин',
      invalidToken: 'Недействительный или просроченный токен',
      storeExists: 'Этот магазин уже подключен',
    },
    // Profile
    profile: {
      title: 'Информация профиля',
      email: 'Email',
      emailCannotChange: 'Email нельзя изменить',
      wechatId: 'WeChat ID',
      telegramUsername: 'Telegram',
      messengerHint: 'Контакты в мессенджерах',
      firstName: 'Имя',
      lastName: 'Фамилия',
      accountStatus: 'Статус аккаунта',
      emailVerified: 'Email подтвержден',
      memberSince: 'Дата регистрации',
      edit: 'Редактировать',
      save: 'Сохранить',
      saving: 'Сохранение...',
      cancel: 'Отмена',
      updateSuccess: 'Профиль успешно обновлен!',
      updateError: 'Не удалось обновить профиль. Попробуйте снова.',
      // Delivery address
      deliveryAddressTitle: 'Адрес доставки',
      deliveryAddressDescription: 'Ваш адрес доставки необходим для получения возвратов товаров.',
      deliveryAddressWarning: 'Пожалуйста, заполните адрес доставки, чтобы иметь возможность запрашивать возврат товаров.',
      addressUpdateSuccess: 'Адрес успешно обновлен!',
      addressStreet: 'Улица, дом, квартира',
      addressStreetPlaceholder: 'ул. Примерная, д. 123, кв. 4',
      addressCity: 'Город',
      addressCityPlaceholder: 'Москва',
      addressPostalCode: 'Почтовый индекс',
      addressPostalCodePlaceholder: '123456',
      addressCountry: 'Страна',
      addressCountryPlaceholder: 'Россия',
      addressPhone: 'Телефон',
      addressPhonePlaceholder: '+7 (999) 123-45-67',
      // Legal documents
      documentsTitle: 'Документы юридического лица',
      documentsDescription: 'Загрузите PDF документы, связанные с вашим юридическим лицом. Максимальный размер файла: 10МБ.',
      documentsUpload: 'Загрузить PDF',
      documentsUploading: 'Загрузка...',
      documentsEmpty: 'Документы еще не загружены',
      documentsOnlyPdf: 'Разрешены только PDF файлы',
      documentsMaxSize: 'Размер файла не может превышать 10МБ',
      documentsUploadSuccess: 'Документ успешно загружен!',
      documentsUploadError: 'Не удалось загрузить документ',
      documentsDeleteSuccess: 'Документ успешно удален!',
      documentsDeleteError: 'Не удалось удалить документ',
      documentsConfirmDelete: 'Вы уверены, что хотите удалить этот документ?',
      autoReturnCheckTitle: 'Автоматическая проверка возвратов',
      autoReturnCheckHint:
        'Для каждого магазина: если включено, новые позиции возвратов этого магазина создаются с проверкой на складе (needs_check). Если выключено — без проверки.',
      autoReturnCheckLoadError: 'Не удалось загрузить список магазинов.',
      autoReturnCheckUpdateError: 'Не удалось сохранить настройку. Попробуйте снова.',
      autoReturnCheckNoStores: 'Нет подключённых магазинов. Сначала добавьте магазин на главной.',
    },
    // Security
    security: {
      title: 'Безопасность',
      changePassword: 'Изменить пароль',
      currentPassword: 'Текущий пароль',
      newPassword: 'Новый пароль',
      confirmPassword: 'Подтвердите новый пароль',
      update: 'Обновить пароль',
      updating: 'Обновление...',
      success: 'Пароль успешно изменен!',
    },
    chatApp: {
      topicSupport: 'Техподдержка',
      topicSupportSub: 'Чат с командой',
      topicAi: 'Складской Котик',
      topicAiSub: 'AI-помощник',
      topicProfile: 'Профиль',
      reports: 'Отчёты',
      settings: 'Настройки',
      reportDeductions: 'Списания',
      reportTopups: 'Пополнения',
      reportSales: 'Продажи',
      reportReturns: 'Возвраты',
      switchClassic: 'Классический интерфейс',
      switchChat: 'Чат-интерфейс',
      aiWelcome: 'Мяу! Я Складской Котик — спрашивайте про возвраты, биллинг и работу кабинета.',
      aiPlaceholder: 'Задайте вопрос…',
      aiError: 'Не удалось получить ответ. Попробуйте снова или напишите в поддержку.',
      send: 'Отправить',
      load: 'Загрузить',
      returnsWindows: 'Возвраты за 24 / 48 / 72 ч',
      barcode: 'Штрихкод',
      date: 'Дата',
      store: 'Магазин',
      comment: 'Комментарий',
      wbReceived: 'Поступления WB (completed)',
      ourReceipts: 'Наши приёмки',
      debt: 'Долг (выдано, не принято)',
    },
    // Stores
    stores: {
      title: 'Мои магазины',
      noStores: 'Магазины еще не подключены',
      addFirst: 'Добавьте первый магазин для начала работы',
      connected: 'Подключен',
      storeId: 'ID магазина',
      edit: 'Редактировать магазин',
      editTitle: 'Изменить название магазина',
      storeName: 'Название магазина',
      storeNamePlaceholder: 'Введите название магазина',
      storeNameHint: 'Дайте магазину название для удобной идентификации',
      editError: 'Не удалось обновить магазин',
      // Verification status
      verifying: 'Проверка...',
      verified: 'Подтвержден',
      verificationFailed: 'Ошибка проверки',
      verificationFailedMessage: 'Проверка токена не удалась. Пожалуйста, обновите API ключ или удалите магазин и добавьте его снова с действительным API-ключом.',
      verificationPending: 'Проверка в процессе...',
      deleteStore: 'Удалить магазин',
      deleteStoreConfirm: 'Вы уверены, что хотите удалить этот магазин?',
      updateApiKey: 'Обновить API ключ',
      enterNewApiKey: 'Введите новый API ключ',
      apiKeyPlaceholder: 'Вставьте ваш API ключ здесь...',
      apiKeyUpdateHint: 'Введите новый API ключ для замены текущего. Магазин будет повторно проверен после обновления.',
      apiKeyUpdateSuccess: 'API ключ успешно обновлен. Проверка магазина в процессе.',
      apiKeyUpdateError: 'Не удалось обновить API ключ',
      apiKeyInvalidMessage: 'Ваш API ключ недействителен или истек. Пожалуйста, обновите его, чтобы продолжить использование этого магазина.',
      store: 'Магазин',
    },
    // Auth
    auth: {
      login: 'Войти',
      register: 'Регистрация',
      email: 'Email',
      password: 'Пароль',
      confirmPassword: 'Подтвердите пароль',
      rememberMe: 'Запомнить меня',
      forgotPassword: 'Забыли пароль?',
      noAccount: 'Нет аккаунта?',
      haveAccount: 'Уже есть аккаунт?',
      signUpNow: 'Зарегистрируйтесь',
      signInNow: 'Войдите',
      firstName: 'Имя',
      lastName: 'Фамилия',
      welcomeBack: 'С возвращением',
      signInToAccount: 'Войдите в свой аккаунт',
      enterEmail: 'Введите email',
      enterPassword: 'Введите пароль',
      signingIn: 'Вход...',
      loginFailed: 'Ошибка входа. Попробуйте снова.',
      createAccount: 'Создать аккаунт',
      joinUs: 'Присоединяйтесь к нам',
      signingUp: 'Создание аккаунта...',
      registrationFailed: 'Ошибка регистрации. Попробуйте снова.',
      pricingAndExample: 'Наши цены и примеры',
      resetPassword: 'Сбросить пароль',
      enterEmailReset: 'Введите email для сброса пароля',
      sendResetLink: 'Отправить ссылку',
      sending: 'Отправка...',
      backToLogin: 'Вернуться к входу',
      checkEmail: 'Проверьте почту',
      resetLinkSent: 'Мы отправили ссылку для сброса пароля на',
      newPasswordTitle: 'Новый пароль',
      enterNewPassword: 'Введите новый пароль',
      confirmNewPassword: 'Подтвердите новый пароль',
      resetPasswordBtn: 'Сбросить пароль',
      resetting: 'Сброс...',
      passwordResetSuccess: 'Пароль успешно сброшен',
      passwordResetSuccessMsg: 'Ваш пароль был успешно изменен.',
      registrationSuccess: 'Регистрация успешна',
      verifyEmailMsg: 'Пожалуйста, проверьте почту для подтверждения аккаунта.',
      verifyingEmail: 'Подтверждение email...',
      emailVerified: 'Email подтвержден',
      emailVerifiedMsg: 'Ваш email был успешно подтвержден.',
      resendVerification: 'Отправить письмо повторно',
      // Forgot Password
      forgotPasswordTitle: 'Забыли пароль?',
      forgotPasswordSubtitle: 'Не беспокойтесь, мы отправим вам инструкции по сбросу',
      forgotPasswordFailed: 'Не удалось отправить письмо для сброса. Попробуйте снова.',
      // Reset Sent
      resetSentTitle: 'Проверьте почту',
      resetSentMessage: 'Мы отправили инструкции по сбросу пароля на',
      resetSentInfo: 'Если аккаунт с этим email существует, вы получите инструкции по сбросу пароля. Проверьте папку спам, если не видите письмо в течение нескольких минут.',
      // Reset Password
      resetPasswordTitle: 'Сбросить пароль',
      resetPasswordSubtitle: 'Введите новый пароль ниже',
      newPasswordLabel: 'Новый пароль',
      newPasswordPlaceholder: 'Минимум 8 символов',
      confirmNewPasswordLabel: 'Подтвердите пароль',
      confirmNewPasswordPlaceholder: 'Подтвердите ваш новый пароль',
      passwordsDoNotMatch: 'Пароли не совпадают',
      resetPasswordFailed: 'Не удалось сбросить пароль. Попробуйте снова.',
      // Reset Success
      resetSuccessTitle: 'Пароль успешно сброшен',
      resetSuccessMessage: 'Ваш пароль был успешно изменен.',
      resetSuccessInfo: 'Теперь вы можете войти с новым паролем.',
      continueToSignIn: 'Перейти к входу',
      // Verify Email
      verifyingEmailTitle: 'Подтверждение email',
      verifyingEmailMessage: 'Пожалуйста, подождите, пока мы подтверждаем ваш email...',
      emailVerifiedTitle: 'Email подтвержден!',
      emailVerifiedMessage: 'Ваш email был успешно подтвержден.',
      emailVerifiedInfo: 'Ваш аккаунт теперь активен. Вы будете перенаправлены на страницу входа через несколько секунд...',
      verificationFailedTitle: 'Ошибка подтверждения',
      verificationFailedMessage: 'Не удалось подтвердить ваш email',
      verificationFailedInfo: 'Ссылка для подтверждения могла истечь или уже была использована. Попробуйте войти или запросите новое письмо для подтверждения.',
      goToLogin: 'Перейти к входу',
      // Registration Success
      registrationSuccessTitle: 'Проверьте почту',
      registrationSuccessMessage: 'Мы отправили ссылку для подтверждения на',
      registrationSuccessImportant: 'Важно:',
      registrationSuccessInfo: 'Вы должны подтвердить ваш email перед входом. Нажмите на ссылку в письме, которое мы отправили, чтобы активировать аккаунт.',
      didntReceiveEmail: 'Не получили письмо?',
      resendVerificationEmail: 'Отправить письмо повторно',
      verificationEmailResent: 'Письмо для подтверждения было отправлено повторно. Проверьте почту.',
      resendEmailFailed: 'Не удалось отправить письмо повторно. Попробуйте снова.',
      alreadyVerified: 'Уже подтвердили?',
      contactUs: 'Связаться с нами',
      telegramChat: 'Чат в Telegram',
      faq: 'FAQ',
      aboutProject: 'О проекте',
    },
    // Register
    register: {
      title: 'Создать аккаунт',
      subtitle: 'Зарегистрируйтесь для начала работы',
      firstName: 'Имя',
      firstNamePlaceholder: 'Иван',
      lastName: 'Фамилия',
      lastNamePlaceholder: 'Иванов',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      password: 'Пароль',
      passwordPlaceholder: 'Минимум 8 символов',
      confirmPassword: 'Подтвердите пароль',
      confirmPasswordPlaceholder: 'Подтвердите ваш пароль',
      submit: 'Создать аккаунт',
      creating: 'Создание аккаунта...',
      haveAccount: 'Уже есть аккаунт?',
      signIn: 'Войти',
      passwordsDoNotMatch: 'Пароли не совпадают',
      failed: 'Ошибка регистрации. Попробуйте снова.',
      agreeToOffer: 'Я ознакомился и согласен с',
      offerLink: 'Офертой',
      agreeToDataProcessing: 'Я согласен на обработку персональных данных',
      mustAgreeToOffer: 'Вы должны согласиться с офертой для регистрации',
      mustAgreeToDataProcessing: 'Вы должны согласиться на обработку персональных данных для регистрации',
      wechatId: 'WeChat ID',
      telegramUsername: 'Telegram',
      messengerHint: 'Укажите хотя бы одно: WeChat ID или имя пользователя Telegram',
    },
    // Forgot Password
    forgotPassword: {
      title: 'Забыли пароль?',
      subtitle: 'Не беспокойтесь, мы отправим вам инструкции по сбросу',
      emailLabel: 'Email',
      emailPlaceholder: 'Введите email',
      sendResetLink: 'Отправить ссылку',
      sending: 'Отправка...',
      backToLogin: 'Вернуться к входу',
      failed: 'Не удалось отправить письмо для сброса. Попробуйте снова.',
    },
    // Reset Sent
    resetSent: {
      title: 'Проверьте почту',
      message: 'Мы отправили инструкции по сбросу пароля на',
      info: 'Если аккаунт с этим email существует, вы получите инструкции по сбросу пароля. Проверьте папку спам, если не видите письмо в течение нескольких минут.',
      backToLogin: 'Вернуться к входу',
    },
    // Reset Password
    resetPassword: {
      title: 'Сбросить пароль',
      subtitle: 'Введите новый пароль ниже',
      newPasswordLabel: 'Новый пароль',
      newPasswordPlaceholder: 'Минимум 8 символов',
      confirmPasswordLabel: 'Подтвердите пароль',
      confirmPasswordPlaceholder: 'Подтвердите ваш новый пароль',
      resetButton: 'Сбросить пароль',
      resetting: 'Сброс...',
      backToLogin: 'Вернуться к входу',
      passwordsDoNotMatch: 'Пароли не совпадают',
      failed: 'Не удалось сбросить пароль. Попробуйте снова.',
    },
    // Reset Success
    resetSuccess: {
      title: 'Пароль успешно сброшен',
      message: 'Ваш пароль был успешно изменен.',
      info: 'Теперь вы можете войти с новым паролем.',
      continueToSignIn: 'Перейти к входу',
    },
    // Verify Email
    verifyEmail: {
      verifyingTitle: 'Подтверждение email',
      verifyingMessage: 'Пожалуйста, подождите, пока мы подтверждаем ваш email...',
      successTitle: 'Email подтвержден!',
      successMessage: 'Ваш email был успешно подтвержден.',
      successInfo: 'Ваш аккаунт теперь активен. Вы будете перенаправлены на страницу входа через несколько секунд...',
      continueToSignIn: 'Перейти к входу',
      failedTitle: 'Ошибка подтверждения',
      failedMessage: 'Не удалось подтвердить ваш email',
      failedInfo: 'Ссылка для подтверждения могла истечь или уже была использована. Попробуйте войти или запросите новое письмо для подтверждения.',
      goToLogin: 'Перейти к входу',
      invalidLink: 'Недействительная ссылка для подтверждения.',
      failedError: 'Не удалось подтвердить email. Ссылка может быть недействительной или истекшей.',
    },
    // Registration Success
    registrationSuccess: {
      title: 'Проверьте почту',
      message: 'Мы отправили ссылку для подтверждения на',
      important: 'Важно:',
      info: 'Вы должны подтвердить ваш email перед входом. Нажмите на ссылку в письме, которое мы отправили, чтобы активировать аккаунт.',
      didntReceiveEmail: 'Не получили письмо?',
      resendButton: 'Отправить письмо повторно',
      sending: 'Отправка...',
      emailResent: 'Письмо для подтверждения было отправлено повторно. Проверьте почту.',
      resendFailed: 'Не удалось отправить письмо повторно. Попробуйте снова.',
      alreadyVerified: 'Уже подтвердили?',
      signIn: 'Войти',
    },
    // Offer
    offer: {
      title: 'Договор оферты',
      languageUAE: 'ОАЭ',
      languageChina: 'Китай',
      selectLanguage: 'Выберите язык для скачивания документа оферты',
      uaeDescription: 'Скачать документ оферты для ОАЭ',
      chinaDescription: 'Скачать документ оферты для Китая',
      download: 'Скачать DOCX',
      downloading: 'Скачивание...',
      downloadError: 'Не удалось скачать документ оферты',
    },
    // Pricing
    pricing: {
      title: 'Таблица ценообразования',
      subtitle: 'Тарифы на услуги и информация о ценах',
      loadError: 'Не удалось загрузить таблицу цен',
      downloadButton: 'Скачать прайс-лист',
      downloading: 'Скачивание...',
      downloadError: 'Не удалось скачать прайс-лист',
    },
    // Indigo Price List (static table on /pricing)
    priceList: {
      title: 'Прайс-лист услуг INDIGO',
      subhead: 'Тарифы на услуги — цены указаны за одну единицу услуги, если не указано иное.',
      colNo: '№',
      colService: 'Услуга',
      colCost: 'Стоимость (¥)',
      colNote: 'Примечание / единица измерения',
      r1_name: 'Приемка товаров или возвратов на складе (поштучно)',
      r1_note: 'за каждую единицу товара',
      r2_name: 'Приемка в пункте выдачи (поштучно)',
      r2_note: 'за единицу',
      r3_name: 'Проверка товара',
      r3_note: 'за единицу',
      r4_name: 'Проверка бракованного товара с фотографиями',
      r4_note: 'за единицу',
      r5_main: 'Обработка заказа (упаковка и отправка на маркетплейс)',
      r5_50_name: 'до 50 см (сумма сторон)',
      r5_50_note: 'сумма Д+Ш+В ≤ 50 см',
      r5_80_name: 'до 80 см',
      r5_80_note: 'сумма ≤ 80 см',
      r5_100_name: 'до 100 см',
      r5_100_note: 'сумма ≤ 100 см',
      r5_120_name: 'до 120 см',
      r5_120_note: 'сумма ≤ 120 см',
      r5_180_name: 'до 180 см',
      r5_180_note: 'сумма ≤ 180 см',
      r5_220_name: 'до 220 см',
      r5_220_note: 'сумма ≤ 220 см',
      r5_oversized_name: 'сверхгабаритные заказы',
      r5_oversized_note: 'свыше 220 см или нестандарт',
      r6_name: 'Хранение товара на складе (до отправки)',
      r6_note: 'за 1 м³ в день',
      r7_name: 'Подготовка товара к возврату продавцу',
      r7_note: 'за единицу',
      r8_name: 'Возврат продавцу',
      r8_note: 'согласно тарифам службы доставки (рассчитывается отдельно)',
      r8_price: 'индивидуально',
      infoTitle: 'Важные примечания',
      info1: 'Услуга 5 (обработка заказа) включает упаковку и отправку заказа клиента со склада на маркетплейс. Стоимость зависит от суммы трёх измерений (длина + ширина + высота) в сантиметрах.',
      info2: 'Хранение (услуга 6) тарифицируется за каждый полный или неполный день нахождения товара на складе из расчёта 13,5 за 1 кубический метр в сутки. Объем округляется до 0,001 м³.',
      info3: 'Возврат продавцу (услуга 8) — стоимость рассчитывается индивидуально под конкретную транспортную компанию и направление.',
      info4: 'Все цены указаны без учёта комиссий маркетплейсов и налогов.',
    },
    // Landing
    landing: {
      home: 'Главная',
      heroTitle: 'Управление складом и возвратами для маркетплейсов',
      heroSubtitle: 'Подключите магазин, управляйте возвратами и хранением в одном месте.',
      login: 'Вход',
      register: 'Регистрация',
      connectService: 'Подключить сервис',
      featuresTitle: 'Почему мы',
      feature1Title: 'Возвраты и хранение',
      feature1Text: 'Управление возвратами и складскими операциями в одной системе.',
      feature2Title: 'Скорость и прозрачность',
      feature2Text: 'Актуальные статусы и понятный биллинг.',
      feature3Title: 'Безопасность',
      feature3Text: 'Ваши данные под защитой и в соответствии с требованиями.',
      ctaTitle: 'Начать',
      ctaText: 'Войдите или создайте аккаунт, чтобы подключить магазин.',
    },
    // Footer
    footer: {
      copyright: '© {{year}} Indigo Warehouse. Все права защищены.',
      pricing: 'Ценообразование и примеры',
      offer: 'Оферта',
      faq: 'FAQ',
      aboutProject: 'О проекте',
    },
    // Common
    common: {
      loading: 'Загрузка...',
      error: 'Ошибка',
      success: 'Успешно',
      hello: 'Привет',
      cancel: 'Отмена',
      close: 'Закрыть',
      save: 'Сохранить',
      saving: 'Сохранение...',
      update: 'Обновить',
      updating: 'Обновление...',
      back: 'Назад',
      home: 'Главная',
      currency: {
        yen: '¥',
        ruble: '₽',
      },
      yes: 'Да',
      no: 'Нет',
    },
    // Admin Orders
    adminOrders: {
      title: 'Управление заказами (Админ)',
      orderNumber: 'Номер заказа',
      sticker: 'Стикер',
      status: 'Статус',
      store: 'Магазин',
      trackingNumbers: 'Трек-номера',
      product: 'Товар',
      wbProductPhoto: 'Фото WB',
      refreshWbPhotoTooltip: 'Обновить превью из WB (онлайн)',
      goodsReturnReason: 'Причина возврата (WB)',
      defectNeedsPhotoVideo:
        'Для бракованного товара включите «Требует фото/видео» перед переводом в продажу или к решению продавца.',
      dstOfficeAddress: 'Адрес ПВЗ выдачи возврата',
      returnStatus: 'Статус возврата',
      allReturnStatuses: 'Все по статусу возврата',
      returnStatusActive: 'Активный',
      returnStatusArchived: 'Архивный',
      readyToReturnDt: 'Дата готовности возврата',
      createdDate: 'Дата создания',
      actions: 'Действия',
      details: 'Подробнее',
      hide: 'Скрыть',
      edit: 'Редактировать',
      acceptanceMode: 'Режим приемки',
      acceptanceModeNotFound: 'Возврат не найден в WB goods-return.',
      searchPlaceholder:
        'Номер заказа, трек, SKU, штрихкод, WB stickerId, WB shkId (подстрока; точное совпадение если только цифры), адрес ПВЗ…',
      allStatuses: 'Все статусы',
      storeIdPlaceholder: 'ID магазина',
      customer: 'Клиент',
      tracking: 'Трек',
      seller: 'Продавец',
      orderInfo: 'Информация о заказе',
      id: 'ID',
      whEnterId: 'WH Enter ID',
      whSyncError: 'WH Sync Error',
      productInfo: 'Информация о товаре',
      defective: 'Дефектный',
      needsCheck: 'Требует проверки',
      defectAfterCheck: 'Дефект после проверки',
      needsPhotoVideo: 'Требует фото/видео',
      comments: 'Комментарии',
      attachments: 'Вложения',
      addAttachment: 'Добавить вложение',
      showing: 'Показано {{from}} - {{to}} из {{total}}',
      editOrder: 'Редактировать заказ',
      statusLabel: 'Статус',
      storeId: 'ID магазина',
      customerTrackingNumber: 'Трек-номер клиента',
      trackingNumber: 'Трек-номер',
      sellerTrackingNumber: 'Трек-номер продавца',
      itemFields: 'Поля товара',
      inspectionComments: 'Комментарии к проверке',
      cancel: 'Отмена',
      save: 'Сохранить',
      addAttachmentTitle: 'Добавить вложение',
      attachmentType: 'Тип вложения',
      photo: 'Фото',
      video: 'Видео',
      file: 'Файл',
      upload: 'Загрузить',
      attachmentFilesSelected: 'Выбрано файлов: {{count}}',
      accessDenied: 'Доступ запрещен. Требуются права супер-администратора.',
      deleteAttachment: 'Удалить вложение?',
      statusTransitionSection: 'Переход в статус (история)',
      statusTransitionHint:
        'Заказы, у которых в выбранный период зафиксирован переход в отмеченные статусы (по времени смены в истории). Сочетается с остальными фильтрами (И).',
      statusTransitionDateFrom: 'Период с',
      statusTransitionDateTo: 'Период по',
      statusTransitionTargetStatuses: 'Статусы (куда перешли)',
      statusTransitionClear: 'Сбросить фильтр переходов',
      statusTransitionIncomplete: 'Укажите обе даты и отметьте хотя бы один статус.',
      statusTransitionActiveNote: 'Фильтр по переходу включён. Всего подходящих заказов: {{total}}.',
      dimensionsWeight: 'Габариты и вес',
      disposalModalTitle: 'Списание за утилизацию',
      disposalModalHint:
        'По одной записи на каждую позицию заказа. Если известен вес брутто (кг), подсказка: вес × 3,5 ¥. Сумму можно изменить для каждой позиции.',
      disposalApplyAuto: 'Заполнить по весу (кг × 3,5 ¥)',
      disposalAmountYuan: 'Сумма (¥)',
      disposalWeightLine: 'Масса брутто: {{kg}} кг — рекомендуется {{suggested}} ¥',
      disposalWeightUnknown: 'Вес товара неизвестен — введите сумму вручную.',
      disposalConfirm: 'Создать списания и перевести в «Утилизирован»',
    },
    // Returns Table
    returns: {
      allReturns: 'Все возвраты',
      inTransit: 'Товары в пути',
      inWarehouse: 'Возвраты на складе',
      ordersInProcessing: 'Заказы в обработке',
      ordersPendingDecision: 'Ожидают решения',
      completedOrders: 'Завершённые заказы',
      returnsOtherPvz: 'Возвраты в другие ПВЗ',
      filterByOtherPvz: 'Заказы в другие ПВЗ',
      otherPvzTrue: 'Только другие ПВЗ',
      otherPvzFalse: 'Только ПВЗ Indigo',
      pvzScopeFilter: 'Адрес доставки (ПВЗ WB)',
      pvzScopeAll: 'Все адреса',
      pvzScopeShosseynaya: 'г Москва, Шоссейная улица, 4к3',
      pvzScopeProezd3723: 'Проектируемый проезд № 3723, вл12, Москва, 109548',
      pvzScopeOther: 'Другие ПВЗ',
      pvzScopeOur: 'Наши ПВЗ (Шоссейная + проезд)',
      wbDtFrom: 'WB дата с',
      wbDtTo: 'WB дата по',
      wbDtFieldsHint: 'Учитывать поля WB (если несколько — ИЛИ)',
      wbDtFieldCompleted: 'completedDt',
      wbDtFieldReady: 'readyToReturnDt',
      wbDtFieldExpired: 'expiredDt',
      wbDtFieldOrder: 'orderDt',
      otherPvzContactBanner: 'Если необходимо забрать данные товары, свяжитесь с нами в чате.',
      whBillingCharges: 'Кол-во списаний за хранение товара на складе и передачу его в продажу',
      whChargesCountCol: 'Кол-во списаний (хранение + передача в продажу)',
      whStockUnitsCol: 'Кол-во единиц на складе',
      whServiceStorage: 'Хранение (склад)',
      whServiceShipmentToSale: 'Отгрузка в продажу (упаковка и передача)',
      whStorageTotal: 'Итого списано за хранение',
      whShipmentTotal: 'Итого списано за передачу в продажу',
      otherPvzHelpText: 'Здесь отображаются возвраты WB в статусе «Ожидает получения в WB», которые направлены не в ПВЗ Indigo.',
      goodsOnSaleHelpText: 'Здесь отображаются товары, переданные в продажу, и связанные с ними списания WH.',
      goodsOnSaleTotalsTitle: 'Итого на странице',
      goodsOnSaleTotalsLine: 'На складе (возвратов): {{wh}} · Продано / отгружено: {{sold}}',
      goodsOnSaleOnStockCol: 'На складе WH',
      goodsOnSaleSoldCol: 'Продано и отправлено покупателю',
      goodsOnSaleStorageFeeCol: 'Списания за хранение — WH и посуточное (¥)',
      goodsOnSaleShipmentFeeCol: 'Списания за отгрузку (¥)',
      goodsOnSaleReturnsSubtable: 'Возвраты по этому товару',
      goodsOnSaleWarehouseBadge: 'На складе',
      goodsOnSaleSettledBadge: 'Реализовано',
      goodsOnSaleWhStateCol: 'Состояние WH',
      goodsOnSaleWhPresentCol: 'Остаток WH (в наличии)',
      goodsOnSaleWhReservedCol: 'Остаток WH (резерв)',
      goodsOnSaleWhDefectedCol: 'Остаток WH (брак)',
      goodsOnSaleWhStockLiveHint: 'Колонка «На складе WH» — live из WH API (stocks.present). Наведите для резерва/брака.',
      goodsOnSaleWhStockUnavailable: 'Не удалось загрузить остатки WH',
      goodsOnSaleMpStateCol: 'Статус на маркетплейсе',
      goodsOnSaleMpStateWaiting: 'Готовится к отправке',
      goodsOnSaleMpStateReadyPickup: 'Сборочное задание прибыло на пункт выдачи заказов (ПВЗ)',
      goodsOnSaleMpStateSold: 'Продано',
      goodsOnSaleMpStateCanceledByClient: 'Покупатель отменил заказ при получении',
      goodsOnSaleMpStateSorted: 'Сборочное задание отсортировано',
      goodsOnSaleMpStateDefect: 'Отмена сборочного задания по причине брака',
      goodsOnSaleReturnsWord: 'возвр.',
      goodsOnSaleMobileGroupedHint: 'Строки сгруппированы по товару; нажмите карточку, чтобы увидеть возвраты.',
      goodsOnSaleShippedDateFrom: 'Отгрузка покупателю с',
      goodsOnSaleShippedDateTo: 'Отгрузка покупателю по',
      goodsOnSaleApplyFilters: 'Применить фильтры',
      goodsOnSaleSummaryShipments: 'Отгрузок (строк списаний)',
      goodsOnSaleSummarySold: 'Успешных продаж',
      goodsOnSaleSummaryCanceled: 'Отказов / брак',
      goodsOnSaleSummaryInTransit: 'В пути / прочее',
      destination: 'Куда направлен возврат',
      readyToReturnDt: 'Готов к выдаче',
      archiveState: 'Активный/Архивный',
      finances: 'Финансы',
      filters: 'Фильтры',
      // Status values for filter dropdown
      statusAwaitingReceipt: 'Ожидает получения в WB',
      statusReceivedAwaitingCheck: 'Получен, ожидает проверки',
      statusAwaitingSellerDecision: 'Ожидает решения продавцом',
      statusAwaitingForSale: 'Ожидает передачи в продажу',
      statusTransferringToSale: 'Передается на продажу',
      statusSubmittedForSale: 'Передан в продажу',
      statusAwaitingShipment: 'Ожидает отправки продавцу',
      statusAwaitingDisposal: 'Ожидает утилизации',
      statusDisposed: 'Утилизирован',
      statusSentToSeller: 'Отправлен продавцу',
      // Table columns - In Transit
      returnRequestDate: 'Дата заявки на возврат',
      product: 'Товар',
      dimensionsWeight: 'Габариты и вес',
      unitCm: 'см',
      unitKg: 'кг',
      dimensionsUnknownShort: '—',
      weightUnknownShort: 'вес неизвестен',
      dimensionsWeightUnavailable: 'Габариты и вес недоступны',
      sku: 'Артикул',
      barcode: 'Баркод',
      returnNumber: 'Номер возврата',
      sticker: 'Sticker',
      defectiveItem: 'Заявка по браку?',
      needsCheck: 'Нужна проверка',
      needsPhotoVideo: 'Нужно ли фото/видео?',
      decisionOnProduct: 'Решение по товару',
      status: 'Статус',
      trackingNumber: 'Трек-номер',
      sellerTrackingNumber: 'Трек-номер отправки продавцу',
      // Table columns - In Warehouse
      isDefectAfterCheck: 'Брак по проверке',
      photoVideo: 'Фото/видео',
      receiptDate: 'Дата получения товара ИндигоСклад',
      attachedFiles: 'Приложенные файлы',
      photo: 'Фото',
      video: 'Видео',
      inspectionComments: 'Комментарий по осмотру товара/Предложения',
      goodsReturnReason: 'Причина возврата (WB)',
      wbProductPhoto: 'Фото',
      productImageComingSoon: 'Скоро',
      wbImageNotFound: 'Не найдено',
      wbPhotoFullscreen: 'Открыть фото на весь экран',
      wbOpenOnWildberries: 'Открыть на Wildberries',
      wbCatalogShort: 'Карточка WB',
      whPortalProducts: 'Открыть в ВХ (товары)',
      photoVideoAdminOnly:
        'Проверка бракованного товара с фотографиями задаётся администратором после осмотра; вы выбираете только, нужна ли проверка.',
      acceptSuggestion: 'Принять предложение',
      // Yes/No buttons
      yes: 'Да',
      no: 'Нет',
      // Status decisions
      transferToSale: 'Передать в продажу',
      sellOnWB: 'Продавать на WB',
      dispose: 'Утилизировать',
      disposeIn7Days: 'Утилизация через 7 дн.',
      sendToSeller: 'Возврат продавцу',
      // Filters
      searchPlaceholder: 'Поиск по товару, артикулу, баркоду, номеру возврата...',
      dateFrom: 'Дата с',
      dateTo: 'Дата по',
      allStatuses: 'Все статусы',
      filterByDefect: 'Фильтр по браку',
      applyFilters: 'Применить фильтры',
      clearFilters: 'Сбросить фильтры',
      // Confirmations and warnings
      confirmNeedsCheckTitle: 'Подтвердите запрос на проверку',
      confirmNeedsCheckMessage: 'Вы уверены, что хотите запросить проверку? Это действие необратимо и не может быть отменено.',
      alsoRequirePhotoVideo: 'Также требуется фото/видео',
      confirmAction: 'Да, запросить проверку',
      deliveryAddressRequired: 'Пожалуйста, заполните адрес доставки в профиле перед запросом возврата товара.',
      // Status change modal
      chooseAction: 'Выбрать действие',
      statusChangeTitle: 'Решение по товару',
      statusChangeMessage: 'Выберите, что сделать с этим товаром:',
      confirmStatusChange: 'Подтвердить',
      photoVideoRequiresCheck: 'Фото/видео можно запрашивать только при включенной проверке.',
      errorPhotoVideoWithoutCheck: 'Невозможно включить требование фото/видео без проверки. Сначала включите проверку.',
      errorCannotDisableCheck: 'Невозможно отключить проверку. Это действие необратимо.',
      errorUpdateFailed: 'Не удалось обновить. Попробуйте ещё раз.',
      // Table states
      noItemsFound: 'Товары не найдены',
      loadingItems: 'Загрузка товаров...',
      errorLoadingItems: 'Ошибка загрузки товаров',
      // Pagination
      showingItems: 'Показано {{from}}-{{to}} из {{total}} товаров',
      itemsPerPage: 'Элементов на странице',
      // Links
      downloadAttachment: 'Скачать вложение',
      attachmentCommentPlaceholder: 'Комментарий к фото проверки',
      saveAttachmentComment: 'Сохранить комментарий',
      bulkSelectColumn: 'Выбрать строку',
      bulkSelectPage: 'Выбрать все на странице',
      bulkClearSelection: 'Снять выбор',
      bulkSelectedCount: 'Выбрано: {{count}}',
      bulkNeedsCheckOn: 'Проверка: да (выбранные)',
      bulkNeedsCheckOff: 'Проверка: нет (выбранные)',
      bulkNeedsCheckPending: 'Запросить проверку (выбранные)',
      bulkPhotoVideoOn: 'Требовать фото/видео (выбранные)',
      bulkDecisionForSelected: 'Решение для выбранных…',
      bulkStatusModalIntro: 'Массовое действие',
      bulkStatusModalCount: '{{count}} позиций',
      bulkConfirmNeedsCheckCount:
        'Запросить проверку для {{count}} позиций? Это действие необратимо.',
      bulkPartialFailure:
        'Не удалось обновить {{failed}} из {{total}} позиций. Список обновлён.',
    },
    // Support Chat
    support: {
      chat: {
        connectionError: 'Ошибка подключения. Проверьте соединение с сервером.',
        connectionErrorNoToken: 'Токен авторизации не найден. Пожалуйста, войдите в систему заново.',
        reconnectError: 'Не удалось переподключиться к чату',
        connectionClosed: 'Соединение с чатом закрыто',
      },
      supportChat: 'Чат поддержки',
      chatWith: 'Чат с',
      online: 'Онлайн',
      archived: 'Архив',
      chatNotFound: 'Чат не найден',
      enterMessage: 'Введите сообщение...',
      send: 'Отправить',
      justNow: 'сейчас',
      goToChat: 'Перейти в чат',
      support: 'Поддержка',
      allChats: 'Все чаты',
      myChats: 'Мои чаты',
      archive: 'Архив',
      active: 'Активные',
      newChat: 'Новый чат',
      searchChats: 'Поиск по чатам...',
      search: 'Поиск...',
      nothingFound: 'Ничего не найдено',
      noChats: 'Нет чатов',
      noChatsYet: 'У вас пока нет чатов',
      open: 'Открыт',
      closed: 'Закрыт',
      unarchive: 'Разархивировать',
      toArchive: 'В архив',
      noSelectedChat: 'Нет выбранного чата',
      selectChatToView: 'Выберите чат для просмотра',
      newSupportChat: 'Новый чат поддержки',
      subject: 'Тема',
      describeProblem: 'Опишите вашу проблему...',
      create: 'Создать',
      cancel: 'Отмена',
      failedToLoadChats: 'Не удалось загрузить чаты',
      failedToChangeArchive: 'Не удалось изменить статус архивации',
      failedToCreateChat: 'Не удалось создать чат',
      failedToLoadChat: 'Не удалось загрузить чат',
      failedToUploadFile: 'Не удалось загрузить файл',
      chatInArchive: 'Чат находится в архиве. Отправка сообщений недоступна.',
      attachment: '[Вложение]',
      minutesAgo: '{{minutes}} мин назад',
      invalidFileType: 'Неподдерживаемый тип файла. Разрешены: изображения ({{imageExts}}) и видео ({{videoExts}})',
      fileSizeExceeded: 'Размер файла не должен превышать 50MB. Текущий размер: {{currentSize}}MB',
      reply: 'Ответить',
      replyToMessage: 'Ответить на сообщение',
      primaryTab: 'Личные чаты',
      openOldThreads: 'Старые темы',
      backToMainChat: 'К основному чату',
      filterByStoreId: 'ID магазина (фильтр)',
      markAsUnread: 'Не прочитано',
      markUnreadFailed: 'Не удалось пометить',
      aiSuggestTitle: 'Черновик ответа (ИИ)',
      aiSuggestHint:
        'Вставьте вопрос клиента (Ctrl+V), получите черновик, отредактируйте и отправьте сами. Автоотправки нет.',
      aiSuggestPasteClipboard: 'Вставить из буфера',
      aiSuggestGetDraft: 'Черновик от ИИ',
      aiSuggestInsert: 'Вставить в поле сообщения',
      aiSuggestLoading: 'Генерация…',
      aiSuggestError: 'Не удалось получить черновик ИИ.',
      broadcastTitle: 'Рассылка в чаты пользователей',
      broadcastOpen: 'Рассылка',
      broadcastAudience: 'Аудитория',
      broadcastAudienceAll: 'Все клиенты (активные, не админы)',
      broadcastAudienceStore: 'Пользователи с магазином, у которого store_id содержит',
      broadcastAudienceUsers: 'Конкретные пользователи (по ID)',
      broadcastStoreIdHint: 'Подстрока WB store_id (как в фильтре списка)',
      broadcastUserIdsHint: 'ID через запятую, напр. 12, 34, 56',
      broadcastUserIdsLabel: 'ID пользователей',
      broadcastMessageLabel: 'Текст сообщения',
      broadcastTranslatedLabel: 'Перевод / пометка для админов (необязательно, translated_content)',
      broadcastSend: 'Отправить всем',
      broadcastSending: 'Отправка…',
      broadcastDone: 'Готово: отправлено {{sent}}, ошибок {{failed}}.',
      broadcastError: 'Рассылка не выполнена',
      broadcastSuperuserOnly: 'Рассылку может отправить только суперпользователь.',
      broadcastConfirm: 'Отправить это сообщение каждому пользователю из выбранной аудитории?',
      broadcastNeedStoreId: 'Укажите подстроку ID магазина.',
      broadcastNeedUserIds: 'Укажите хотя бы один числовой ID пользователя.',
    },
  },
  zh: {
    // Navigation
    nav: {
      allStores: '所有商店',
      addStore: '添加商店',
      billings: '账单',
      accounts: '账户',
      support: '支持',
      profile: '个人资料',
      signOut: '退出',
      selectStore: '选择商店',
      adminOrders: '管理员：订单',
      adminSupport: '管理员：支持',
      adminBillings: '账单',
      goodsOnSale: '在售商品',
      createSuperuser: 'Create superadmin',
      adminWbReturns: 'WB：店铺退货报表',
      notifications: '通知',
    },
    notifications: {
      empty: '暂无通知',
      markRead: '我已了解',
      languageLabel: '显示语言',
      apiTokenTitle: 'API 密钥验证失败',
      apiTokenBody: '店铺「{{storeName}}」的定期检查失败。请更新市场 API 密钥以恢复同步。',
      addApiToken: '添加 API 密钥',
      apiTokenDismiss: '隐藏至下次登录',
    },
    errors: {
      serviceUnavailable:
        '服务暂时无法连接，可能正在进行维护或服务器重启。请等待几分钟后刷新页面。',
      serviceUnavailableShort: '网站暂时不可用（维护或重启中），请几分钟后再试。',
      unknown: '出错了，请重试。',
    },
    billing: {
      title: '账户',
      currentBalance: '当前余额',
      topUp: '充值',
      deducted: '已扣',
      dateFrom: '开始日期（计费日 billing_date）',
      dateTo: '结束日期（计费日 billing_date）',
      type: '类型',
      orderNo: '订单号',
      searchProductBarcode: '商品、条形码...',
      apply: '应用',
      downloadExcel: '下载 Excel',
      downloadPdf: '下载 PDF 报表',
      accountsPdfFilename: 'accounts_report',
      noExpenses: '所选期间无扣款。',
      shownOf: '显示 {{from}}–{{to}}，共 {{total}} 条',
      perPage: '每页',
      back: '上一页',
      next: '下一页',
      pageOf: '第 {{page}} 页，共 {{total}} 页',
      date: '日期',
      service: '服务',
      orderStatus: '订单状态',
      orderDate: '订单日期',
      product: '商品',
      amount: '金额 (¥)',
      allTypes: '全部类型',
      type_storage_daily: '按日仓储',
      type_storage_warehouse: 'WH仓储（库存/发货）',
      type_prepare_return_to_seller: '退货准备',
      type_disposal: '销毁处理',
      type_packaging_shipment: '包装与发货',
      type_inspection_no_media: '商品检验',
      type_inspection_with_media: '缺陷商品检验（含照片）',
      type_receipt_warehouse: '仓库收货',
      type_receipt_pickup: '自提点收货',
      type_balance_top_up: '余额充值',
      whStockUnits: 'WH 库存数量',
      byStore: '按店铺',
      depositWarningBanner: '注意！根据要约中所述的合作条款，余额为负时，Flydarin 仅能接收、检验和存储货物，不会上架销售。为保证业务正常运行，请通过本页二维码使用支付宝充值。连接 1 家店铺最低存款 = 1000 元，2 家 = 每家 700 元，3 家及以上 = 每家 500 元。款项将在 24 小时内到账。',
      sendReceiptHint: '请在支付定金后务必发送收据或截图。',
      sendReceiptButton: '发送收据',
      payWithAlipay: '支付宝支付',
      payWithAlipayHint:
        '选择店铺并输入任意充值金额（人民币）。支付宝确认支付后余额会自动更新，此方式一般无需再传收据。',
      payWithAlipayCustomHint:
        '为所选店铺输入充值金额，然后打开支付宝官方收银台页面。',
      payWithAlipayStoreLabel: '店铺',
      payWithAlipayAmountLabel: '充值金额（CNY）',
      payWithAlipayFillDebt: '填入欠款（{{amount}} ¥）',
      payWithAlipayAmountRequired: '请输入有效金额（最低 0.01 ¥）。',
      payWithAlipayStoreRequired: '请选择店铺。',
      payWithAlipayNoStores: '您的账户未关联任何店铺。',
      payWithAlipayPagePrimaryHint:
        '推荐在本浏览器完成支付：将跳转支付宝官方收银台（电脑网站支付 / page pay）。',
      payWithAlipayPageNewTab: '在新标签页打开',
      payWithAlipayNegativeOnly: '仅当店铺余额为负时才能使用此动态二维码付款。',
      payWithAlipayButton: '获取付款二维码',
      payWithAlipayAmount: '金额',
      payWithAlipayOrderNo: '商户订单号',
      payWithAlipayReused: '沿用尚未过期的未支付二维码',
      payWithAlipayScanHint: '请打开支付宝扫码。',
      payWithAlipayCreditHint: '支付宝确认支付后会自动入账，此方式无需再发送收据。',
      payWithAlipayCopyPayload: '复制二维码内容',
      payWithAlipayCopied: '已复制',
      payWithAlipayPageButton: '打开 AliPay 支付页',
      payWithAlipayPagePopupBlocked: '浏览器拦截了弹窗，请允许弹窗后重试。',
      payWithAlipayPageNoUrl: '无法获取 AliPay 支付链接。',
    },
    // Dashboard cards
    dashboard: {
      inTransit: '运输中到',
      warehouse: 'Indigo仓库',
      storedIn: '存储于',
      completedReturns: '已完成退货',
      returnRequests: '退货请求',
      ordersInProcessing: '处理中的订单',
      ordersPendingDecision: '待决定的订单',
      completedOrders: '已完成订单',
      items: '件商品',
      or: '或',
      viewItemsInTransit: '查看运输中的商品',
      viewReturnsOtherPvz: '查看发往其他自提点的退货',
      viewReturnData: '查看退货数据',
      viewFinancialReport: '查看财务报告',
      processReturns: '处理退货',
      viewProcessingOrders: '查看处理中订单',
      viewCompletedOrders: '查看已完成订单',
    },
    // Add Store Modal
    addStore: {
      title: '添加商店',
      selectMarketplace: '选择市场',
      wildberries: 'Wildberries',
      ozon: 'Ozon',
      yandexMarket: 'Yandex市场',
      comingSoon: '即将推出',
      storeName: '商店名称',
      storeNamePlaceholder: '我的商店',
      storeNameHint: '给你的商店起个名字以便识别',
      enterApiKey: '输入JWT API密钥',
      apiKeyPlaceholder: '在此粘贴您的JWT API密钥...',
      cancel: '取消',
      add: '添加商店',
      adding: '添加中...',
      success: '商店添加成功！',
      error: '添加商店失败',
      invalidToken: '无效或过期的令牌',
      storeExists: '此商店已连接',
    },
    // Profile
    profile: {
      title: '个人资料',
      email: '邮箱',
      emailCannotChange: '邮箱不可更改',
      wechatId: 'WeChat ID',
      telegramUsername: 'Telegram',
      messengerHint: '即时通讯联系方式',
      firstName: '名',
      lastName: '姓',
      accountStatus: '账户状态',
      emailVerified: '邮箱已验证',
      memberSince: '注册时间',
      edit: '编辑',
      save: '保存更改',
      saving: '保存中...',
      cancel: '取消',
      updateSuccess: '个人资料更新成功！',
      updateError: '更新个人资料失败，请重试。',
      // Delivery address
      deliveryAddressTitle: '收货地址',
      deliveryAddressDescription: '您的收货地址用于接收退货商品。',
      deliveryAddressWarning: '请填写收货地址以便能够申请退货。',
      addressUpdateSuccess: '地址更新成功！',
      addressStreet: '详细地址',
      addressStreetPlaceholder: '街道名称，门牌号，单元号',
      addressCity: '城市',
      addressCityPlaceholder: '北京市',
      addressPostalCode: '邮政编码',
      addressPostalCodePlaceholder: '100000',
      addressCountry: '国家',
      addressCountryPlaceholder: '中国',
      addressPhone: '电话号码',
      addressPhonePlaceholder: '+86 138-0000-0000',
      // Legal documents
      documentsTitle: '法人文件',
      documentsDescription: '上传与您的法人实体相关的PDF文件。最大文件大小：10MB。',
      documentsUpload: '上传PDF',
      documentsUploading: '上传中...',
      documentsEmpty: '尚未上传任何文件',
      documentsOnlyPdf: '仅允许PDF文件',
      documentsMaxSize: '文件大小不能超过10MB',
      documentsUploadSuccess: '文件上传成功！',
      documentsUploadError: '文件上传失败',
      documentsDeleteSuccess: '文件删除成功！',
      documentsDeleteError: '文件删除失败',
      documentsConfirmDelete: '确定要删除此文件吗？',
      autoReturnCheckTitle: '自动退货核验',
      autoReturnCheckHint:
        '按店铺设置：开启后，该店铺新的退货商品行将需要仓库核验；关闭则创建为无需核验。',
      autoReturnCheckLoadError: '无法加载店铺列表。',
      autoReturnCheckUpdateError: '无法保存设置，请重试。',
      autoReturnCheckNoStores: '尚未连接店铺。请先在控制台添加店铺。',
    },
    // Security
    security: {
      title: '安全',
      changePassword: '更改密码',
      currentPassword: '当前密码',
      newPassword: '新密码',
      confirmPassword: '确认新密码',
      update: '更新密码',
      updating: '更新中...',
      success: '密码更改成功！',
    },
    // Stores
    stores: {
      title: '我的商店',
      noStores: '尚未连接商店',
      addFirst: '添加您的第一个商店开始使用',
      connected: '已连接',
      storeId: '商店ID',
      edit: '编辑商店',
      editTitle: '编辑商店名称',
      storeName: '商店名称',
      storeNamePlaceholder: '输入商店名称',
      storeNameHint: '给你的商店起个名字以便识别',
      editError: '更新商店失败',
      // Verification status
      verifying: '验证中...',
      verified: '已验证',
      verificationFailed: '验证失败',
      verificationFailedMessage: '令牌验证失败。请删除此商店并使用有效的API密钥重新添加。',
      verificationPending: '验证进行中...',
      deleteStore: '删除商店',
      deleteStoreConfirm: '确定要删除此商店吗？',
    },
    // Auth
    auth: {
      login: '登录',
      register: '注册',
      email: '邮箱',
      password: '密码',
      confirmPassword: '确认密码',
      rememberMe: '记住我',
      forgotPassword: '忘记密码？',
      noAccount: '没有账户？',
      haveAccount: '已有账户？',
      signUpNow: '注册',
      signInNow: '登录',
      firstName: '名',
      lastName: '姓',
      welcomeBack: '欢迎回来',
      signInToAccount: '登录您的账户',
      enterEmail: '输入您的邮箱',
      enterPassword: '输入您的密码',
      signingIn: '登录中...',
      loginFailed: '登录失败，请重试。',
      createAccount: '创建账户',
      joinUs: '加入我们',
      signingUp: '创建账户中...',
      registrationFailed: '注册失败，请重试。',
      pricingAndExample: '我们的价格和示例',
      resetPassword: '重置密码',
      enterEmailReset: '输入邮箱以重置密码',
      sendResetLink: '发送重置链接',
      sending: '发送中...',
      backToLogin: '返回登录',
      checkEmail: '检查您的邮箱',
      resetLinkSent: '我们已将密码重置链接发送到',
      newPasswordTitle: '设置新密码',
      enterNewPassword: '输入新密码',
      confirmNewPassword: '确认新密码',
      resetPasswordBtn: '重置密码',
      resetting: '重置中...',
      passwordResetSuccess: '密码重置成功',
      passwordResetSuccessMsg: '您的密码已成功重置。',
      registrationSuccess: '注册成功',
      verifyEmailMsg: '请检查您的邮箱以验证账户。',
      verifyingEmail: '验证邮箱中...',
      emailVerified: '邮箱已验证',
      emailVerifiedMsg: '您的邮箱已成功验证。',
      resendVerification: '重新发送验证邮件',
      // Forgot Password
      forgotPasswordTitle: '忘记密码？',
      forgotPasswordSubtitle: '别担心，我们会向您发送重置说明',
      forgotPasswordFailed: '发送重置邮件失败，请重试。',
      // Reset Sent
      resetSentTitle: '检查您的邮箱',
      resetSentMessage: '我们已将密码重置说明发送至',
      resetSentInfo: '如果存在使用此邮箱的账户，您将收到重置密码的说明。如果几分钟内没有看到，请检查垃圾邮件文件夹。',
      // Reset Password
      resetPasswordTitle: '重置密码',
      resetPasswordSubtitle: '在下方输入您的新密码',
      newPasswordLabel: '新密码',
      newPasswordPlaceholder: '至少8个字符',
      confirmNewPasswordLabel: '确认密码',
      confirmNewPasswordPlaceholder: '确认您的新密码',
      passwordsDoNotMatch: '密码不匹配',
      resetPasswordFailed: '重置密码失败，请重试。',
      // Reset Success
      resetSuccessTitle: '密码重置完成',
      resetSuccessMessage: '您的密码已成功重置。',
      resetSuccessInfo: '您现在可以使用新密码登录。',
      continueToSignIn: '继续登录',
      // Verify Email
      verifyingEmailTitle: '正在验证您的邮箱',
      verifyingEmailMessage: '请稍候，我们正在验证您的邮箱地址...',
      emailVerifiedTitle: '邮箱已验证！',
      emailVerifiedMessage: '您的邮箱已成功验证。',
      emailVerifiedInfo: '您的账户现已激活。您将很快被重定向到登录页面...',
      verificationFailedTitle: '验证失败',
      verificationFailedMessage: '我们无法验证您的邮箱地址',
      verificationFailedInfo: '验证链接可能已过期或已被使用。请尝试登录或请求新的验证邮件。',
      goToLogin: '前往登录',
      // Registration Success
      registrationSuccessTitle: '检查您的邮箱',
      registrationSuccessMessage: '我们已将验证链接发送至',
      registrationSuccessImportant: '重要提示：',
      registrationSuccessInfo: '您必须先验证邮箱地址才能登录。请点击我们发送的邮件中的链接以激活您的账户。',
      didntReceiveEmail: '没有收到邮件？',
      resendVerificationEmail: '重新发送验证邮件',
      verificationEmailResent: '验证邮件已重新发送。请检查您的收件箱。',
      resendEmailFailed: '重新发送邮件失败，请重试。',
      alreadyVerified: '已经验证？',
      contactUs: '联系我们',
      telegramChat: 'Telegram 聊天',
      faq: '常见问题',
      aboutProject: '关于项目',
    },
    // Register
    register: {
      title: '创建账户',
      subtitle: '注册以开始使用',
      firstName: '名',
      firstNamePlaceholder: '小明',
      lastName: '姓',
      lastNamePlaceholder: '张',
      email: '邮箱',
      emailPlaceholder: 'your@email.com',
      password: '密码',
      passwordPlaceholder: '至少8个字符',
      confirmPassword: '确认密码',
      confirmPasswordPlaceholder: '确认您的密码',
      submit: '创建账户',
      creating: '创建账户中...',
      haveAccount: '已有账户？',
      signIn: '登录',
      passwordsDoNotMatch: '密码不匹配',
      failed: '注册失败，请重试。',
      agreeToOffer: '我已阅读并同意',
      offerLink: '服务协议',
      agreeToDataProcessing: '我同意处理个人数据',
      mustAgreeToOffer: '您必须同意服务协议才能注册',
      mustAgreeToDataProcessing: '您必须同意处理个人数据才能注册',
      wechatId: 'WeChat ID',
      telegramUsername: 'Telegram 用户名',
      messengerHint: '请至少填写 WeChat ID 或 Telegram 用户名之一',
    },
    // Forgot Password
    forgotPassword: {
      title: '忘记密码？',
      subtitle: '别担心，我们会向您发送重置说明',
      emailLabel: '邮箱',
      emailPlaceholder: '输入您的邮箱',
      sendResetLink: '发送重置链接',
      sending: '发送中...',
      backToLogin: '返回登录',
      failed: '发送重置邮件失败，请重试。',
    },
    // Reset Sent
    resetSent: {
      title: '检查您的邮箱',
      message: '我们已将密码重置说明发送至',
      info: '如果存在使用此邮箱的账户，您将收到重置密码的说明。如果几分钟内没有看到，请检查垃圾邮件文件夹。',
      backToLogin: '返回登录',
    },
    // Reset Password
    resetPassword: {
      title: '重置密码',
      subtitle: '在下方输入您的新密码',
      newPasswordLabel: '新密码',
      newPasswordPlaceholder: '至少8个字符',
      confirmPasswordLabel: '确认密码',
      confirmPasswordPlaceholder: '确认您的新密码',
      resetButton: '重置密码',
      resetting: '重置中...',
      backToLogin: '返回登录',
      passwordsDoNotMatch: '密码不匹配',
      failed: '重置密码失败，请重试。',
    },
    // Reset Success
    resetSuccess: {
      title: '密码重置完成',
      message: '您的密码已成功重置。',
      info: '您现在可以使用新密码登录。',
      continueToSignIn: '继续登录',
    },
    // Verify Email
    verifyEmail: {
      verifyingTitle: '正在验证您的邮箱',
      verifyingMessage: '请稍候，我们正在验证您的邮箱地址...',
      successTitle: '邮箱已验证！',
      successMessage: '您的邮箱已成功验证。',
      successInfo: '您的账户现已激活。您将很快被重定向到登录页面...',
      continueToSignIn: '继续登录',
      failedTitle: '验证失败',
      failedMessage: '我们无法验证您的邮箱地址',
      failedInfo: '验证链接可能已过期或已被使用。请尝试登录或请求新的验证邮件。',
      goToLogin: '前往登录',
      invalidLink: '无效的验证链接。',
      failedError: '验证邮箱失败。链接可能无效或已过期。',
    },
    // Registration Success
    registrationSuccess: {
      title: '检查您的邮箱',
      message: '我们已将验证链接发送至',
      important: '重要提示：',
      info: '您必须先验证邮箱地址才能登录。请点击我们发送的邮件中的链接以激活您的账户。',
      didntReceiveEmail: '没有收到邮件？',
      resendButton: '重新发送验证邮件',
      sending: '发送中...',
      emailResent: '验证邮件已重新发送。请检查您的收件箱。',
      resendFailed: '重新发送邮件失败，请重试。',
      alreadyVerified: '已经验证？',
      signIn: '登录',
    },
    // Pricing
    pricing: {
      title: '服务费率',
      subtitle: '服务费率和价格信息',
      loadError: '无法加载价格表',
      downloadButton: '下载我们的价格表',
      downloading: '正在下载...',
      downloadError: '下载价目表失败',
    },
    // Indigo Price List (static table on /pricing)
    priceList: {
      title: 'INDIGO 服务价目表',
      subhead: '服务费率 — 除另有说明外，价格为每单位。',
      colNo: '序号',
      colService: '服务',
      colCost: '费用 (¥)',
      colNote: '备注 / 计量单位',
      r1_name: '仓库收货或退货（按件）',
      r1_note: '每件',
      r2_name: '自提点收货（按件）',
      r2_note: '每单位',
      r3_name: '商品检验',
      r3_note: '每单位',
      r4_name: '缺陷商品检验（含照片）',
      r4_note: '每单位',
      r5_main: '订单处理（包装及发往电商平台）',
      r5_50_name: '50厘米以内（三边之和）',
      r5_50_note: '长+宽+高 ≤ 50 cm',
      r5_80_name: '80厘米以内',
      r5_80_note: '总和 ≤ 80 cm',
      r5_100_name: '100厘米以内',
      r5_100_note: '总和 ≤ 100 cm',
      r5_120_name: '120厘米以内',
      r5_120_note: '总和 ≤ 120 cm',
      r5_180_name: '180厘米以内',
      r5_180_note: '总和 ≤ 180 cm',
      r5_220_name: '220厘米以内',
      r5_220_note: '总和 ≤ 220 cm',
      r5_oversized_name: '超规格订单',
      r5_oversized_note: '超过220厘米或非标准',
      r6_name: '仓库仓储（发货前）',
      r6_note: '每立方米每天',
      r7_name: '退货卖家前的商品准备',
      r7_note: '每单位',
      r8_name: '退还给卖家',
      r8_note: '按物流公司费率（另行计算）',
      r8_price: '按实际情况',
      infoTitle: '重要说明',
      info1: '服务5（订单处理）包含从仓库到电商平台的客户订单包装与发货。费用根据三边之和（长+宽+高，厘米）计算。',
      info2: '仓储（服务6）按每满或不足一天计费，每立方米每天13.5。体积四舍五入至0.001立方米。',
      info3: '退还给卖家（服务8）— 费用按具体物流公司与路线单独计算。',
      info4: '所有价格不含平台佣金及税费。',
    },
    // Landing
    landing: {
      home: '首页',
      heroTitle: '电商仓库与退货管理',
      heroSubtitle: '连接店铺，在一个地方管理退货与仓储。',
      login: '登录',
      register: '注册',
      connectService: '连接服务',
      featuresTitle: '为什么选择我们',
      feature1Title: '退货与仓储',
      feature1Text: '在一个系统中管理退货与仓储操作。',
      feature2Title: '速度与透明',
      feature2Text: '实时状态与清晰计费。',
      feature3Title: '安全',
      feature3Text: '您的数据受保护并符合规范。',
      ctaTitle: '开始使用',
      ctaText: '登录或注册以连接您的店铺。',
    },
    // Footer
    footer: {
      copyright: '© {{year}} Indigo Warehouse. 版权所有。',
      pricing: '价格与示例',
      offer: '服务协议',
      faq: '常见问题',
      aboutProject: '关于项目',
    },
    // Common
    common: {
      loading: '加载中...',
      error: '错误',
      success: '成功',
      hello: '你好',
      cancel: '取消',
      close: '关闭',
      save: '保存',
      saving: '保存中...',
      update: '更新',
      updating: '更新中...',
      back: '返回',
      home: '首页',
      currency: {
        yen: '¥',
        ruble: '₽',
      },
      yes: 'Да',
      no: 'Нет',
    },
    // Admin Orders
    adminOrders: {
      title: '订单管理 (管理员)',
      orderNumber: '订单号',
      status: '状态',
      store: '店铺',
      trackingNumbers: '快递单号',
      product: '商品',
      dstOfficeAddress: '退货取件点地址',
      returnStatus: '退货状态',
      allReturnStatuses: '全部退货状态',
      returnStatusActive: '有效',
      returnStatusArchived: '已归档',
      readyToReturnDt: '退货就绪日期',
      createdDate: '创建日期',
      actions: '操作',
      details: '详情',
      hide: '隐藏',
      edit: '编辑',
      searchPlaceholder: '订单号、快递、SKU、条码、WB stickerId、WB shkId（子串；纯数字则精确）、自提地址…',
      allStatuses: '所有状态',
      storeIdPlaceholder: '店铺ID',
      customer: '客户',
      tracking: '快递',
      seller: '卖家',
      orderInfo: '订单信息',
      id: 'ID',
      whEnterId: 'WH入库ID',
      whSyncError: 'WH同步错误',
      productInfo: '商品信息',
      defective: '缺陷',
      needsCheck: '需要检查',
      defectAfterCheck: '检查后缺陷',
      needsPhotoVideo: '需要照片/视频',
      comments: '备注',
      attachments: '附件',
      addAttachment: '添加附件',
      showing: '显示 {{from}} - {{to}} 共 {{total}}',
      editOrder: '编辑订单',
      statusLabel: '状态',
      storeId: '店铺ID',
      customerTrackingNumber: '客户快递单号',
      trackingNumber: '快递单号',
      sellerTrackingNumber: '卖家快递单号',
      itemFields: '商品字段',
      inspectionComments: '检验备注',
      cancel: '取消',
      save: '保存',
      addAttachmentTitle: '添加附件',
      attachmentType: '附件类型',
      photo: '照片',
      video: '视频',
      file: '文件',
      upload: '上传',
      attachmentFilesSelected: '已选择 {{count}} 个文件',
      accessDenied: '拒绝访问。需要超级管理员权限。',
      deleteAttachment: '删除附件？',
      statusTransitionSection: '状态变更（历史）',
      statusTransitionHint:
        '显示在所选时间范围内进入任一勾选状态的订单（按状态变更时间）。与其他筛选条件为“与”关系。',
      statusTransitionDateFrom: '变更自',
      statusTransitionDateTo: '变更至',
      statusTransitionTargetStatuses: '进入的状态',
      statusTransitionClear: '清除变更筛选',
      statusTransitionIncomplete: '请选择日期范围并至少勾选一个状态。',
      statusTransitionActiveNote: '已启用状态变更筛选。符合条件的订单总数：{{total}}。',
      dimensionsWeight: '尺寸与重量',
      disposalModalTitle: '销毁费用',
      disposalModalHint: '每个订单行一条扣费。已知毛重（千克）时建议金额为 重量×3.5 ¥，可逐行修改。',
      disposalApplyAuto: '按重量填写（千克 × 3.5 ¥）',
      disposalAmountYuan: '金额（¥）',
      disposalWeightLine: '毛重：{{kg}} 千克 — 建议 {{suggested}} ¥',
      disposalWeightUnknown: '商品重量未知 — 请手动输入金额。',
      disposalConfirm: '创建扣费并设为已销毁',
    },
    // Returns Table
    returns: {
      allReturns: '所有退货',
      inTransit: '运输中商品',
      inWarehouse: '仓库存储',
      ordersInProcessing: '处理中的订单',
      ordersPendingDecision: '待决定的订单',
      completedOrders: '已完成订单',
      returnsOtherPvz: '发往其他自提点的退货',
      filterByOtherPvz: '发往其他自提点的订单',
      otherPvzTrue: '仅其他自提点',
      otherPvzFalse: '仅 Indigo 自提点',
      pvzScopeFilter: 'WB 自提地址',
      pvzScopeAll: '全部地址',
      pvzScopeShosseynaya: '莫斯科，Shosseynaya 4k3',
      pvzScopeProezd3723: '规划通道 3723，莫斯科 109548',
      pvzScopeOther: '其他自提点',
      pvzScopeOur: '我方自提点（上述两项）',
      wbDtFrom: 'WB 日期起',
      wbDtTo: 'WB 日期止',
      wbDtFieldsHint: '按 WB 字段筛选（多选为或）',
      wbDtFieldCompleted: 'completedDt',
      wbDtFieldReady: 'readyToReturnDt',
      wbDtFieldExpired: 'expiredDt',
      wbDtFieldOrder: 'orderDt',
      otherPvzContactBanner: '如需取回这些商品，请在聊天中联系我们。',
      whBillingCharges: 'WH 费用',
      finances: '财务',
      filters: '筛选',
      // Table columns - In Transit
      returnRequestDate: '退货申请日期',
      product: '商品',
      dimensionsWeight: '尺寸与重量',
      unitCm: '厘米',
      unitKg: '千克',
      dimensionsUnknownShort: '—',
      weightUnknownShort: '重量未知',
      dimensionsWeightUnavailable: '暂无尺寸与重量',
      sku: '商品编号',
      barcode: '条形码',
      returnNumber: '退货编号',
      sticker: '标签',
      defectiveItem: '缺陷商品?',
      needsCheck: '需要检查',
      needsPhotoVideo: '需要照片/视频?',
      decisionOnProduct: '商品决定',
      status: '状态',
      trackingNumber: '快递单号',
      sellerTrackingNumber: '卖家快递单号',
      // Table columns - In Warehouse
      isDefectAfterCheck: '检查后缺陷',
      photoVideo: '照片/视频',
      receiptDate: 'Indigo仓库收货日期',
      returnNumber: '退货编号',
      attachedFiles: '附件',
      photo: '照片',
      video: '视频',
      inspectionComments: '检验评论/建议',
      acceptSuggestion: '接受建议',
      productImageComingSoon: '即将推出',
      wbImageNotFound: '未找到',
      // Yes/No buttons
      yes: '是',
      no: '否',
      // Status decisions
      transferToSale: '转为销售',
      sellOnWB: '在WB销售',
      dispose: '处置',
      disposeIn7Days: '7天后处置',
      sendToSeller: '退回卖家',
      // Filters
      searchPlaceholder: '按商品、编号、条形码、退货号搜索...',
      dateFrom: '开始日期',
      dateTo: '结束日期',
      allStatuses: '所有状态',
      filterByDefect: '按缺陷筛选',
      applyFilters: '应用筛选',
      clearFilters: '清除筛选',
      // Confirmations and warnings
      confirmNeedsCheckTitle: '确认检验请求',
      confirmNeedsCheckMessage: '您确定要请求检验吗？此操作不可逆，无法撤销。',
      alsoRequirePhotoVideo: '同时需要照片/视频',
      confirmAction: '是的，请求检验',
      deliveryAddressRequired: '请先在个人资料中填写收货地址，然后再申请退货。',
      returnNumber: '退货编号',
      sticker: '标签',
      // Status change modal
      chooseAction: '选择操作',
      statusChangeTitle: '商品决定',
      statusChangeMessage: '选择如何处理此商品：',
      confirmStatusChange: '确认',
      photoVideoRequiresCheck: '只有在需要检验时才能要求照片/视频。',
      errorPhotoVideoWithoutCheck: '未启用检验时无法启用照片/视频要求。请先启用检验。',
      errorCannotDisableCheck: '无法禁用检验。此操作不可逆。',
      errorUpdateFailed: '更新失败，请重试。',
      // Table states
      noItemsFound: '未找到商品',
      loadingItems: '加载商品中...',
      errorLoadingItems: '加载商品出错',
      // Pagination
      showingItems: '显示 {{from}}-{{to}} 共 {{total}} 项',
      itemsPerPage: '每页显示',
      // Links
      downloadAttachment: '下载附件',
      attachmentCommentPlaceholder: '对此验货照片的评论',
      saveAttachmentComment: '保存评论',
      bulkSelectColumn: '选择行',
      bulkSelectPage: '全选本页',
      bulkClearSelection: '清除选择',
      bulkSelectedCount: '已选：{{count}}',
      bulkNeedsCheckOn: '检验：是（所选）',
      bulkNeedsCheckOff: '检验：否（所选）',
      bulkNeedsCheckPending: '请求检验（所选）',
      bulkPhotoVideoOn: '要求照片/视频（所选）',
      bulkDecisionForSelected: '所选商品决策…',
      bulkStatusModalIntro: '批量操作',
      bulkStatusModalCount: '{{count}} 项',
      bulkConfirmNeedsCheckCount: '为 {{count}} 项请求检验？此操作不可撤销。',
      bulkPartialFailure: '{{total}} 项中有 {{failed}} 项未能更新。列表已刷新。',
    },
    // Support Chat
    support: {
      chat: {
        connectionError: '连接错误。请检查与服务器的连接。',
        connectionErrorNoToken: '未找到授权令牌。请重新登录。',
        reconnectError: '重新连接到聊天失败',
        connectionClosed: '聊天连接已关闭',
      },
      supportChat: '支持聊天',
      chatWith: '与聊天',
      online: '在线',
      archived: '已归档',
      chatNotFound: '未找到聊天',
      enterMessage: '输入消息...',
      send: '发送',
      justNow: '刚刚',
      goToChat: '前往聊天',
      support: '支持',
      allChats: '所有聊天',
      myChats: '我的聊天',
      archive: '归档',
      active: '活跃',
      newChat: '新聊天',
      searchChats: '搜索聊天...',
      search: '搜索...',
      nothingFound: '未找到',
      noChats: '没有聊天',
      noChatsYet: '您还没有任何聊天',
      open: '打开',
      closed: '关闭',
      unarchive: '取消归档',
      toArchive: '归档',
      noSelectedChat: '未选择聊天',
      selectChatToView: '选择要查看的聊天',
      newSupportChat: '新的支持聊天',
      subject: '主题',
      describeProblem: '描述您的问题...',
      create: '创建',
      cancel: '取消',
      failedToLoadChats: '加载聊天失败',
      failedToChangeArchive: '更改归档状态失败',
      failedToCreateChat: '创建聊天失败',
      failedToLoadChat: '加载聊天失败',
      failedToUploadFile: '上传文件失败',
      chatInArchive: '聊天已归档。无法发送消息。',
      attachment: '[附件]',
      minutesAgo: '{{minutes}} 分钟前',
      invalidFileType: '不支持的文件类型。允许：图片 ({{imageExts}}) 和视频 ({{videoExts}})',
      fileSizeExceeded: '文件大小不能超过 50MB。当前大小：{{currentSize}}MB',
      reply: '回复',
      replyToMessage: '回复消息',
      primaryTab: '用户主会话',
      openOldThreads: '历史主题',
      backToMainChat: '返回主会话',
      filterByStoreId: '店铺 ID（筛选）',
      markAsUnread: '标为未读',
      markUnreadFailed: '无法标为未读',
      broadcastTitle: '向用户聊天群发',
      broadcastOpen: '群发',
      broadcastAudience: '受众',
      broadcastAudienceAll: '所有客户（活跃、非管理员）',
      broadcastAudienceStore: '店铺 ID 包含以下子串的用户',
      broadcastAudienceUsers: '指定用户（用户 ID）',
      broadcastStoreIdHint: 'WB store_id 子串（与列表筛选相同）',
      broadcastUserIdsHint: '逗号分隔的数字 ID，例如 12, 34, 56',
      broadcastUserIdsLabel: '用户 ID',
      broadcastMessageLabel: '消息正文',
      broadcastTranslatedLabel: '管理员译文/备注（可选）',
      broadcastSend: '发送给所有目标',
      broadcastSending: '发送中…',
      broadcastDone: '完成：已发 {{sent}}，失败 {{failed}}。',
      broadcastError: '群发失败',
      broadcastSuperuserOnly: '仅超级管理员可群发。',
      broadcastConfirm: '向所选受众的每位用户发送此消息？',
      broadcastNeedStoreId: '请输入店铺 ID 子串。',
      broadcastNeedUserIds: '请至少输入一个数字用户 ID。',
    },
  },
  tr: {
    // Navigation
    nav: {
      allStores: 'Tüm Mağazalar',
      addStore: 'Mağaza Ekle',
      billings: 'Faturalar',
      accounts: 'Hesaplar',
      support: 'Destek',
      profile: 'Profil',
      signOut: 'Çıkış',
      selectStore: 'Mağaza Seç',
      adminOrders: 'Yönetici: Siparişler',
      adminSupport: 'Yönetici: Destek',
      adminBillings: 'Faturalar',
      goodsOnSale: 'Satıştaki ürünler',
      createSuperuser: 'Create superadmin',
      adminWbReturns: 'WB: Mağaza iadeleri',
      notifications: 'Bildirimler',
    },
    notifications: {
      empty: 'Bildirim yok',
      markRead: 'Okudum',
      languageLabel: 'Görüntüleme dili',
      apiTokenTitle: 'API anahtarı doğrulanamadı',
      apiTokenBody:
        '«{{storeName}}» mağazası için planlı kontrol başarısız. Senkronizasyonu geri yüklemek için pazar yeri API anahtarını güncelleyin.',
      addApiToken: 'API anahtarı ekle',
      apiTokenDismiss: 'Sonraki girişe kadar gizle',
    },
    errors: {
      serviceUnavailable:
        'Hizmete geçici olarak ulaşılamıyor. Bakım veya sunucu yeniden başlatması olabilir. Birkaç dakika bekleyip sayfayı yenileyin.',
      serviceUnavailableShort:
        'Site geçici olarak kullanılamıyor (bakım veya yeniden başlatma). Lütfen birkaç dakika sonra tekrar deneyin.',
      unknown: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    },
    billing: {
      title: 'Hesaplar',
      currentBalance: 'Güncel bakiye',
      topUp: 'Yükleme',
      deducted: 'Düşülen',
      dateFrom: 'Başlangıç (faturalama tarihi)',
      dateTo: 'Bitiş (faturalama tarihi)',
      type: 'Tür',
      orderNo: 'Sipariş no',
      searchProductBarcode: 'Ürün, barkod...',
      apply: 'Uygula',
      downloadExcel: 'Excel indir',
      downloadPdf: 'PDF raporu indir',
      accountsPdfFilename: 'accounts_report',
      noExpenses: 'Seçilen dönemde işlem yok.',
      shownOf: '{{from}}–{{to}} / {{total}}',
      perPage: 'sayfa başına',
      back: 'Geri',
      next: 'İleri',
      pageOf: 'Sayfa {{page}} / {{total}}',
      date: 'Tarih',
      service: 'Hizmet',
      orderStatus: 'Sipariş durumu',
      orderDate: 'Sipariş tarihi',
      product: 'Ürün',
      amount: 'Tutar (¥)',
      allTypes: 'Tüm türler',
      type_storage_daily: 'Günlük depolama',
      type_storage_warehouse: 'WH depolama (stok/sevkiyat)',
      type_prepare_return_to_seller: 'Satıcıya iade hazırlığı',
      type_disposal: 'İmha',
      type_packaging_shipment: 'Paketleme ve gönderim',
      type_inspection_no_media: 'Ürün incelemesi',
      type_inspection_with_media: 'Defolu ürün incelemesi (fotoğraflarla)',
      type_receipt_warehouse: 'Depoda teslim alma',
      type_receipt_pickup: 'PVD\'de teslim alma',
      type_balance_top_up: 'Bakiye yükleme',
      whStockUnits: 'WH stok adedi',
      byStore: 'Mağazaya göre',
      depositWarningBanner: 'Dikkat! Teklifte açıklanan işbirliği koşullarına göre, negatif bakiye durumunda Flydarin yalnızca ürünleri kabul edebilir, kontrol edebilir ve saklayabilir; satışa sunulmayacaktır. Kesintisiz hizmet için lütfen bu sayfadaki QR kodu ile AliPay üzerinden bakiyenizi yükleyin. 1 mağaza bağlanırken minimum depozito = 1000 yuan, 2 mağaza = her biri 700 yuan, 3 veya daha fazla mağaza = her biri 500 yuan. Fonlar 24 saat içinde bakiyenize yatırılacaktır.',
      sendReceiptHint: 'Lütfen depozito ödedikten sonra mutlaka makbuz veya ekran görüntüsü gönderin.',
      sendReceiptButton: 'Makbuz gönder',
      payWithAlipay: 'AliPay ile öde',
      payWithAlipayHint:
        'Mağaza seçin ve CNY cinsinden istediğiniz yükleme tutarını girin. AliPay ödemeyi onaylayınca bakiye otomatik güncellenir.',
      payWithAlipayCustomHint:
        'Seçili mağaza için yükleme tutarını girin ve resmi AliPay ödeme sayfasını açın.',
      payWithAlipayStoreLabel: 'Mağaza',
      payWithAlipayAmountLabel: 'Yükleme tutarı (CNY)',
      payWithAlipayFillDebt: 'Borç tutarını doldur ({{amount}} ¥)',
      payWithAlipayAmountRequired: 'Geçerli bir tutar girin (minimum 0,01 ¥).',
      payWithAlipayStoreRequired: 'Mağaza seçin.',
      payWithAlipayNoStores: 'Hesabınıza bağlı mağaza yok.',
      payWithAlipayPagePrimaryHint:
        'Önerilen: bu tarayıcıda ödeyin — resmi AliPay ödeme sayfasına yönlendirilirsiniz (page pay).',
      payWithAlipayPageNewTab: 'Yeni sekmede aç',
      payWithAlipayNegativeOnly: 'Canlı QR ödemesi yalnızca mağaza bakiyesi negatifken kullanılabilir.',
      payWithAlipayButton: 'Ödeme QR al',
      payWithAlipayAmount: 'Tutar',
      payWithAlipayOrderNo: 'Sipariş no',
      payWithAlipayReused: 'Mevcut ödenmemiş QR hâlâ geçerli',
      payWithAlipayScanHint: 'AliPay ile bu kodu tarayın.',
      payWithAlipayCreditHint: 'AliPay ödemeyi onayladığında bakiye otomatik yüklenir; bu akış için makbuz gerekmez.',
      payWithAlipayCopyPayload: 'QR içeriğini kopyala',
      payWithAlipayCopied: 'Kopyalandı',
      payWithAlipayPageButton: 'AliPay sayfasını aç',
      payWithAlipayPagePopupBlocked: 'Tarayıcı açılır pencereyi engelledi. Lütfen izin verip tekrar deneyin.',
      payWithAlipayPageNoUrl: 'AliPay ödeme bağlantısı alınamadı.',
    },
    // Dashboard cards
    dashboard: {
      inTransit: 'Yolda',
      warehouse: 'IndigoDepo',
      storedIn: 'Depoda',
      completedReturns: 'Tamamlanan İadeler',
      returnRequests: 'İade Talepleri',
      ordersInProcessing: 'İşlenen Siparişler',
      ordersPendingDecision: 'Karar Bekleyen',
      completedOrders: 'Tamamlanan Siparişler',
      items: 'ürün',
      or: 'veya',
      viewItemsInTransit: 'Yoldaki ürünleri görüntüle',
      viewReturnsOtherPvz: 'Diğer PVD iadelerini görüntüle',
      viewReturnData: 'İade verilerini görüntüle',
      viewFinancialReport: 'Finansal raporu görüntüle',
      processReturns: 'İadeleri işle',
      viewProcessingOrders: 'İşlenen siparişleri görüntüle',
      viewCompletedOrders: 'Tamamlanan siparişleri görüntüle',
    },
    // Add Store Modal
    addStore: {
      title: 'Mağaza Ekle',
      selectMarketplace: 'Pazar Yeri Seçin',
      wildberries: 'Wildberries',
      ozon: 'Ozon',
      yandexMarket: 'Yandex Market',
      comingSoon: 'Yakında',
      storeName: 'Mağaza Adı',
      storeNamePlaceholder: 'Mağazam',
      storeNameHint: 'Mağazanıza kolay tanımlama için bir isim verin',
      enterApiKey: 'JWT API Anahtarını Girin',
      apiKeyPlaceholder: 'JWT API anahtarınızı buraya yapıştırın...',
      cancel: 'İptal',
      add: 'Mağaza Ekle',
      adding: 'Ekleniyor...',
      success: 'Mağaza başarıyla eklendi!',
      error: 'Mağaza eklenemedi',
      invalidToken: 'Geçersiz veya süresi dolmuş token',
      storeExists: 'Bu mağaza zaten bağlı',
    },
    // Profile
    profile: {
      title: 'Profil Bilgileri',
      email: 'E-posta',
      emailCannotChange: 'E-posta değiştirilemez',
      wechatId: 'WeChat ID',
      telegramUsername: 'Telegram',
      messengerHint: 'Mesajlaşma iletişim bilgileri',
      firstName: 'Ad',
      lastName: 'Soyad',
      accountStatus: 'Hesap Durumu',
      emailVerified: 'E-posta Doğrulandı',
      memberSince: 'Üyelik Tarihi',
      edit: 'Düzenle',
      save: 'Değişiklikleri Kaydet',
      saving: 'Kaydediliyor...',
      cancel: 'İptal',
      updateSuccess: 'Profil başarıyla güncellendi!',
      updateError: 'Profil güncellenemedi. Lütfen tekrar deneyin.',
      // Delivery address
      deliveryAddressTitle: 'Teslimat Adresi',
      deliveryAddressDescription: 'Ürün iadelerini almak için teslimat adresiniz gereklidir.',
      deliveryAddressWarning: 'Ürün iadesi talep edebilmek için lütfen teslimat adresinizi doldurun.',
      addressUpdateSuccess: 'Adres başarıyla güncellendi!',
      addressStreet: 'Sokak Adresi',
      addressStreetPlaceholder: 'Örnek Caddesi No: 123, Daire 4',
      addressCity: 'Şehir',
      addressCityPlaceholder: 'İstanbul',
      addressPostalCode: 'Posta Kodu',
      addressPostalCodePlaceholder: '34000',
      addressCountry: 'Ülke',
      addressCountryPlaceholder: 'Türkiye',
      addressPhone: 'Telefon Numarası',
      addressPhonePlaceholder: '+90 (555) 123-45-67',
      // Legal documents
      documentsTitle: 'Tüzel Kişilik Belgeleri',
      documentsDescription: 'Tüzel kişiliğinizle ilgili PDF belgeleri yükleyin. Maksimum dosya boyutu: 10MB.',
      documentsUpload: 'PDF Yükle',
      documentsUploading: 'Yükleniyor...',
      documentsEmpty: 'Henüz belge yüklenmedi',
      documentsOnlyPdf: 'Sadece PDF dosyalarına izin verilir',
      documentsMaxSize: 'Dosya boyutu 10MB\'ı aşamaz',
      documentsUploadSuccess: 'Belge başarıyla yüklendi!',
      documentsUploadError: 'Belge yüklenemedi',
      documentsDeleteSuccess: 'Belge başarıyla silindi!',
      documentsDeleteError: 'Belge silinemedi',
      documentsConfirmDelete: 'Bu belgeyi silmek istediğinizden emin misiniz?',
      autoReturnCheckTitle: 'Otomatik iade doğrulama',
      autoReturnCheckHint:
        'Mağaza başına: açıkken yeni iade kalemleri depo doğrulaması gerektirir; kapalıyken doğrulama olmadan oluşturulur.',
      autoReturnCheckLoadError: 'Mağazalar yüklenemedi.',
      autoReturnCheckUpdateError: 'Ayar kaydedilemedi. Lütfen tekrar deneyin.',
      autoReturnCheckNoStores: 'Bağlı mağaza yok. Önce kontrol panelinden mağaza ekleyin.',
    },
    // Security
    security: {
      title: 'Güvenlik',
      changePassword: 'Şifre Değiştir',
      currentPassword: 'Mevcut Şifre',
      newPassword: 'Yeni Şifre',
      confirmPassword: 'Yeni Şifreyi Onayla',
      update: 'Şifreyi Güncelle',
      updating: 'Güncelleniyor...',
      success: 'Şifre başarıyla değiştirildi!',
    },
    // Stores
    stores: {
      title: 'Mağazalarım',
      noStores: 'Henüz bağlı mağaza yok',
      addFirst: 'Başlamak için ilk mağazanızı ekleyin',
      connected: 'Bağlı',
      storeId: 'Mağaza ID',
      edit: 'Mağazayı düzenle',
      editTitle: 'Mağaza Adını Düzenle',
      storeName: 'Mağaza Adı',
      storeNamePlaceholder: 'Mağaza adını girin',
      storeNameHint: 'Mağazanıza kolay tanımlama için bir isim verin',
      editError: 'Mağaza güncellenemedi',
      // Verification status
      verifying: 'Doğrulanıyor...',
      verified: 'Doğrulandı',
      verificationFailed: 'Doğrulama Başarısız',
      verificationFailedMessage: 'Token doğrulaması başarısız oldu. Lütfen bu mağazayı silin ve geçerli bir API anahtarıyla tekrar ekleyin.',
      verificationPending: 'Doğrulama devam ediyor...',
      deleteStore: 'Mağazayı Sil',
      deleteStoreConfirm: 'Bu mağazayı silmek istediğinizden emin misiniz?',
    },
    // Auth
    auth: {
      login: 'Giriş Yap',
      register: 'Kayıt Ol',
      email: 'E-posta',
      password: 'Şifre',
      confirmPassword: 'Şifreyi Onayla',
      rememberMe: 'Beni hatırla',
      forgotPassword: 'Şifremi unuttum?',
      noAccount: 'Hesabınız yok mu?',
      haveAccount: 'Zaten hesabınız var mı?',
      signUpNow: 'Kayıt olun',
      signInNow: 'Giriş yapın',
      firstName: 'Ad',
      lastName: 'Soyad',
      welcomeBack: 'Tekrar Hoş Geldiniz',
      signInToAccount: 'Hesabınıza giriş yapın',
      enterEmail: 'E-postanızı girin',
      enterPassword: 'Şifrenizi girin',
      signingIn: 'Giriş yapılıyor...',
      loginFailed: 'Giriş başarısız. Lütfen tekrar deneyin.',
      createAccount: 'Hesap Oluştur',
      joinUs: 'Bize katılın',
      signingUp: 'Hesap oluşturuluyor...',
      registrationFailed: 'Kayıt başarısız. Lütfen tekrar deneyin.',
      pricingAndExample: 'Fiyatlarımız ve örnekler',
      resetPassword: 'Şifre Sıfırla',
      enterEmailReset: 'Şifre sıfırlama için e-postanızı girin',
      sendResetLink: 'Sıfırlama Linki Gönder',
      sending: 'Gönderiliyor...',
      backToLogin: 'Girişe dön',
      checkEmail: 'E-postanızı Kontrol Edin',
      resetLinkSent: 'Şifre sıfırlama linki gönderildi',
      newPasswordTitle: 'Yeni Şifre Belirle',
      enterNewPassword: 'Yeni şifrenizi girin',
      confirmNewPassword: 'Yeni şifrenizi onaylayın',
      resetPasswordBtn: 'Şifreyi Sıfırla',
      resetting: 'Sıfırlanıyor...',
      passwordResetSuccess: 'Şifre Başarıyla Sıfırlandı',
      passwordResetSuccessMsg: 'Şifreniz başarıyla sıfırlandı.',
      registrationSuccess: 'Kayıt Başarılı',
      verifyEmailMsg: 'Hesabınızı doğrulamak için e-postanızı kontrol edin.',
      verifyingEmail: 'E-posta doğrulanıyor...',
      emailVerified: 'E-posta Doğrulandı',
      emailVerifiedMsg: 'E-postanız başarıyla doğrulandı.',
      resendVerification: 'Doğrulama e-postasını tekrar gönder',
      // Forgot Password
      forgotPasswordTitle: 'Şifremi Unuttum?',
      forgotPasswordSubtitle: 'Endişelenmeyin, size sıfırlama talimatları göndereceğiz',
      forgotPasswordFailed: 'Sıfırlama e-postası gönderilemedi. Lütfen tekrar deneyin.',
      // Reset Sent
      resetSentTitle: 'E-postanızı Kontrol Edin',
      resetSentMessage: 'Şifre sıfırlama talimatlarını gönderdik',
      resetSentInfo: 'Bu e-posta ile bir hesap varsa, şifrenizi sıfırlama talimatlarını alacaksınız. Birkaç dakika içinde görmüyorsanız spam klasörünüzü kontrol edin.',
      // Reset Password
      resetPasswordTitle: 'Şifre Sıfırla',
      resetPasswordSubtitle: 'Yeni şifrenizi aşağıya girin',
      newPasswordLabel: 'Yeni Şifre',
      newPasswordPlaceholder: 'En az 8 karakter',
      confirmNewPasswordLabel: 'Şifreyi Onayla',
      confirmNewPasswordPlaceholder: 'Yeni şifrenizi onaylayın',
      passwordsDoNotMatch: 'Şifreler eşleşmiyor',
      resetPasswordFailed: 'Şifre sıfırlanamadı. Lütfen tekrar deneyin.',
      // Reset Success
      resetSuccessTitle: 'Şifre Sıfırlama Tamamlandı',
      resetSuccessMessage: 'Şifreniz başarıyla sıfırlandı.',
      resetSuccessInfo: 'Artık yeni şifrenizle giriş yapabilirsiniz.',
      continueToSignIn: 'Giriş Yapmaya Devam Et',
      // Verify Email
      verifyingEmailTitle: 'E-postanız Doğrulanıyor',
      verifyingEmailMessage: 'E-posta adresinizi doğrularken lütfen bekleyin...',
      emailVerifiedTitle: 'E-posta Doğrulandı!',
      emailVerifiedMessage: 'E-postanız başarıyla doğrulandı.',
      emailVerifiedInfo: 'Hesabınız artık aktif. Kısa süre içinde giriş sayfasına yönlendirileceksiniz...',
      verificationFailedTitle: 'Doğrulama Başarısız',
      verificationFailedMessage: 'E-posta adresinizi doğrulayamadık',
      verificationFailedInfo: 'Doğrulama bağlantısının süresi dolmuş veya zaten kullanılmış olabilir. Lütfen giriş yapmayı deneyin veya yeni bir doğrulama e-postası isteyin.',
      goToLogin: 'Giriş Sayfasına Git',
      // Registration Success
      registrationSuccessTitle: 'E-postanızı Kontrol Edin',
      registrationSuccessMessage: 'Doğrulama bağlantısını gönderdik',
      registrationSuccessImportant: 'Önemli:',
      registrationSuccessInfo: 'Giriş yapmadan önce e-posta adresinizi doğrulamanız gerekir. Hesabınızı etkinleştirmek için gönderdiğimiz e-postadaki bağlantıya tıklayın.',
      didntReceiveEmail: 'E-posta almadınız mı?',
      resendVerificationEmail: 'Doğrulama e-postasını tekrar gönder',
      verificationEmailResent: 'Doğrulama e-postası tekrar gönderildi. Lütfen gelen kutunuzu kontrol edin.',
      resendEmailFailed: 'E-posta tekrar gönderilemedi. Lütfen tekrar deneyin.',
      alreadyVerified: 'Zaten doğrulandı mı?',
      contactUs: 'Bize ulaşın',
      telegramChat: 'Telegram sohbeti',
      faq: 'SSS',
      aboutProject: 'Proje Hakkında',
    },
    // Register
    register: {
      title: 'Hesap Oluştur',
      subtitle: 'Başlamak için kayıt olun',
      firstName: 'Ad',
      firstNamePlaceholder: 'Ahmet',
      lastName: 'Soyad',
      lastNamePlaceholder: 'Yılmaz',
      email: 'E-posta',
      emailPlaceholder: 'your@email.com',
      password: 'Şifre',
      passwordPlaceholder: 'En az 8 karakter',
      confirmPassword: 'Şifreyi Onayla',
      confirmPasswordPlaceholder: 'Şifrenizi onaylayın',
      submit: 'Hesap Oluştur',
      creating: 'Hesap oluşturuluyor...',
      haveAccount: 'Zaten hesabınız var mı?',
      signIn: 'Giriş yapın',
      passwordsDoNotMatch: 'Şifreler eşleşmiyor',
      failed: 'Kayıt başarısız. Lütfen tekrar deneyin.',
      agreeToOffer: 'Okudum ve kabul ediyorum',
      offerLink: 'Teklif',
      agreeToDataProcessing: 'Kişisel verilerin işlenmesine izin veriyorum',
      mustAgreeToOffer: 'Kayıt olmak için teklifi kabul etmelisiniz',
      mustAgreeToDataProcessing: 'Kayıt olmak için veri işlemeyi kabul etmelisiniz',
      wechatId: 'WeChat ID',
      telegramUsername: 'Telegram kullanıcı adı',
      messengerHint: 'WeChat ID veya Telegram kullanıcı adından en az birini girin',
    },
    // Forgot Password
    forgotPassword: {
      title: 'Şifremi Unuttum?',
      subtitle: 'Endişelenmeyin, size sıfırlama talimatları göndereceğiz',
      emailLabel: 'E-posta',
      emailPlaceholder: 'E-postanızı girin',
      sendResetLink: 'Sıfırlama Linki Gönder',
      sending: 'Gönderiliyor...',
      backToLogin: 'Girişe dön',
      failed: 'Sıfırlama e-postası gönderilemedi. Lütfen tekrar deneyin.',
    },
    // Reset Sent
    resetSent: {
      title: 'E-postanızı Kontrol Edin',
      message: 'Şifre sıfırlama talimatlarını gönderdik',
      info: 'Bu e-posta ile bir hesap varsa, şifrenizi sıfırlama talimatlarını alacaksınız. Birkaç dakika içinde görmüyorsanız spam klasörünüzü kontrol edin.',
      backToLogin: 'Girişe dön',
    },
    // Reset Password
    resetPassword: {
      title: 'Şifre Sıfırla',
      subtitle: 'Yeni şifrenizi aşağıya girin',
      newPasswordLabel: 'Yeni Şifre',
      newPasswordPlaceholder: 'En az 8 karakter',
      confirmPasswordLabel: 'Şifreyi Onayla',
      confirmPasswordPlaceholder: 'Yeni şifrenizi onaylayın',
      resetButton: 'Şifreyi Sıfırla',
      resetting: 'Sıfırlanıyor...',
      backToLogin: 'Girişe dön',
      passwordsDoNotMatch: 'Şifreler eşleşmiyor',
      failed: 'Şifre sıfırlanamadı. Lütfen tekrar deneyin.',
    },
    // Reset Success
    resetSuccess: {
      title: 'Şifre Sıfırlama Tamamlandı',
      message: 'Şifreniz başarıyla sıfırlandı.',
      info: 'Artık yeni şifrenizle giriş yapabilirsiniz.',
      continueToSignIn: 'Giriş Yapmaya Devam Et',
    },
    // Verify Email
    verifyEmail: {
      verifyingTitle: 'E-postanız Doğrulanıyor',
      verifyingMessage: 'E-posta adresinizi doğrularken lütfen bekleyin...',
      successTitle: 'E-posta Doğrulandı!',
      successMessage: 'E-postanız başarıyla doğrulandı.',
      successInfo: 'Hesabınız artık aktif. Kısa süre içinde giriş sayfasına yönlendirileceksiniz...',
      continueToSignIn: 'Giriş Yapmaya Devam Et',
      failedTitle: 'Doğrulama Başarısız',
      failedMessage: 'E-posta adresinizi doğrulayamadık',
      failedInfo: 'Doğrulama bağlantısının süresi dolmuş veya zaten kullanılmış olabilir. Lütfen giriş yapmayı deneyin veya yeni bir doğrulama e-postası isteyin.',
      goToLogin: 'Giriş Sayfasına Git',
      invalidLink: 'Geçersiz doğrulama bağlantısı.',
      failedError: 'E-posta doğrulanamadı. Bağlantı geçersiz veya süresi dolmuş olabilir.',
    },
    // Registration Success
    registrationSuccess: {
      title: 'E-postanızı Kontrol Edin',
      message: 'Doğrulama bağlantısını gönderdik',
      important: 'Önemli:',
      info: 'Giriş yapmadan önce e-posta adresinizi doğrulamanız gerekir. Hesabınızı etkinleştirmek için gönderdiğimiz e-postadaki bağlantıya tıklayın.',
      didntReceiveEmail: 'E-posta almadınız mı?',
      resendButton: 'Doğrulama e-postasını tekrar gönder',
      sending: 'Gönderiliyor...',
      emailResent: 'Doğrulama e-postası tekrar gönderildi. Lütfen gelen kutunuzu kontrol edin.',
      resendFailed: 'E-posta tekrar gönderilemedi. Lütfen tekrar deneyin.',
      alreadyVerified: 'Zaten doğrulandı mı?',
      signIn: 'Giriş yapın',
    },
    // Pricing
    pricing: {
      title: 'Hizmet Ücretleri',
      subtitle: 'Hizmet ücretleri ve fiyat bilgileri',
      loadError: 'Fiyat tablosu yüklenemedi',
      downloadButton: 'Fiyat Listemizi İndirin',
      downloading: 'İndiriliyor...',
      downloadError: 'Fiyat listesi indirilemedi',
    },
    // Indigo Price List (static table on /pricing)
    priceList: {
      title: 'INDIGO Hizmet Fiyat Listesi',
      subhead: 'Hizmet tarifeleri — fiyatlar aksi belirtilmedikçe birim başına gösterilir.',
      colNo: 'No.',
      colService: 'Hizmet',
      colCost: 'Tutar (¥)',
      colNote: 'Not / ölçü birimi',
      r1_name: 'Depoda mal veya iade kabulü (adet)',
      r1_note: 'birim başına',
      r2_name: 'Teslimat noktasında kabul (adet)',
      r2_note: 'birim başına',
      r3_name: 'Ürün incelemesi',
      r3_note: 'birim başına',
      r4_name: 'Defolu ürün incelemesi (fotoğraflarla)',
      r4_note: 'birim başına',
      r5_main: 'Sipariş işleme (paketleme ve pazaryerine gönderim)',
      r5_50_name: '50 cm\'e kadar (kenar toplamı)',
      r5_50_note: 'U+G+Y ≤ 50 cm',
      r5_80_name: '80 cm\'e kadar',
      r5_80_note: 'toplam ≤ 80 cm',
      r5_100_name: '100 cm\'e kadar',
      r5_100_note: 'toplam ≤ 100 cm',
      r5_120_name: '120 cm\'e kadar',
      r5_120_note: 'toplam ≤ 120 cm',
      r5_180_name: '180 cm\'e kadar',
      r5_180_note: 'toplam ≤ 180 cm',
      r5_220_name: '220 cm\'e kadar',
      r5_220_note: 'toplam ≤ 220 cm',
      r5_oversized_name: 'büyük hacimli siparişler',
      r5_oversized_note: '220 cm üzeri veya standart dışı',
      r6_name: 'Depoda depolama (gönderime kadar)',
      r6_note: 'm³/gün başına',
      r7_name: 'Satıcıya iade için hazırlık',
      r7_note: 'birim başına',
      r8_name: 'Satıcıya iade',
      r8_note: 'kargo tarifesine göre (ayrı hesaplanır)',
      r8_price: 'bireysel',
      infoTitle: 'Önemli notlar',
      info1: 'Hizmet 5 (sipariş işleme) depodan pazaryerine müşteri siparişinin paketlenmesi ve gönderimini içerir. Maliyet üç boyut toplamına (uzunluk + genişlik + yükseklik, cm) bağlıdır.',
      info2: 'Depolama (hizmet 6) tam veya kısmi gün başına m³/gün 13,5 üzerinden ücretlendirilir. Hacim 0,001 m³\'e yuvarlanır.',
      info3: 'Satıcıya iade (hizmet 8) — maliyet belirli kargo ve güzergah için ayrı hesaplanır.',
      info4: 'Tüm fiyatlar pazaryeri komisyonları ve vergiler hariçtir.',
    },
    // Landing
    landing: {
      home: 'Ana Sayfa',
      heroTitle: 'Pazaryerleri için depo ve iade yönetimi',
      heroSubtitle: 'Mağazanızı bağlayın, iadeleri ve depolamayı tek yerden yönetin.',
      login: 'Giriş',
      register: 'Kayıt',
      connectService: 'Hizmeti bağla',
      featuresTitle: 'Neden bizi seçmelisiniz',
      feature1Title: 'İadeler ve depolama',
      feature1Text: 'İadeleri ve depo işlemlerini tek sistemde yönetin.',
      feature2Title: 'Hız ve şeffaflık',
      feature2Text: 'Anlık durumlar ve net faturalandırma.',
      feature3Title: 'Güvenlik',
      feature3Text: 'Verileriniz korunur ve uyumludur.',
      ctaTitle: 'Başlayın',
      ctaText: 'Mağazanızı bağlamak için giriş yapın veya hesap oluşturun.',
    },
    // Footer
    footer: {
      copyright: '© {{year}} Indigo Warehouse. Tüm hakları saklıdır.',
      pricing: 'Fiyatlandırma ve örnek',
      offer: 'Teklif',
      faq: 'SSS',
      aboutProject: 'Proje Hakkında',
    },
    // Common
    common: {
      loading: 'Yükleniyor...',
      error: 'Hata',
      success: 'Başarılı',
      hello: 'Merhaba',
      cancel: 'İptal',
      close: 'Kapat',
      save: 'Kaydet',
      saving: 'Kaydediliyor...',
      update: 'Güncelle',
      updating: 'Güncelleniyor...',
      back: 'Geri',
      home: 'Ana Sayfa',
      currency: {
        yen: '¥',
        ruble: '₽',
      },
      yes: 'Да',
      no: 'Нет',
    },
    // Admin Orders
    adminOrders: {
      title: 'Sipariş Yönetimi (Admin)',
      orderNumber: 'Sipariş Numarası',
      status: 'Durum',
      store: 'Mağaza',
      trackingNumbers: 'Takip Numaraları',
      product: 'Ürün',
      dstOfficeAddress: 'İade PVZ Adresi',
      returnStatus: 'İade Durumu',
      allReturnStatuses: 'Tüm iade durumları',
      returnStatusActive: 'Aktif',
      returnStatusArchived: 'Arşivlenmiş',
      readyToReturnDt: 'İade Hazır Tarihi',
      createdDate: 'Oluşturma Tarihi',
      actions: 'İşlemler',
      details: 'Detaylar',
      hide: 'Gizle',
      edit: 'Düzenle',
      searchPlaceholder:
        'Sipariş no, takip, SKU, barkod, WB stickerId, WB shkId (alt dize; sadece rakamsa tam eşleşme), PVZ adresi…',
      allStatuses: 'Tüm Durumlar',
      storeIdPlaceholder: 'Mağaza ID',
      customer: 'Müşteri',
      tracking: 'Takip',
      seller: 'Satıcı',
      orderInfo: 'Sipariş Bilgisi',
      id: 'ID',
      whEnterId: 'WH Giriş ID',
      whSyncError: 'WH Senkron Hatası',
      productInfo: 'Ürün Bilgisi',
      defective: 'Kusurlu',
      needsCheck: 'Kontrol Gerekli',
      defectAfterCheck: 'Kontrol Sonrası Kusur',
      needsPhotoVideo: 'Fotoğraf/Video Gerekli',
      comments: 'Yorumlar',
      attachments: 'Ekler',
      addAttachment: 'Ek Ekle',
      showing: '{{from}} - {{to}} / {{total}} gösteriliyor',
      editOrder: 'Siparişi Düzenle',
      statusLabel: 'Durum',
      storeId: 'Mağaza ID',
      customerTrackingNumber: 'Müşteri Takip Numarası',
      trackingNumber: 'Takip Numarası',
      sellerTrackingNumber: 'Satıcı Takip Numarası',
      itemFields: 'Ürün Alanları',
      inspectionComments: 'Kontrol Notları',
      cancel: 'İptal',
      save: 'Kaydet',
      addAttachmentTitle: 'Ek Ekle',
      attachmentType: 'Ek Türü',
      photo: 'Fotoğraf',
      video: 'Video',
      file: 'Dosya',
      upload: 'Yükle',
      attachmentFilesSelected: 'Seçilen: {{count}} dosya',
      accessDenied: 'Erişim reddedildi. Süper yönetici yetkisi gerekli.',
      deleteAttachment: 'Ek silinsin mi?',
      statusTransitionSection: 'Durum geçişi (geçmiş)',
      statusTransitionHint:
        'Seçili aralıkta işaretlenen durumlardan herhangi birine geçen siparişleri gösterir (değişim zamanına göre). Diğer filtrelerle VE ile birleşir.',
      statusTransitionDateFrom: 'Geçiş başlangıç',
      statusTransitionDateTo: 'Geçiş bitiş',
      statusTransitionTargetStatuses: 'Girilen durumlar',
      statusTransitionClear: 'Geçiş filtresini temizle',
      statusTransitionIncomplete: 'Tarih aralığı ve en az bir durum seçin.',
      statusTransitionActiveNote: 'Geçiş filtresi açık. Eşleşen sipariş sayısı: {{total}}.',
      dimensionsWeight: 'Boyut ve ağırlık',
      disposalModalTitle: 'İmha ücreti',
      disposalModalHint:
        'Sipariş satırı başına bir kesinti. Brüt ağırlık (kg) biliniyorsa önerilen tutar: ağırlık × 3,5 ¥. Her satırı düzenleyebilirsiniz.',
      disposalApplyAuto: 'Ağırlıktan doldur (kg × 3,5 ¥)',
      disposalAmountYuan: 'Tutar (¥)',
      disposalWeightLine: 'Brüt ağırlık: {{kg}} kg — önerilen {{suggested}} ¥',
      disposalWeightUnknown: 'Ürün ağırlığı bilinmiyor — tutarı elle girin.',
      disposalConfirm: 'Kesintileri oluştur ve «İmha edildi» yap',
    },
    // Returns Table
    returns: {
      allReturns: 'Tüm İadeler',
      inTransit: 'Transit Ürünler',
      inWarehouse: 'Depoda Saklanan',
      ordersInProcessing: 'İşlenen Siparişler',
      ordersPendingDecision: 'Karar Bekleyen Siparişler',
      completedOrders: 'Tamamlanan Siparişler',
      returnsOtherPvz: 'Diğer PVD’lere iadeler',
      filterByOtherPvz: 'Diğer PVD\'lere siparişler',
      otherPvzTrue: 'Yalnızca diğer PVD',
      otherPvzFalse: 'Yalnızca Indigo PVD',
      pvzScopeFilter: 'WB teslimat (PVD)',
      pvzScopeAll: 'Tüm adresler',
      pvzScopeShosseynaya: 'Moskova, Şosseynaya 4k3',
      pvzScopeProezd3723: '3723 geçidi, vl12, Moskova',
      pvzScopeOther: 'Diğer PVD',
      pvzScopeOur: 'Bizim PVD (ikisi)',
      wbDtFrom: 'WB tarih (başlangıç)',
      wbDtTo: 'WB tarih (bitiş)',
      wbDtFieldsHint: 'WB alanları (birden fazla = VEYA)',
      wbDtFieldCompleted: 'completedDt',
      wbDtFieldReady: 'readyToReturnDt',
      wbDtFieldExpired: 'expiredDt',
      wbDtFieldOrder: 'orderDt',
      otherPvzContactBanner: 'Bu ürünleri teslim almanız gerekiyorsa bizimle sohbet üzerinden iletişime geçin.',
      whBillingCharges: 'WH kesintileri',
      finances: 'Finans',
      filters: 'Filtreler',
      // Status values for filter dropdown
      statusAwaitingReceipt: 'WB\'de Alınmayı Bekliyor',
      statusReceivedAwaitingCheck: 'Alındı, Kontrol Bekliyor',
      statusAwaitingSellerDecision: 'Satıcı Kararı Bekliyor',
      statusAwaitingForSale: 'Satışa Aktarılmayı Bekliyor',
      statusTransferringToSale: 'Satışa Aktarılıyor',
      statusSubmittedForSale: 'Satışa Sunuldu',
      statusAwaitingShipment: 'Satıcıya Gönderilmeyi Bekliyor',
      statusAwaitingDisposal: 'İmha Edilmeyi Bekliyor',
      statusDisposed: 'İmha Edildi',
      statusSentToSeller: 'Satıcıya Gönderildi',
      // Table columns - In Transit
      returnRequestDate: 'İade Talep Tarihi',
      product: 'Ürün',
      dimensionsWeight: 'Boyut ve ağırlık',
      unitCm: 'cm',
      unitKg: 'kg',
      dimensionsUnknownShort: '—',
      weightUnknownShort: 'ağırlık bilinmiyor',
      dimensionsWeightUnavailable: 'Boyut ve ağırlık yok',
      sku: 'SKU',
      barcode: 'Barkod',
      returnNumber: 'İade Numarası',
      sticker: 'Etiket',
      defectiveItem: 'Kusurlu Ürün?',
      needsCheck: 'Doğrulama Gerekiyor',
      needsPhotoVideo: 'Fotoğraf/Video Gerekli?',
      decisionOnProduct: 'Ürün Kararı',
      status: 'Durum',
      trackingNumber: 'Takip Numarası',
      sellerTrackingNumber: 'Satıcı Takip Numarası',
      // Table columns - In Warehouse
      isDefectAfterCheck: 'Kontrol Sonrası Kusur',
      photoVideo: 'Fotoğraf/Video',
      receiptDate: 'IndigoDepo Teslim Alma Tarihi',
      returnNumber: 'İade Numarası',
      attachedFiles: 'Ekli Dosyalar',
      photo: 'Fotoğraf',
      video: 'Video',
      inspectionComments: 'Denetim Yorumları/Öneriler',
      acceptSuggestion: 'Öneriyi Kabul Et',
      productImageComingSoon: 'Çok yakında',
      wbImageNotFound: 'Bulunamadı',
      // Yes/No buttons
      yes: 'Evet',
      no: 'Hayır',
      // Status decisions
      transferToSale: 'Satışa Aktar',
      sellOnWB: "WB'de Sat",
      dispose: 'İmha Et',
      disposeIn7Days: '7 Gün İçinde İmha',
      sendToSeller: 'Satıcıya İade',
      // Filters
      searchPlaceholder: 'Ürün, SKU, barkod, iade numarası ara...',
      dateFrom: 'Başlangıç Tarihi',
      dateTo: 'Bitiş Tarihi',
      allStatuses: 'Tüm Durumlar',
      filterByDefect: 'Kusura Göre Filtrele',
      applyFilters: 'Filtreleri Uygula',
      clearFilters: 'Filtreleri Temizle',
      // Confirmations and warnings
      confirmNeedsCheckTitle: 'Doğrulama Talebini Onayla',
      confirmNeedsCheckMessage: 'Doğrulama talep etmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
      alsoRequirePhotoVideo: 'Ayrıca fotoğraf/video iste',
      confirmAction: 'Evet, Doğrulama Talep Et',
      // Status change modal
      chooseAction: 'İşlem Seç',
      statusChangeTitle: 'Ürün Kararı',
      statusChangeMessage: 'Bu ürün için ne yapılacağını seçin:',
      confirmStatusChange: 'Onayla',
      photoVideoRequiresCheck: 'Fotoğraf/video sadece doğrulama gerektiğinde istenebilir.',
      errorPhotoVideoWithoutCheck: 'Doğrulama olmadan fotoğraf/video gereksinimi etkinleştirilemez. Önce doğrulamayı etkinleştirin.',
      errorCannotDisableCheck: 'Doğrulama devre dışı bırakılamaz. Bu işlem geri alınamaz.',
      errorUpdateFailed: 'Güncelleme başarısız. Lütfen tekrar deneyin.',
      // Table states
      noItemsFound: 'Ürün bulunamadı',
      loadingItems: 'Ürünler yükleniyor...',
      errorLoadingItems: 'Ürünleri yüklerken hata',
      // Pagination
      showingItems: '{{total}} üründen {{from}}-{{to}} arası gösteriliyor',
      itemsPerPage: 'Sayfa başına',
      // Links
      downloadAttachment: 'Ek Dosya İndir',
      attachmentCommentPlaceholder: 'Doğrulama fotoğrafı için yorum',
      saveAttachmentComment: 'Yorumu kaydet',
      bulkSelectColumn: 'Satırı seç',
      bulkSelectPage: 'Sayfadakilerin tümünü seç',
      bulkClearSelection: 'Seçimi temizle',
      bulkSelectedCount: 'Seçili: {{count}}',
      bulkNeedsCheckOn: 'Doğrulama: evet (seçili)',
      bulkNeedsCheckOff: 'Doğrulama: hayır (seçili)',
      bulkNeedsCheckPending: 'Doğrulama iste (seçili)',
      bulkPhotoVideoOn: 'Fotoğraf/video iste (seçili)',
      bulkDecisionForSelected: 'Seçilenler için karar…',
      bulkStatusModalIntro: 'Toplu işlem',
      bulkStatusModalCount: '{{count}} ürün',
      bulkConfirmNeedsCheckCount:
        '{{count}} ürün için doğrulama istensin mi? Bu işlem geri alınamaz.',
      bulkPartialFailure:
        '{{total}} üründen {{failed}} tanesi güncellenemedi. Liste yenilendi.',
    },
    // Support Chat
    support: {
      chat: {
        connectionError: 'Bağlantı hatası. Sunucuya bağlantınızı kontrol edin.',
        connectionErrorNoToken: 'Yetkilendirme token\'ı bulunamadı. Lütfen tekrar giriş yapın.',
        reconnectError: 'Sohbete yeniden bağlanılamadı',
        connectionClosed: 'Sohbet bağlantısı kapatıldı',
      },
      supportChat: 'Destek Sohbeti',
      chatWith: 'İle Sohbet',
      online: 'Çevrimiçi',
      archived: 'Arşivlendi',
      chatNotFound: 'Sohbet bulunamadı',
      enterMessage: 'Mesaj girin...',
      send: 'Gönder',
      justNow: 'şimdi',
      goToChat: 'Sohbete Git',
      support: 'Destek',
      allChats: 'Tüm Sohbetler',
      myChats: 'Sohbetlerim',
      archive: 'Arşiv',
      active: 'Aktif',
      newChat: 'Yeni Sohbet',
      searchChats: 'Sohbet ara...',
      search: 'Ara...',
      nothingFound: 'Hiçbir şey bulunamadı',
      noChats: 'Sohbet yok',
      noChatsYet: 'Henüz sohbetiniz yok',
      open: 'Açık',
      closed: 'Kapalı',
      unarchive: 'Arşivden Çıkar',
      toArchive: 'Arşive',
      noSelectedChat: 'Seçili sohbet yok',
      selectChatToView: 'Görüntülemek için bir sohbet seçin',
      newSupportChat: 'Yeni Destek Sohbeti',
      subject: 'Konu',
      describeProblem: 'Sorununuzu açıklayın...',
      create: 'Oluştur',
      cancel: 'İptal',
      failedToLoadChats: 'Sohbetler yüklenemedi',
      failedToChangeArchive: 'Arşiv durumu değiştirilemedi',
      failedToCreateChat: 'Sohbet oluşturulamadı',
      failedToLoadChat: 'Sohbet yüklenemedi',
      failedToUploadFile: 'Dosya yüklenemedi',
      chatInArchive: 'Sohbet arşivde. Mesaj gönderme kullanılamıyor.',
      attachment: '[Ek]',
      minutesAgo: '{{minutes}} dakika önce',
      invalidFileType: 'Desteklenmeyen dosya türü. İzin verilen: resimler ({{imageExts}}) ve videolar ({{videoExts}})',
      fileSizeExceeded: 'Dosya boyutu 50MB\'ı geçmemelidir. Mevcut boyut: {{currentSize}}MB',
      reply: 'Yanıtla',
      replyToMessage: 'Mesaja yanıtla',
      primaryTab: 'Kişisel gelen kutuları',
      openOldThreads: 'Eski konular',
      backToMainChat: 'Ana sohbete dön',
      filterByStoreId: 'Mağaza ID (filtre)',
      markAsUnread: 'Okunmadı',
      markUnreadFailed: 'İşaretlenemedi',
      broadcastTitle: 'Kullanıcı sohbetlerine toplu mesaj',
      broadcastOpen: 'Toplu gönder',
      broadcastAudience: 'Hedef kitle',
      broadcastAudienceAll: 'Tüm müşteriler (aktif, yönetici değil)',
      broadcastAudienceStore: 'Mağaza kimliği şunu içeren kullanıcılar',
      broadcastAudienceUsers: 'Belirli kullanıcılar (kullanıcı ID)',
      broadcastStoreIdHint: 'WB store_id alt dizgisi (liste filtresi gibi)',
      broadcastUserIdsHint: 'Virgülle ayrılmış sayısal ID, örn. 12, 34, 56',
      broadcastUserIdsLabel: 'Kullanıcı ID',
      broadcastMessageLabel: 'Mesaj metni',
      broadcastTranslatedLabel: 'Yönetici çevirisi (isteğe bağlı)',
      broadcastSend: 'Tüm hedeflere gönder',
      broadcastSending: 'Gönderiliyor…',
      broadcastDone: 'Bitti: gönderilen {{sent}}, hata {{failed}}.',
      broadcastError: 'Toplu gönderim başarısız',
      broadcastSuperuserOnly: 'Toplu gönderim yalnızca süper kullanıcıya açıktır.',
      broadcastConfirm: 'Seçilen kitledeki her kullanıcıya bu mesaj gönderilsin mi?',
      broadcastNeedStoreId: 'Mağaza kimliği alt dizgisini girin.',
      broadcastNeedUserIds: 'En az bir sayısal kullanıcı kimliği girin.',
    },
  },

  ar: {
    // Navigation
    nav: {
      allStores: 'جميع المتاجر',
      addStore: 'إضافة متجر',
      billings: 'الفواتير',
      accounts: 'الحسابات',
      support: 'الدعم',
      profile: 'الملف الشخصي',
      signOut: 'تسجيل الخروج',
      selectStore: 'اختر المتجر',
      adminOrders: 'المسؤول: الطلبات',
      adminSupport: 'المسؤول: الدعم',
      adminBillings: 'الفواتير',
      goodsOnSale: 'سلع قيد البيع',
      createSuperuser: 'Create superadmin',
      adminWbReturns: 'مرتجعات المتجر (WB)',
      notifications: 'إشعارات',
    },
    notifications: {
      empty: 'لا توجد إشعارات',
      markRead: 'اطّلعت',
      languageLabel: 'لغة العرض',
      apiTokenTitle: 'فشل التحقق من مفتاح API',
      apiTokenBody:
        'فشلت الفحوصات المجدولة للمتجر «{{storeName}}». حدّث مفتاح API للسوق لاستعادة المزامنة.',
      addApiToken: 'إضافة مفتاح API',
      apiTokenDismiss: 'إخفاء حتى تسجيل الدخول التالي',
    },
    errors: {
      serviceUnavailable:
        'الخدمة غير متاحة مؤقتًا. قد يكون السبب صيانة تقنية أو إعادة تشغيل للخادم. انتظر بضع دقائق ثم حدّث الصفحة.',
      serviceUnavailableShort:
        'الموقع غير متاح مؤقتًا (صيانة أو إعادة تشغيل). حاول مرة أخرى بعد بضع دقائق.',
      unknown: 'حدث خطأ. حاول مرة أخرى.',
    },
    billing: {
      title: 'الحسابات',
      currentBalance: 'الرصيد الحالي',
      topUp: 'التعبئة',
      deducted: 'المخصوم',
      dateFrom: 'من تاريخ (تاريخ الفوترة)',
      dateTo: 'إلى تاريخ (تاريخ الفوترة)',
      type: 'النوع',
      orderNo: 'رقم الطلب',
      searchProductBarcode: 'المنتج، الباركود...',
      apply: 'تطبيق',
      downloadExcel: 'تحميل Excel',
      downloadPdf: 'تنزيل تقرير PDF',
      accountsPdfFilename: 'accounts_report',
      noExpenses: 'لا توجد خصومات للفترة المحددة.',
      shownOf: 'عرض {{from}}–{{to}} من {{total}}',
      perPage: 'لكل صفحة',
      back: 'السابق',
      next: 'التالي',
      pageOf: 'صفحة {{page}} من {{total}}',
      date: 'التاريخ',
      service: 'الخدمة',
      orderStatus: 'حالة الطلب',
      orderDate: 'تاريخ الطلب',
      product: 'المنتج',
      amount: 'المبلغ (¥)',
      allTypes: 'جميع الأنواع',
      type_storage_daily: 'التخزين اليومي',
      type_storage_warehouse: 'تخزين WH (المخزون/الشحن)',
      type_prepare_return_to_seller: 'التحضير للإرجاع للبائع',
      type_disposal: 'التخلص من المنتج',
      type_packaging_shipment: 'التغليف والشحن',
      type_inspection_no_media: 'فحص المنتج',
      type_inspection_with_media: 'فحص المنتج المعيب مع الصور',
      type_receipt_warehouse: 'استلام في المستودع',
      type_receipt_pickup: 'استلام في نقطة الانطلاق',
      type_balance_top_up: 'تعبئة الرصيد',
      whStockUnits: 'كمية مخزون WH',
      byStore: 'حسب المتجر',
      depositWarningBanner: 'انتباه! وفقاً لشروط التعاون الموضحة في العرض، عند الرصيد السالب سيتمكن Flydarin فقط من استلام وفحص وتخزين البضائع، ولن يتم طرحها للبيع. للتشغيل دون انقطاع، يرجى تعبئة الرصيد عبر AliPay باستخدام رمز QR في هذه الصفحة. الحد الأدنى للوديعة عند ربط متجر واحد = 1000 يوان، متجرين = 700 يوان لكل منهما، 3 متاجر أو أكثر = 500 يوان لكل منها. سيتم إضافة المبلغ إلى رصيدك خلال 24 ساعة.',
      sendReceiptHint: 'يرجى إرسال إيصال أو لقطة شاشة بعد دفع الوديعة.',
      sendReceiptButton: 'إرسال الإيصال',
      payWithAlipay: 'الدفع عبر AliPay',
      payWithAlipayHint:
        'اختر المتجر وأدخل أي مبلغ شحن باليوان. بعد تأكيد AliPay للدفع يُحدَّث الرصيد تلقائياً.',
      payWithAlipayCustomHint:
        'أدخل مبلغ الشحن للمتجر المحدد ثم افتح صفحة الدفع الرسمية في AliPay.',
      payWithAlipayStoreLabel: 'المتجر',
      payWithAlipayAmountLabel: 'مبلغ الشحن (CNY)',
      payWithAlipayFillDebt: 'تعبئة مبلغ الدين ({{amount}} ¥)',
      payWithAlipayAmountRequired: 'أدخل مبلغاً صالحاً (الحد الأدنى 0.01 ¥).',
      payWithAlipayStoreRequired: 'اختر متجراً.',
      payWithAlipayNoStores: 'لا توجد متاجر مرتبطة بحسابك.',
      payWithAlipayPagePrimaryHint:
        'موصى به: الدفع في هذا المتصفح — سيتم إعادة التوجيه إلى صفحة الدفع الرسمية في AliPay.',
      payWithAlipayPageNewTab: 'فتح في علامة تبويب جديدة',
      payWithAlipayNegativeOnly: 'الدفع برمز QR الديناميكي متاح فقط عندما يكون رصيد المتجر سالباً.',
      payWithAlipayButton: 'احصل على QR للدفع',
      payWithAlipayAmount: 'المبلغ',
      payWithAlipayOrderNo: 'رقم الطلب',
      payWithAlipayReused: 'استخدام QR غير المدفوع السابق (ما زال صالحاً)',
      payWithAlipayScanHint: 'افتح AliPay وامسح هذا الرمز.',
      payWithAlipayCreditHint: 'بعد تأكيد AliPay للدفع يُضاف الرصيد تلقائياً؛ لا حاجة لإيصال في هذا المسار.',
      payWithAlipayCopyPayload: 'نسخ محتوى الرمز',
      payWithAlipayCopied: 'تم النسخ',
      payWithAlipayPageButton: 'فتح صفحة AliPay',
      payWithAlipayPagePopupBlocked: 'حظر المتصفح النافذة المنبثقة. اسمح بالنوافذ المنبثقة ثم أعد المحاولة.',
      payWithAlipayPageNoUrl: 'تعذر الحصول على رابط دفع AliPay.',
    },
    // Dashboard cards
    dashboard: {
      inTransit: 'في الطريق إلى',
      warehouse: 'مستودع إنديجو',
      storedIn: 'مخزنة في',
      completedReturns: 'الإرجاعات المكتملة',
      returnRequests: 'طلبات الإرجاع',
      ordersInProcessing: 'الطلبات قيد المعالجة',
      ordersPendingDecision: 'الطلبات في انتظار القرار',
      completedOrders: 'الطلبات المكتملة',
      items: 'عناصر',
      or: 'أو',
      viewItemsInTransit: 'عرض العناصر في الطريق',
      viewReturnsOtherPvz: 'عرض الإرجاعات إلى نقاط تسليم أخرى',
      viewReturnData: 'عرض بيانات الإرجاع',
      viewFinancialReport: 'عرض التقرير المالي',
      processReturns: 'معالجة الإرجاعات',
      viewProcessingOrders: 'عرض الطلبات قيد المعالجة',
      viewCompletedOrders: 'عرض الطلبات المكتملة',
    },
    // Add Store Modal
    addStore: {
      title: 'إضافة متجر',
      selectMarketplace: 'اختر السوق',
      wildberries: 'Wildberries',
      ozon: 'Ozon',
      yandexMarket: 'Yandex Market',
      comingSoon: 'قريباً',
      storeName: 'اسم المتجر',
      storeNamePlaceholder: 'متجري',
      storeNameHint: 'أعط متجرك اسماً لتحديده بسهولة',
      enterApiKey: 'أدخل مفتاح JWT API',
      apiKeyPlaceholder: 'الصق مفتاح JWT API الخاص بك هنا...',
      cancel: 'إلغاء',
      add: 'إضافة متجر',
      adding: 'جاري الإضافة...',
      success: 'تم إضافة المتجر بنجاح!',
      error: 'فشل في إضافة المتجر',
      invalidToken: 'رمز غير صالح أو منتهي الصلاحية',
      storeExists: 'هذا المتجر متصل بالفعل',
    },
    // Profile
    profile: {
      title: 'معلومات الملف الشخصي',
      email: 'البريد الإلكتروني',
      emailCannotChange: 'لا يمكن تغيير البريد الإلكتروني',
      wechatId: 'WeChat ID',
      telegramUsername: 'Telegram',
      messengerHint: 'جهات اتصال المراسلة',
      firstName: 'الاسم الأول',
      lastName: 'اسم العائلة',
      accountStatus: 'حالة الحساب',
      emailVerified: 'تم التحقق من البريد الإلكتروني',
      memberSince: 'عضو منذ',
      edit: 'تعديل',
      save: 'حفظ التغييرات',
      saving: 'جاري الحفظ...',
      cancel: 'إلغاء',
      updateSuccess: 'تم تحديث الملف الشخصي بنجاح!',
      updateError: 'فشل في تحديث الملف الشخصي. يرجى المحاولة مرة أخرى.',
      // Delivery address
      deliveryAddressTitle: 'عنوان التسليم',
      deliveryAddressDescription: 'عنوان التسليم الخاص بك مطلوب لاستلام إرجاعات المنتجات.',
      deliveryAddressWarning: 'يرجى ملء عنوان التسليم لتتمكن من طلب إرجاع المنتجات.',
      addressUpdateSuccess: 'تم تحديث العنوان بنجاح!',
      addressStreet: 'عنوان الشارع',
      addressStreetPlaceholder: '123 الشارع الرئيسي، شقة 4',
      addressCity: 'المدينة',
      addressCityPlaceholder: 'دبي',
      addressPostalCode: 'الرمز البريدي',
      addressPostalCodePlaceholder: '12345',
      addressCountry: 'الدولة',
      addressCountryPlaceholder: 'الإمارات العربية المتحدة',
      addressPhone: 'رقم الهاتف',
      addressPhonePlaceholder: '+971 50 123 4567',
      // Legal documents
      documentsTitle: 'وثائق الكيان القانوني',
      documentsDescription: 'قم بتحميل مستندات PDF المتعلقة بكيانك القانوني. الحد الأقصى لحجم الملف: 10MB.',
      documentsUpload: 'تحميل PDF',
      documentsUploading: 'جاري التحميل...',
      documentsEmpty: 'لم يتم تحميل أي مستندات بعد',
      documentsOnlyPdf: 'يُسمح فقط بملفات PDF',
      documentsMaxSize: 'لا يمكن أن يتجاوز حجم الملف 10MB',
      documentsUploadSuccess: 'تم تحميل المستند بنجاح!',
      documentsUploadError: 'فشل في تحميل المستند',
      documentsDeleteSuccess: 'تم حذف المستند بنجاح!',
      documentsDeleteError: 'فشل في حذف المستند',
      documentsConfirmDelete: 'هل أنت متأكد من أنك تريد حذف هذا المستند؟',
      autoReturnCheckTitle: 'التحقق التلقائي من المرتجعات',
      autoReturnCheckHint:
        'لكل متجر: عند التفعيل، تُنشأ بنود المرتجعات الجديدة مع طلب التحقق في المستودع؛ وعند الإيقاف بدون تحقق.',
      autoReturnCheckLoadError: 'تعذر تحميل المتاجر.',
      autoReturnCheckUpdateError: 'تعذر حفظ الإعداد. يرجى المحاولة مرة أخرى.',
      autoReturnCheckNoStores: 'لا توجد متاجر مرتبطة. أضف متجرًا من لوحة التحكم أولاً.',
    },
    // Security
    security: {
      title: 'الأمان',
      changePassword: 'تغيير كلمة المرور',
      currentPassword: 'كلمة المرور الحالية',
      newPassword: 'كلمة المرور الجديدة',
      confirmPassword: 'تأكيد كلمة المرور الجديدة',
      update: 'تحديث كلمة المرور',
      updating: 'جاري التحديث...',
      success: 'تم تغيير كلمة المرور بنجاح!',
    },
    // Stores
    stores: {
      title: 'متاجري',
      noStores: 'لم يتم الاتصال بأي متاجر بعد',
      addFirst: 'أضف متجرك الأول للبدء',
      connected: 'متصل',
      storeId: 'معرف المتجر',
      edit: 'تعديل المتجر',
      editTitle: 'تعديل اسم المتجر',
      storeName: 'اسم المتجر',
      storeNamePlaceholder: 'أدخل اسم المتجر',
      storeNameHint: 'أعط متجرك اسماً لتحديده بسهولة',
      editError: 'فشل في تحديث المتجر',
      // Verification status
      verifying: 'جاري التحقق...',
      verified: 'تم التحقق',
      verificationFailed: 'فشل التحقق',
      verificationFailedMessage: 'فشل التحقق من الرمز. يرجى حذف هذا المتجر وإضافته مرة أخرى بمفتاح API صالح.',
      verificationPending: 'التحقق قيد التنفيذ...',
      deleteStore: 'حذف المتجر',
      deleteStoreConfirm: 'هل أنت متأكد من أنك تريد حذف هذا المتجر؟',
    },
    // Auth
    auth: {
      login: 'تسجيل الدخول',
      register: 'التسجيل',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      rememberMe: 'تذكرني',
      forgotPassword: 'نسيت كلمة المرور؟',
      noAccount: 'ليس لديك حساب؟',
      haveAccount: 'لديك حساب بالفعل؟',
      signUpNow: 'سجل الآن',
      signInNow: 'سجل الدخول',
      firstName: 'الاسم الأول',
      lastName: 'اسم العائلة',
      welcomeBack: 'مرحباً بعودتك',
      signInToAccount: 'سجل الدخول إلى حسابك',
      enterEmail: 'أدخل بريدك الإلكتروني',
      enterPassword: 'أدخل كلمة المرور',
      signingIn: 'جاري تسجيل الدخول...',
      loginFailed: 'فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.',
      createAccount: 'إنشاء حساب',
      joinUs: 'انضم إلينا وابدأ',
      signingUp: 'جاري إنشاء الحساب...',
      registrationFailed: 'فشل التسجيل. يرجى المحاولة مرة أخرى.',
      pricingAndExample: 'أسعارنا والأمثلة',
      resetPassword: 'إعادة تعيين كلمة المرور',
      enterEmailReset: 'أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور',
      sendResetLink: 'إرسال رابط إعادة التعيين',
      sending: 'جاري الإرسال...',
      backToLogin: 'العودة إلى تسجيل الدخول',
      checkEmail: 'تحقق من بريدك الإلكتروني',
      resetLinkSent: 'لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى',
      newPasswordTitle: 'تعيين كلمة مرور جديدة',
      enterNewPassword: 'أدخل كلمة المرور الجديدة',
      confirmNewPassword: 'أكد كلمة المرور الجديدة',
      resetPasswordBtn: 'إعادة تعيين كلمة المرور',
      resetting: 'جاري إعادة التعيين...',
      passwordResetSuccess: 'تم إعادة تعيين كلمة المرور بنجاح',
      passwordResetSuccessMsg: 'تم إعادة تعيين كلمة المرور بنجاح.',
      registrationSuccess: 'نجح التسجيل',
      verifyEmailMsg: 'يرجى التحقق من بريدك الإلكتروني للتحقق من حسابك.',
      verifyingEmail: 'جاري التحقق من البريد الإلكتروني...',
      emailVerified: 'تم التحقق من البريد الإلكتروني',
      emailVerifiedMsg: 'تم التحقق من بريدك الإلكتروني بنجاح.',
      resendVerification: 'إعادة إرسال بريد التحقق',
      contactUs: 'اتصل بنا',
      telegramChat: 'دردشة تليجرام',
      faq: 'الأسئلة الشائعة',
      aboutProject: 'عن المشروع',
    },
    // Register
    register: {
      title: 'إنشاء حساب',
      subtitle: 'سجل للبدء',
      firstName: 'الاسم الأول',
      firstNamePlaceholder: 'محمد',
      lastName: 'اسم العائلة',
      lastNamePlaceholder: 'أحمد',
      email: 'البريد الإلكتروني',
      emailPlaceholder: 'your@email.com',
      password: 'كلمة المرور',
      passwordPlaceholder: '8 أحرف على الأقل',
      confirmPassword: 'تأكيد كلمة المرور',
      confirmPasswordPlaceholder: 'أكد كلمة المرور',
      submit: 'إنشاء حساب',
      creating: 'جاري إنشاء الحساب...',
      haveAccount: 'لديك حساب بالفعل؟',
      signIn: 'تسجيل الدخول',
      passwordsDoNotMatch: 'كلمات المرور غير متطابقة',
      failed: 'فشل التسجيل. يرجى المحاولة مرة أخرى.',
      agreeToOffer: 'لقد قرأت ووافقت على',
      offerLink: 'العرض',
      agreeToDataProcessing: 'أوافق على معالجة البيانات الشخصية',
      mustAgreeToOffer: 'يجب أن توافق على العرض للتسجيل',
      mustAgreeToDataProcessing: 'يجب أن توافق على معالجة البيانات الشخصية للتسجيل',
      wechatId: 'WeChat ID',
      telegramUsername: 'Telegram',
      messengerHint: 'أدخل WeChat ID أو اسم مستخدم Telegram (واحد على الأقل)',
    },
    // Forgot Password
    forgotPassword: {
      title: 'نسيت كلمة المرور؟',
      subtitle: 'لا تقلق، سنرسل لك تعليمات إعادة التعيين',
      emailLabel: 'البريد الإلكتروني',
      emailPlaceholder: 'أدخل بريدك الإلكتروني',
      sendResetLink: 'إرسال رابط إعادة التعيين',
      sending: 'جاري الإرسال...',
      backToLogin: 'العودة إلى تسجيل الدخول',
      failed: 'فشل في إرسال بريد إعادة التعيين. يرجى المحاولة مرة أخرى.',
    },
    // Reset Sent
    resetSent: {
      title: 'تحقق من بريدك الإلكتروني',
      message: 'لقد أرسلنا تعليمات إعادة تعيين كلمة المرور إلى',
      info: 'إذا كان هناك حساب بهذا البريد الإلكتروني، ستتلقى تعليمات لإعادة تعيين كلمة المرور. تحقق من مجلد البريد العشوائي إذا لم ترها في غضون بضع دقائق.',
      backToLogin: 'العودة إلى تسجيل الدخول',
    },
    // Reset Password
    resetPassword: {
      title: 'إعادة تعيين كلمة المرور',
      subtitle: 'أدخل كلمة المرور الجديدة أدناه',
      newPasswordLabel: 'كلمة المرور الجديدة',
      newPasswordPlaceholder: '8 أحرف على الأقل',
      confirmPasswordLabel: 'تأكيد كلمة المرور',
      confirmPasswordPlaceholder: 'أكد كلمة المرور الجديدة',
      resetButton: 'إعادة تعيين كلمة المرور',
      resetting: 'جاري إعادة التعيين...',
      backToLogin: 'العودة إلى تسجيل الدخول',
      passwordsDoNotMatch: 'كلمات المرور غير متطابقة',
      failed: 'فشل في إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.',
    },
    // Reset Success
    resetSuccess: {
      title: 'اكتمل إعادة تعيين كلمة المرور',
      message: 'تم إعادة تعيين كلمة المرور بنجاح.',
      info: 'يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.',
      continueToSignIn: 'متابعة تسجيل الدخول',
    },
    // Verify Email
    verifyEmail: {
      verifyingTitle: 'جاري التحقق من بريدك الإلكتروني',
      verifyingMessage: 'يرجى الانتظار بينما نتحقق من عنوان بريدك الإلكتروني...',
      successTitle: 'تم التحقق من البريد الإلكتروني!',
      successMessage: 'تم التحقق من بريدك الإلكتروني بنجاح.',
      successInfo: 'حسابك نشط الآن. سيتم توجيهك إلى صفحة تسجيل الدخول قريباً...',
      continueToSignIn: 'متابعة تسجيل الدخول',
      failedTitle: 'فشل التحقق',
      failedMessage: 'لم نتمكن من التحقق من عنوان بريدك الإلكتروني',
      failedInfo: 'قد يكون رابط التحقق منتهي الصلاحية أو تم استخدامه بالفعل. يرجى محاولة تسجيل الدخول أو طلب بريد تحقق جديد.',
      goToLogin: 'الذهاب إلى تسجيل الدخول',
      invalidLink: 'رابط تحقق غير صالح.',
      failedError: 'فشل في التحقق من البريد الإلكتروني. قد يكون الرابط غير صالح أو منتهي الصلاحية.',
    },
    // Registration Success
    registrationSuccess: {
      title: 'تحقق من بريدك الإلكتروني',
      message: 'لقد أرسلنا رابط التحقق إلى',
      important: 'مهم:',
      info: 'يجب عليك التحقق من عنوان بريدك الإلكتروني قبل تسجيل الدخول. انقر على الرابط في البريد الإلكتروني الذي أرسلناه لتفعيل حسابك.',
      didntReceiveEmail: 'لم تستلم البريد الإلكتروني؟',
      resendButton: 'إعادة إرسال بريد التحقق',
      sending: 'جاري الإرسال...',
      emailResent: 'تم إعادة إرسال بريد التحقق. يرجى التحقق من صندوق الوارد.',
      resendFailed: 'فشل في إعادة إرسال البريد الإلكتروني. يرجى المحاولة مرة أخرى.',
      alreadyVerified: 'تم التحقق بالفعل؟',
      signIn: 'تسجيل الدخول',
    },
    // Offer
    offer: {
      title: 'اتفاقية العرض',
      languageUAE: 'الإمارات',
      languageChina: 'الصين',
      selectLanguage: 'اختر اللغة لتنزيل مستند العرض',
      uaeDescription: 'تنزيل مستند العرض للإمارات',
      chinaDescription: 'تنزيل مستند العرض للصين',
      download: 'تنزيل DOCX',
      downloading: 'جاري التنزيل...',
      downloadError: 'فشل في تنزيل مستند العرض',
    },
    // Pricing
    pricing: {
      title: 'أسعار الخدمة',
      subtitle: 'أسعار الخدمة ومعلومات التسعير',
      loadError: 'فشل في تحميل جدول الأسعار',
      downloadButton: 'حمّل قائمة الأسعار الخاصة بنا',
      downloading: 'جاري التحميل...',
      downloadError: 'فشل تحميل قائمة الأسعار',
    },
    // Indigo Price List (static table on /pricing)
    priceList: {
      title: 'قائمة أسعار خدمات INDIGO',
      subhead: 'تعريفات الخدمات — الأسعار لكل وحدة ما لم يُذكر خلاف ذلك.',
      colNo: 'م',
      colService: 'الخدمة',
      colCost: 'التكلفة (¥)',
      colNote: 'ملاحظة / وحدة القياس',
      r1_name: 'استلام البضائع أو المرتجعات في المستودع (بالقطعة)',
      r1_note: 'لكل وحدة',
      r2_name: 'الاستلام في نقطة التسليم (بالقطعة)',
      r2_note: 'لكل وحدة',
      r3_name: 'فحص المنتج',
      r3_note: 'لكل وحدة',
      r4_name: 'فحص المنتج المعيب مع الصور',
      r4_note: 'لكل وحدة',
      r5_main: 'معالجة الطلب (التعبئة والشحن إلى السوق)',
      r5_50_name: 'حتى 50 سم (مجموع الأضلاع)',
      r5_50_note: 'ط+ع+ا ≤ 50 سم',
      r5_80_name: 'حتى 80 سم',
      r5_80_note: 'المجموع ≤ 80 سم',
      r5_100_name: 'حتى 100 سم',
      r5_100_note: 'المجموع ≤ 100 سم',
      r5_120_name: 'حتى 120 سم',
      r5_120_note: 'المجموع ≤ 120 سم',
      r5_180_name: 'حتى 180 سم',
      r5_180_note: 'المجموع ≤ 180 سم',
      r5_220_name: 'حتى 220 سم',
      r5_220_note: 'المجموع ≤ 220 سم',
      r5_oversized_name: 'طلبات كبيرة الحجم',
      r5_oversized_note: 'أكثر من 220 سم أو غير قياسي',
      r6_name: 'التخزين في المستودع (حتى الشحن)',
      r6_note: 'لكل م³ في اليوم',
      r7_name: 'تحضير البضاعة للإرجاع إلى البائع',
      r7_note: 'لكل وحدة',
      r8_name: 'الإرجاع إلى البائع',
      r8_note: 'حسب تعريفة شركة الشحن (تحسب بشكل منفصل)',
      r8_price: 'بشكل فردي',
      infoTitle: 'ملاحظات مهمة',
      info1: 'الخدمة 5 (معالجة الطلب) تشمل التعبئة وشحن طلب العميل من المستودع إلى السوق. التكلفة تعتمد على مجموع الأبعاد الثلاثة (الطول + العرض + الارتفاع) بالسنتيمتر.',
      info2: 'التخزين (الخدمة 6) يُفوتر لكل يوم كامل أو جزء منه بمقدار 13.5 لكل متر مكعب في اليوم. يُقرّب الحجم إلى 0.001 م³.',
      info3: 'الإرجاع إلى البائع (الخدمة 8) — تُحسب التكلفة بشكل فردي لشركة الشحن والمسار المحدد.',
      info4: 'جميع الأسعار دون عمولات الأسواق والضرائب.',
    },
    // Landing
    landing: {
      home: 'الرئيسية',
      heroTitle: 'إدارة المستودعات والمرتجعات للأسواق',
      heroSubtitle: 'اربط متجرك، وأدر المرتجعات والتخزين في مكان واحد.',
      login: 'تسجيل الدخول',
      register: 'التسجيل',
      connectService: 'ربط الخدمة',
      featuresTitle: 'لماذا نحن',
      feature1Title: 'المرتجعات والتخزين',
      feature1Text: 'إدارة المرتجعات وعمليات المستودع في نظام واحد.',
      feature2Title: 'السرعة والشفافية',
      feature2Text: 'حالات فورية وفوترة واضحة.',
      feature3Title: 'الأمان',
      feature3Text: 'بياناتك محمية ومتوافقة.',
      ctaTitle: 'ابدأ',
      ctaText: 'سجّل الدخول أو أنشئ حساباً لربط متجرك.',
    },
    // Footer
    footer: {
      copyright: '© {{year}} مستودع إنديجو. جميع الحقوق محفوظة.',
      pricing: 'التسعير والأمثلة',
      offer: 'العرض',
      faq: 'الأسئلة الشائعة',
      aboutProject: 'عن المشروع',
    },
    // Common
    common: {
      loading: 'جاري التحميل...',
      error: 'خطأ',
      success: 'نجح',
      hello: 'مرحباً',
      cancel: 'إلغاء',
      close: 'إغلاق',
      save: 'حفظ',
      saving: 'جاري الحفظ...',
      update: 'تحديث',
      updating: 'جاري التحديث...',
      back: 'رجوع',
      home: 'الرئيسية',
      currency: {
        yen: '¥',
        ruble: '₽',
      },
      yes: 'نعم',
      no: 'لا',
    },
    // Admin Orders
    adminOrders: {
      title: 'إدارة الطلبات (المسؤول)',
      orderNumber: 'رقم الطلب',
      sticker: 'الملصق',
      status: 'الحالة',
      store: 'المتجر',
      trackingNumbers: 'أرقام التتبع',
      product: 'المنتج',
      dstOfficeAddress: 'عنوان نقطة استلام المرتجعات',
      returnStatus: 'حالة المرتجع',
      allReturnStatuses: 'كل حالات المرتجع',
      returnStatusActive: 'نشط',
      returnStatusArchived: 'مؤرشف',
      readyToReturnDt: 'تاريخ جاهزية المرتجع',
      createdDate: 'تاريخ الإنشاء',
      actions: 'الإجراءات',
      details: 'التفاصيل',
      hide: 'إخفاء',
      edit: 'تعديل',
      searchPlaceholder:
        'رقم الطلب، التتبع، SKU، الباركود، WB stickerId، WB shkId (جزء من الرقم؛ تطابق كامل إذا كانت الأرقام فقط)، عنوان الاستلام…',
      allStatuses: 'جميع الحالات',
      storeIdPlaceholder: 'معرف المتجر',
      customer: 'العميل',
      tracking: 'التتبع',
      seller: 'البائع',
      orderInfo: 'معلومات الطلب',
      id: 'المعرف',
      whEnterId: 'معرف دخول المستودع',
      whSyncError: 'خطأ مزامنة المستودع',
      productInfo: 'معلومات المنتج',
      defective: 'معيب',
      needsCheck: 'يتطلب فحص',
      defectAfterCheck: 'عيب بعد الفحص',
      needsPhotoVideo: 'يتطلب صورة/فيديو',
      comments: 'التعليقات',
      attachments: 'المرفقات',
      addAttachment: 'إضافة مرفق',
      showing: 'عرض {{from}} - {{to}} من {{total}}',
      editOrder: 'تعديل الطلب',
      statusLabel: 'الحالة',
      storeId: 'معرف المتجر',
      customerTrackingNumber: 'رقم تتبع العميل',
      trackingNumber: 'رقم التتبع',
      sellerTrackingNumber: 'رقم تتبع البائع',
      itemFields: 'حقول العنصر',
      inspectionComments: 'تعليقات الفحص',
      cancel: 'إلغاء',
      save: 'حفظ',
      addAttachmentTitle: 'إضافة مرفق',
      attachmentType: 'نوع المرفق',
      photo: 'صورة',
      video: 'فيديو',
      file: 'ملف',
      upload: 'تحميل',
      attachmentFilesSelected: 'تم التحديد: {{count}} ملف(ات)',
      accessDenied: 'تم رفض الوصول. مطلوب صلاحيات المسؤول الفائق.',
      deleteAttachment: 'حذف المرفق؟',
      statusTransitionSection: 'انتقال الحالة (السجل)',
      statusTransitionHint:
        'يعرض الطلبات التي دخلت أي حالة محددة خلال الفترة (حسب وقت تغيير الحالة). يُدمج مع بقية المرشحات باستخدام AND.',
      statusTransitionDateFrom: 'الانتقال من',
      statusTransitionDateTo: 'الانتقال إلى',
      statusTransitionTargetStatuses: 'الحالات المدخلة',
      statusTransitionClear: 'مسح مرشح الانتقال',
      statusTransitionIncomplete: 'اختر نطاق التاريخ وحالة واحدة على الأقل.',
      statusTransitionActiveNote: 'مرشح الانتقال مفعّل. إجمالي الطلبات المطابقة: {{total}}.',
      dimensionsWeight: 'الأبعاد والوزن',
      disposalModalTitle: 'رسوم التخلص',
      disposalModalHint:
        'خصم واحد لكل بند. عند معرفة الوزن الإجمالي (كغ) يُقترح: الوزن × 3.5 ¥. يمكن تعديل كل بند.',
      disposalApplyAuto: 'تعبئة من الوزن (كغ × 3.5 ¥)',
      disposalAmountYuan: 'المبلغ (¥)',
      disposalWeightLine: 'الوزن الإجمالي: {{kg}} كغ — المقترح {{suggested}} ¥',
      disposalWeightUnknown: 'وزن المنتج غير معروف — أدخل المبلغ يدوياً.',
      disposalConfirm: 'إنشاء الخصومات وتعيين «تم التخلص»',
    },
    // Returns Table
    returns: {
      allReturns: 'جميع الإرجاعات',
      inTransit: 'العناصر في الطريق',
      inWarehouse: 'مخزنة في المستودع',
      ordersInProcessing: 'الطلبات قيد المعالجة',
      ordersPendingDecision: 'الطلبات في انتظار القرار',
      completedOrders: 'الطلبات المكتملة',
      returnsOtherPvz: 'إرجاعات إلى نقاط تسليم أخرى',
      filterByOtherPvz: 'طلبات إلى نقاط تسليم أخرى',
      otherPvzTrue: 'نقاط تسليم أخرى فقط',
      otherPvzFalse: 'نقاط Indigo فقط',
      pvzScopeFilter: 'عنوان الاستلام WB',
      pvzScopeAll: 'كل العناوين',
      pvzScopeShosseynaya: 'موسكو، شوسينايا 4к3',
      pvzScopeProezd3723: 'ممر 3723، موسكو 109548',
      pvzScopeOther: 'نقاط استلام أخرى',
      pvzScopeOur: 'نقاطنا (الاثنتان)',
      wbDtFrom: 'WB من تاريخ',
      wbDtTo: 'WB إلى تاريخ',
      wbDtFieldsHint: 'حقول WB (عدة = أو)',
      wbDtFieldCompleted: 'completedDt',
      wbDtFieldReady: 'readyToReturnDt',
      wbDtFieldExpired: 'expiredDt',
      wbDtFieldOrder: 'orderDt',
      otherPvzContactBanner: 'إذا كنت بحاجة إلى استلام هذه البضائع، تواصل معنا عبر الدردشة.',
      whBillingCharges: 'رسوم WH',
      finances: 'المالية',
      filters: 'عوامل التصفية',
      // Status values for filter dropdown
      statusAwaitingReceipt: 'في انتظار الاستلام في WB',
      statusReceivedAwaitingCheck: 'تم الاستلام، في انتظار الفحص',
      statusAwaitingSellerDecision: 'في انتظار قرار البائع',
      statusAwaitingForSale: 'في انتظار النقل للبيع',
      statusTransferringToSale: 'يتم النقل للبيع',
      statusSubmittedForSale: 'تم تقديمه للبيع',
      statusAwaitingShipment: 'في انتظار الشحن للبائع',
      statusAwaitingDisposal: 'في انتظار التخلص',
      statusDisposed: 'تم التخلص',
      statusSentToSeller: 'تم الإرسال للبائع',
      // Table columns - In Transit
      returnRequestDate: 'تاريخ طلب الإرجاع',
      product: 'المنتج',
      dimensionsWeight: 'الأبعاد والوزن',
      unitCm: 'سم',
      unitKg: 'كغ',
      dimensionsUnknownShort: '—',
      weightUnknownShort: 'الوزن غير معروف',
      dimensionsWeightUnavailable: 'لا تتوفر الأبعاد والوزن',
      sku: 'SKU',
      barcode: 'الرمز الشريطي',
      returnNumber: 'رقم الإرجاع',
      sticker: 'الملصق',
      defectiveItem: 'عنصر معيب؟',
      needsCheck: 'يتطلب التحقق',
      needsPhotoVideo: 'يتطلب صورة/فيديو؟',
      decisionOnProduct: 'قرار بشأن المنتج',
      status: 'الحالة',
      trackingNumber: 'رقم التتبع',
      sellerTrackingNumber: 'رقم تتبع البائع',
      // Table columns - In Warehouse
      isDefectAfterCheck: 'عيب بعد الفحص',
      photoVideo: 'صورة/فيديو',
      receiptDate: 'تاريخ استلام المستودع إنديجو',
      attachedFiles: 'الملفات المرفقة',
      photo: 'صورة',
      video: 'فيديو',
      inspectionComments: 'تعليقات الفحص/الاقتراحات',
      acceptSuggestion: 'قبول الاقتراح',
      productImageComingSoon: 'قريبًا',
      wbImageNotFound: 'غير موجود',
      // Yes/No buttons
      yes: 'نعم',
      no: 'لا',
      // Status decisions
      transferToSale: 'نقل للبيع',
      sellOnWB: 'بيع على WB',
      dispose: 'تخلص',
      disposeIn7Days: 'تخلص خلال 7 أيام',
      sendToSeller: 'إرجاع للبائع',
      // Filters
      searchPlaceholder: 'البحث حسب المنتج، SKU، الرمز الشريطي، رقم الإرجاع...',
      dateFrom: 'التاريخ من',
      dateTo: 'التاريخ إلى',
      allStatuses: 'جميع الحالات',
      filterByDefect: 'تصفية حسب العيب',
      applyFilters: 'تطبيق المرشحات',
      clearFilters: 'مسح المرشحات',
      // Confirmations and warnings
      confirmNeedsCheckTitle: 'تأكيد طلب التحقق',
      confirmNeedsCheckMessage: 'هل أنت متأكد من أنك تريد طلب التحقق؟ هذا الإجراء لا رجوع فيه ولا يمكن التراجع عنه.',
      alsoRequirePhotoVideo: 'يتطلب أيضاً صورة/فيديو',
      confirmAction: 'نعم، طلب التحقق',
      deliveryAddressRequired: 'يرجى ملء عنوان التسليم في ملفك الشخصي قبل طلب إرجاع المنتج.',
      // Status change modal
      chooseAction: 'اختر الإجراء',
      statusChangeTitle: 'قرار بشأن المنتج',
      statusChangeMessage: 'اختر ما يجب فعله بهذا المنتج:',
      confirmStatusChange: 'تأكيد',
      photoVideoRequiresCheck: 'يمكن طلب الصورة/الفيديو فقط عند تفعيل التحقق.',
      errorPhotoVideoWithoutCheck: 'لا يمكن تفعيل متطلب الصورة/الفيديو بدون التحقق. يرجى تفعيل التحقق أولاً.',
      errorCannotDisableCheck: 'لا يمكن تعطيل التحقق. هذا الإعداد لا رجوع فيه.',
      errorUpdateFailed: 'فشل التحديث. يرجى المحاولة مرة أخرى.',
      // Table states
      noItemsFound: 'لم يتم العثور على عناصر',
      loadingItems: 'جاري تحميل العناصر...',
      errorLoadingItems: 'خطأ في تحميل العناصر',
      // Pagination
      showingItems: 'عرض {{from}}-{{to}} من {{total}} عنصر',
      itemsPerPage: 'عناصر لكل صفحة',
      // Links
      downloadAttachment: 'تنزيل المرفق',
      attachmentCommentPlaceholder: 'تعليق على صورة التحقق',
      saveAttachmentComment: 'حفظ التعليق',
      bulkSelectColumn: 'تحديد الصف',
      bulkSelectPage: 'تحديد الكل في الصفحة',
      bulkClearSelection: 'إلغاء التحديد',
      bulkSelectedCount: 'المحدد: {{count}}',
      bulkNeedsCheckOn: 'التحقق: نعم (المحدد)',
      bulkNeedsCheckOff: 'التحقق: لا (المحدد)',
      bulkNeedsCheckPending: 'طلب التحقق (المحدد)',
      bulkPhotoVideoOn: 'طلب صورة/فيديو (المحدد)',
      bulkDecisionForSelected: 'قرار للمحدد…',
      bulkStatusModalIntro: 'إجراء جماعي',
      bulkStatusModalCount: '{{count}} عنصر',
      bulkConfirmNeedsCheckCount:
        'طلب التحقق لـ {{count}} عنصر؟ لا يمكن التراجع عن هذا الإجراء.',
      bulkPartialFailure:
        'تعذّر تحديث {{failed}} من أصل {{total}} عنصر. تم تحديث القائمة.',
    },
    // Support Chat
    support: {
      chat: {
        connectionError: 'خطأ في الاتصال. يرجى التحقق من اتصالك بالخادم.',
        connectionErrorNoToken: 'لم يتم العثور على رمز التفويض. يرجى تسجيل الدخول مرة أخرى.',
        reconnectError: 'فشل إعادة الاتصال بالدردشة',
        connectionClosed: 'تم إغلاق اتصال الدردشة',
      },
      supportChat: 'دردشة الدعم',
      chatWith: 'الدردشة مع',
      online: 'متصل',
      archived: 'مؤرشف',
      chatNotFound: 'لم يتم العثور على الدردشة',
      enterMessage: 'أدخل الرسالة...',
      send: 'إرسال',
      justNow: 'الآن',
      goToChat: 'الذهاب إلى الدردشة',
      support: 'الدعم',
      allChats: 'جميع الدردشات',
      myChats: 'دردشاتي',
      archive: 'الأرشيف',
      active: 'نشط',
      newChat: 'دردشة جديدة',
      searchChats: 'البحث في الدردشات...',
      search: 'بحث...',
      nothingFound: 'لم يتم العثور على شيء',
      noChats: 'لا توجد دردشات',
      noChatsYet: 'ليس لديك أي دردشات بعد',
      open: 'مفتوح',
      closed: 'مغلق',
      unarchive: 'إلغاء الأرشفة',
      toArchive: 'إلى الأرشيف',
      noSelectedChat: 'لا توجد دردشة محددة',
      selectChatToView: 'اختر دردشة للعرض',
      newSupportChat: 'دردشة دعم جديدة',
      subject: 'الموضوع',
      describeProblem: 'اوصف مشكلتك...',
      create: 'إنشاء',
      cancel: 'إلغاء',
      failedToLoadChats: 'فشل في تحميل الدردشات',
      failedToChangeArchive: 'فشل في تغيير حالة الأرشفة',
      failedToCreateChat: 'فشل في إنشاء الدردشة',
      failedToLoadChat: 'فشل في تحميل الدردشة',
      failedToUploadFile: 'فشل في تحميل الملف',
      chatInArchive: 'الدردشة في الأرشيف. إرسال الرسائل غير متاح.',
      attachment: '[مرفق]',
      minutesAgo: 'منذ {{minutes}} دقيقة',
      invalidFileType: 'نوع ملف غير مدعوم. المسموح: الصور ({{imageExts}}) والفيديو ({{videoExts}})',
      fileSizeExceeded: 'يجب ألا يتجاوز حجم الملف 50MB. الحجم الحالي: {{currentSize}}MB',
      reply: 'رد',
      replyToMessage: 'الرد على الرسالة',
      primaryTab: 'صندوق المحادثات الشخصية',
      openOldThreads: 'مواضيع قديمة',
      backToMainChat: 'العودة للمحادثة الرئيسية',
      filterByStoreId: 'معرف المتجر (تصفية)',
      markAsUnread: 'غير مقروء',
      markUnreadFailed: 'تعذر التعليم كغير مقروء',
      broadcastTitle: 'بث إلى دردشات المستخدمين',
      broadcastOpen: 'بث',
      broadcastAudience: 'الجمهور',
      broadcastAudienceAll: 'جميع العملاء (نشطون، غير مسؤولين)',
      broadcastAudienceStore: 'المستخدمون الذين لديهم متجر يحتوي معرفه على',
      broadcastAudienceUsers: 'مستخدمون محددون (معرف المستخدم)',
      broadcastStoreIdHint: 'جزء من معرف متجر WB (كفلتر القائمة)',
      broadcastUserIdsHint: 'معرفات رقمية مفصولة بفواصل، مثال 12، 34، 56',
      broadcastUserIdsLabel: 'معرفات المستخدمين',
      broadcastMessageLabel: 'نص الرسالة',
      broadcastTranslatedLabel: 'ترجمة للمسؤولين (اختياري)',
      broadcastSend: 'إرسال لجميع الأهداف',
      broadcastSending: 'جاري الإرسال…',
      broadcastDone: 'تم: أُرسل {{sent}}، فشل {{failed}}.',
      broadcastError: 'فشل البث',
      broadcastSuperuserOnly: 'المستخدم الفائق فقط يمكنه البث.',
      broadcastConfirm: 'إرسال هذه الرسالة إلى كل مستخدم في الجمهور المحدد؟',
      broadcastNeedStoreId: 'أدخل جزءًا من معرف المتجر.',
      broadcastNeedUserIds: 'أدخل معرف مستخدم رقمي واحدًا على الأقل.',
    },
  },
};

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'ar', name: 'العربية', flag: '🇦🇪' },
];

export default translations;
